import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Directive, Output, HostListener, forwardRef, ViewEncapsulation, Input, ViewChild, NgModule, ViewChildren, Pipe, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i3 from 'angular2-ladda';
import { LaddaModule } from 'angular2-ladda';
import * as lpb from 'google-libphonenumber';
import * as moment from 'moment-timezone';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import * as i4 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as i2$1 from 'ngx-skeleton-loader';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { getName, registerLocale, getNames } from 'i18n-iso-countries';
import * as i1$2 from 'ng-multiselect-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import * as i2$2 from 'ngx-gauge';
import { NgxGaugeModule } from 'ngx-gauge';
import { fromEvent } from 'rxjs';

class NgVoxloudService {
    constructor() { }
}
NgVoxloudService.ɵfac = function NgVoxloudService_Factory(t) { return new (t || NgVoxloudService)(); };
NgVoxloudService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NgVoxloudService, factory: NgVoxloudService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgVoxloudService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgVoxloudComponent {
    constructor() { }
    ngOnInit() { }
}
NgVoxloudComponent.ɵfac = function NgVoxloudComponent_Factory(t) { return new (t || NgVoxloudComponent)(); };
NgVoxloudComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NgVoxloudComponent, selectors: [["vox-ng-voxloud"]], decls: 2, vars: 0, template: function NgVoxloudComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, " ng-voxloud works! ");
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgVoxloudComponent, [{
        type: Component,
        args: [{
                selector: 'vox-ng-voxloud',
                template: `
    <p>
      ng-voxloud works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

var PermissionState;
(function (PermissionState) {
    PermissionState["GRANTED"] = "granted";
    PermissionState["PROMPT"] = "prompt";
    PermissionState["DENIED"] = "denied";
})(PermissionState || (PermissionState = {}));
var GeoLocationErrors;
(function (GeoLocationErrors) {
    GeoLocationErrors["DENIED"] = "denied";
    GeoLocationErrors["UNAVAILABLE"] = "unavailable";
    GeoLocationErrors["TIMEOUT"] = "timeout";
})(GeoLocationErrors || (GeoLocationErrors = {}));

class ClickOutsideDirective$4 {
    constructor(el) {
        this.el = el;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside)
            this.clickOutside.emit();
    }
}
ClickOutsideDirective$4.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective$4)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ClickOutsideDirective$4.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClickOutsideDirective$4, selectors: [["", "clickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective$4, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

/// <reference types="@types/googlemaps" />
const _c0$g = ["address"];
const _c1$c = ["dropdown"];
const _c2$b = ["number"];
const _c3$9 = function (a0, a1) { return { "location-icon--black": a0, "location-icon--disabled": a1 }; };
function AddressSearchComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function AddressSearchComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onLocationClick(); });
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c3$9, ctx_r1.isGeolocationPermitted === ctx_r1.permissionStates.GRANTED, ctx_r1.isGeolocationPermitted === ctx_r1.permissionStates.DENIED))("disabled", ctx_r1.isGeolocationPermitted === ctx_r1.permissionStates.DENIED)("ladda", ctx_r1.geolocationLoading);
} }
const _c4$4 = function (a0) { return { "item-selected": a0 }; };
function AddressSearchComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function AddressSearchComponent_div_8_div_2_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const p_r8 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.handleClick(p_r8); });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$4, i_r9 === 0));
    i0.ɵɵattribute("data-address", i_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", p_r8.description.slice(0, p_r8.matched_substrings[0].offset), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(p_r8.description.slice(p_r8.matched_substrings[0].offset, p_r8.matched_substrings[0].offset + p_r8.matched_substrings[0].length));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", p_r8.description.slice(p_r8.matched_substrings[0].length), " ");
} }
function AddressSearchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11, 12);
    i0.ɵɵtemplate(2, AddressSearchComponent_div_8_div_2_Template, 5, 7, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.predictions);
} }
const _c5$4 = function (a0, a1, a2) { return { "vox-text-field__address-close": a0, "vox-text-field__address-open": a1, "vox-text-field-dense": a2 }; };
const _c6$4 = function (a0) { return { "vox-text-field-dense": a0 }; };
class AddressSearchComponent {
    constructor(appRef) {
        this.appRef = appRef;
        this.dense = false;
        this.allowGeolocation = false;
        this.geolocationError = new EventEmitter();
        this.autocompleteInput = '';
        this.dopen = false;
        this.addressFocused = false;
        this.predictions = [];
        this.missingCivic = false;
        this.googleSource = true;
        this.searched = false;
        this.DEFAULT_SEARCH_COUNTRY = 'IT';
        this.searchString = '';
        this.lastResult = null;
        // coordinates
        this.permissionStates = PermissionState;
        this.geolocationLoading = false;
        this.isGeolocationAvailable = !!navigator.geolocation;
        this.isGeolocationPermitted = PermissionState.DENIED;
        this.onChange = (_) => { };
        this.onTouched = (_) => { };
        // Callback to handle the predictions from the Autocomplete service. The appRef.tick is used to update the view
        this.handlePredictions = (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.predictions = predictions;
                if (predictions.length === 1 && !this.addressFocused) {
                    this.handleClick(predictions[0]);
                }
                else {
                    this.open();
                }
            }
            else
                this.predictions = [];
            if (!this.predictions.length)
                this.close();
            this.appRef.tick();
        };
    }
    // Control Value Accessor methods
    writeValue(obj) {
        if (![undefined, null].includes(obj)) {
            this.autocompleteInput = obj;
        }
        if (this.address) {
            this.handleInput({ target: { value: obj } });
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) { }
    ngOnInit() {
        this.checkGeolocationPermission();
    }
    ngAfterViewInit() {
        if (typeof google === 'undefined') {
            this.loadAPI = new Promise(resolve => {
                let node = document.createElement('script');
                node.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleKey}&libraries=places`;
                node.type = 'text/javascript';
                node.async = true;
                document.getElementsByTagName('head')[0].appendChild(node);
                node.onload = () => resolve(null);
            });
            this.loadAPI.then(() => {
                this.initGoogleApi();
            });
        }
        else {
            this.initGoogleApi();
        }
        if (!['', null].includes(this.address.nativeElement.value)) {
            this.initWithNotEmptyValue();
        }
    }
    initWithNotEmptyValue() {
        const query = this.address.nativeElement.value;
        if (this.loadAPI) {
            this.loadAPI.then(() => {
                this.handleInput({ target: this.address.nativeElement });
            });
        }
        else {
            this.handleInput({ target: this.address.nativeElement });
        }
    }
    initGoogleApi() {
        this.autocompleteService = new google.maps.places.AutocompleteService();
        this.sessionToken = new google.maps.places.AutocompleteSessionToken();
        this.geocoder = new google.maps.Geocoder();
    }
    // Dropdown Methods
    open() {
        if (this.predictions.length > 0)
            this.dopen = true;
    }
    close() {
        this.dopen = false;
    }
    openCInput() {
        if (!this.missingCivic) {
            this.missingCivic = true;
            this.civicNumber.nativeElement.setAttribute('tabindex', '0');
            setTimeout(() => this.civicNumber.nativeElement.focus(), 1050);
        }
        else
            this.missingCivic = true;
    }
    // Basic cleaning and closing of the civic number input
    cleanCInput() {
        if (this.civicNumber) {
            this.civicNumber.nativeElement.value = '';
            this.civicNumber.nativeElement.setAttribute('tabindex', '-1');
        }
        this.missingCivic = false;
    }
    // Used to set up some errors
    fireFakeValidation() {
        this.addressFocused = false;
        if (this.predictions.length === 1) {
            this.handleClick(this.predictions[0]);
        }
        if (!this.place) {
            this.searched = true;
            this.lastResult = null;
            this.onChange(null);
        }
    }
    // Calls Autocomplete to generate the predictions
    generatePrediction(str) {
        const fn = () => {
            this.autocompleteService.getPlacePredictions({
                input: str,
                sessionToken: this.sessionToken,
                types: ['address'],
                componentRestrictions: { country: this.country || this.DEFAULT_SEARCH_COUNTRY }
            }, this.handlePredictions);
        };
        if (this.autocompleteService) {
            fn();
        }
        else {
            this.loadAPI.then(fn);
        }
    }
    // Handle the address input event
    handleInput(e) {
        if (e.target.value.length !== this.searchString.length) {
            this.lastResult = null;
            this.onChange([]);
        }
        if (e.target.value.length <= 0) {
            this.predictions = [];
            this.place = null;
            this.close();
            this.cleanCInput();
            this.lastResult = null;
            this.onChange([]);
            return;
        }
        this.searchString = e.target.value;
        this.cleanCInput();
        this.generatePrediction(e.target.value);
    }
    // Handle the Civic Number input event
    handleCInput(e) {
        this.getDetailsByAddress(`${e.target.value} ${this.autocompleteInput}`, this.country);
    }
    // Handle the dropdown event
    handlePaste(e) {
        let clipboardData = e.clipboardData;
        let input = clipboardData.getData('text');
        if (input.length <= 0) {
            this.predictions = [];
            this.close();
            this.cleanCInput();
            return;
        }
        this.generatePrediction(input);
        this.open();
    }
    // Handle the click in the dropdown
    handleClick(e) {
        this.selected = e;
        this.autocompleteInput = e.description;
        this.close();
        this.cleanCInput();
        this.getDetailsById(e.place_id, this.country);
    }
    handleKeyDown(e) {
        switch (e.key) {
            // If enter is pressed and the dropdown is closed it lauches a faked validation to force error.
            // If the dropdown is open, then the selected field will be processed
            case 'Enter':
                e.preventDefault();
                e.stopPropagation();
                if (!this.dopen) {
                    this.fireFakeValidation();
                    break;
                }
                this.searched = true;
                var children = this.dropdown.nativeElement.children;
                Object.keys(children).some(key => {
                    if (children[key].classList.contains('item-selected')) {
                        this.selected = this.predictions[parseInt(children[key].getAttribute('data-address'))];
                        this.autocompleteInput = this.selected.description;
                        this.close();
                        this.getDetailsById(this.selected.place_id, this.country);
                        return true;
                    }
                });
                break;
            // If the dropdown is closed, it generetates another prediction based on the value of the input.
            // If it is open it will navigate
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                if (!this.dopen) {
                    this.cleanCInput();
                    this.generatePrediction(this.address.nativeElement.value);
                    break;
                }
                var children = this.dropdown.nativeElement.children;
                Object.keys(children).some(key => {
                    if (children[key].classList.contains('item-selected')) {
                        const parsedKey = parseInt(key);
                        if (parsedKey < this.predictions.length - 1) {
                            children[key].classList.remove('item-selected');
                            children[(parsedKey + 1).toString()].classList.add('item-selected');
                            return true;
                        }
                    }
                });
                break;
            // Same as ArrowDown but if the dropdown is closed just skip
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                if (!this.dopen) {
                    break;
                }
                var children = this.dropdown.nativeElement.children;
                Object.keys(children).some(key => {
                    if (children[key].classList.contains('item-selected')) {
                        const parsedKey = parseInt(key);
                        if (parsedKey > 0) {
                            children[key].classList.remove('item-selected');
                            children[(parsedKey - 1).toString()].classList.add('item-selected');
                            return true;
                        }
                    }
                });
                break;
            default:
                break;
        }
    }
    handlePlace(place, pushToInput = false) {
        this.place = place;
        // used for readability
        const level2 = this.getDataByType(place.address_components, 'administrative_area_level_2');
        const tmpOutput = {
            city: (this.getDataByType(place.address_components, 'locality') ||
                this.getDataByType(place.address_components, 'postal_town') ||
                this.getDataByType(place.address_components, 'sublocality') ||
                this.getDataByType(place.address_components, 'administrative_area_level_3')),
            countryCode: this.getDataByType(place.address_components, 'country'),
            province: level2 ? level2 : this.getDataByType(place.address_components, 'administrative_area_level_1'),
            streetName: this.getDataByType(place.address_components, 'route'),
            streetNumber: this.getDataByType(place.address_components, 'street_number'),
            zipCode: this.getPostalCode(place.address_components)
        };
        let output = {
            city: tmpOutput.city && tmpOutput.city.long_name,
            countryCode: tmpOutput.countryCode && tmpOutput.countryCode.short_name,
            province: tmpOutput.province && tmpOutput.province.short_name,
            streetName: tmpOutput.streetName && tmpOutput.streetName.long_name,
            streetNumber: tmpOutput.streetNumber && tmpOutput.streetNumber.long_name,
            zipCode: tmpOutput.zipCode
        };
        this.lastResult = output;
        this.onChange([
            ...this.place.address_components,
            { long_name: place.formatted_address, types: ['formatted_address'] },
            { long_name: output, types: ['structured_address_data'] }
        ]);
        if (pushToInput) {
            this.address.nativeElement.value = place.formatted_address;
            this.searchString = place.formatted_address;
        }
        // Manually trigger a detection check of the whole app to update the form validity from a callback
        this.appRef.tick();
    }
    getPostalCode(data) {
        const postal_code = data.find(e => e.types.includes('postal_code'));
        const postal_code_prefix = this.getDataByType(data, 'postal_code_prefix');
        // if postal code prefix present the result is considered ambiguous
        if (postal_code_prefix) {
            return null;
        }
        else {
            return postal_code ? postal_code.long_name : null;
        }
    }
    getDataByType(data, type) {
        return data.find(e => e.types.includes(type));
    }
    getDetailsById(place_id, region) {
        this.geocoder.geocode({ placeId: place_id, region: region }, (result, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                this.autocompleteInput = result[0].formatted_address;
                // fix for a bug in which after backspace, autocompleteInput is no more
                // bind to value until a character is added
                this.address.nativeElement.value = result[0].formatted_address;
                this.googleSource = true;
                this.handlePlace(result[0]);
            }
        });
    }
    getDetailsByAddress(address, region) {
        this.geocoder.geocode({ address: address, region: region }, (result, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                this.googleSource = false;
                this.handlePlace(result[0]);
            }
        });
    }
    // Internal validation
    validate(control) {
        let errors = null;
        if (this.place && this.place.address_components && this.lastResult) {
            if (!this.lastResult.streetNumber) {
                errors = Object.assign(Object.assign({}, errors), { street_number: 'Street Number Missing' });
                this.openCInput();
            }
            if (!this.lastResult.zipCode) {
                errors = Object.assign(Object.assign({}, errors), { city: 'Zip missing' });
            }
            if (!this.lastResult.city) {
                errors = Object.assign(Object.assign({}, errors), { city: 'City missing' });
            }
            if (!this.lastResult.streetName) {
                errors = Object.assign(Object.assign({}, errors), { route: 'Route Missing' });
            }
            if (!this.lastResult.countryCode) {
                errors = Object.assign(Object.assign({}, errors), { country: 'Country Missing' });
            }
        }
        else {
            errors = this.searched
                ? { select_from_list: 'Select from list' }
                : { place_missing: 'Place Missing' };
            this.searched = false;
            this.cleanCInput();
        }
        if (!this.missingCivic)
            this.cleanCInput();
        return errors;
    }
    // geolocation coords
    checkGeolocationPermission() {
        if (!this.isGeolocationAvailable) {
            this.isGeolocationPermitted = PermissionState.DENIED;
            return;
        }
        // if navigator.permissions exists then we can query to know if we have permission
        // otherwise the only way is to try and get the location so the state is set to prompt
        // Safari doesn't have this api so it will always be set to prompt.
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then((permission) => {
                switch (permission.state) {
                    case 'granted':
                        this.isGeolocationPermitted = PermissionState.GRANTED;
                        break;
                    case 'prompt':
                        this.isGeolocationPermitted = PermissionState.PROMPT;
                        break;
                    case 'denied':
                    default:
                        this.isGeolocationPermitted = PermissionState.DENIED;
                        this.geolocationError.emit(GeoLocationErrors.DENIED);
                }
            });
            return;
        }
        this.isGeolocationPermitted = PermissionState.PROMPT;
    }
    onLocationClick() {
        this.geolocationLoading = true;
        if (this.isGeolocationPermitted !== PermissionState.DENIED) {
            navigator.geolocation.getCurrentPosition((pos) => {
                this.isGeolocationPermitted = PermissionState.GRANTED;
                this.geocoder.geocode({ location: { lat: pos.coords.latitude, lng: pos.coords.longitude } }, (result, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        this.googleSource = false;
                        this.geolocationLoading = false;
                        this.cleanCInput();
                        if (result.length > 0)
                            this.handlePlace(result[0], true);
                    }
                });
            }, (error) => {
                this.geolocationLoading = false;
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.isGeolocationPermitted = PermissionState.DENIED;
                        this.geolocationError.emit(GeoLocationErrors.DENIED);
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.geolocationError.emit(GeoLocationErrors.UNAVAILABLE);
                        break;
                    case error.TIMEOUT:
                        this.geolocationError.emit(GeoLocationErrors.TIMEOUT);
                        break;
                }
            });
        }
    }
}
AddressSearchComponent.ɵfac = function AddressSearchComponent_Factory(t) { return new (t || AddressSearchComponent)(i0.ɵɵdirectiveInject(i0.ApplicationRef)); };
AddressSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddressSearchComponent, selectors: [["vox-address-search"]], viewQuery: function AddressSearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$g, 5);
        i0.ɵɵviewQuery(_c1$c, 5);
        i0.ɵɵviewQuery(_c2$b, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.address = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.civicNumber = _t.first);
    } }, inputs: { placeholder: "placeholder", dense: "dense", googleKey: "googleKey", country: "country", allowGeolocation: "allowGeolocation" }, outputs: { geolocationError: "geolocationError" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AddressSearchComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => AddressSearchComponent),
                multi: true
            }
        ])], decls: 9, vars: 12, consts: [[3, "clickOutside"], [1, "address-search-input-container"], [1, "vox-text-field", "vox-text-field__address", 3, "ngClass"], ["type", "text", 1, "input-field", 3, "value", "placeholder", "click", "focus", "blur", "paste", "input", "keydown"], ["address", ""], ["type", "button", "class", "location-icon address-search-ladda-button", "data-style", "slide-left", "data-spinner-size", "30", "data-spinner-color", "#000", 3, "ngClass", "disabled", "ladda", "click", 4, "ngIf"], ["type", "text", "placeholder", "N\u00B0", "tabindex", "-1", 1, "vox-text-field", "vox-text-field__civic", 3, "ngClass", "input", "focus"], ["number", ""], ["class", "address-search-dropdown-container", 4, "ngIf"], ["type", "button", "data-style", "slide-left", "data-spinner-size", "30", "data-spinner-color", "#000", 1, "location-icon", "address-search-ladda-button", 3, "ngClass", "disabled", "ladda", "click"], [1, "icon-small-location"], [1, "address-search-dropdown-container"], ["dropdown", ""], ["class", "dropdown-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "ngClass", "click"]], template: function AddressSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("clickOutside", function AddressSearchComponent_Template_div_clickOutside_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "input", 3, 4);
        i0.ɵɵlistener("click", function AddressSearchComponent_Template_input_click_3_listener() { return ctx.open(); })("focus", function AddressSearchComponent_Template_input_focus_3_listener() { return ctx.addressFocused = true; })("blur", function AddressSearchComponent_Template_input_blur_3_listener() { return ctx.fireFakeValidation(); })("paste", function AddressSearchComponent_Template_input_paste_3_listener($event) { return ctx.handlePaste($event); })("input", function AddressSearchComponent_Template_input_input_3_listener($event) { return ctx.handleInput($event); })("keydown", function AddressSearchComponent_Template_input_keydown_3_listener($event) { return ctx.handleKeyDown($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, AddressSearchComponent_button_5_Template, 2, 6, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "input", 6, 7);
        i0.ɵɵlistener("input", function AddressSearchComponent_Template_input_input_6_listener($event) { return ctx.handleCInput($event); })("focus", function AddressSearchComponent_Template_input_focus_6_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, AddressSearchComponent_div_8_Template, 3, 1, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c5$4, !ctx.missingCivic, ctx.missingCivic, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.autocompleteInput)("placeholder", ctx.placeholder);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isGeolocationAvailable && ctx.allowGeolocation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$4, ctx.dense));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dopen);
    } }, directives: [ClickOutsideDirective$4, i1.NgClass, i1.NgIf, i3.LaddaDirective, i1.NgForOf], styles: ["body{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}::-webkit-scrollbar{width:.5em;height:.5em}::-webkit-scrollbar-thumb{background-color:#868990}::-webkit-scrollbar-track{background-color:#b5bac2}::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}.address-search-input-container{display:flex;flex-direction:row;flex-wrap:nowrap;overflow:hidden}.address-search-input-container .vox-text-field__address{display:flex;align-items:center;padding-right:16px}.address-search-input-container .vox-text-field__address-close{min-width:100%;max-width:100%;transition:min-width 1s}.address-search-input-container .vox-text-field__address-open{min-width:80%;max-width:80%;transition:min-width 1s}.address-search-input-container .vox-text-field__civic{min-width:20%;max-width:20%;text-align:center;padding-left:5px;padding-right:5px}.address-search-input-container .input-field{width:100%;height:100%;border:none;outline:none}.address-search-input-container .location-icon{top:auto;bottom:auto;font-size:30px;color:#868990;background-color:transparent;border:none;outline:none}.address-search-input-container .location-icon:hover{background-color:transparent}.address-search-input-container .location-icon--black{color:#000}.address-search-input-container .location-icon--disabled{color:#e5e9f0}.address-search-input-container .location-icon.address-search-ladda-button .ladda-label{display:flex;align-items:center}.address-search-input-container .location-icon.address-search-ladda-button.ladda-button{background-color:transparent;border:none;outline:none;padding:12px;margin-right:-16px}.address-search-input-container .vox-text-field-dense{height:40px;padding-top:6px;padding-bottom:6px}.address-search-input-container .vox-text-field-dense .location-icon.address-search-ladda-button.ladda-button{padding-top:4px;padding-bottom:4px}.address-search-dropdown-container{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif;font-size:20px;font-weight:300!important;border-radius:3px;border:2px rgba(0,0,0,.2) solid;margin-top:1px;overflow-x:hidden}.address-search-dropdown-container:after{content:\"\";display:block;background-size:144px;height:20px;margin-left:16px;margin-right:5px;background:url(data:image/png;base64,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) 100% 0 no-repeat}.address-search-dropdown-container .dropdown-item{cursor:pointer;font-weight:300!important;padding:.25rem 1rem}.address-search-dropdown-container .dropdown-item:hover{background-color:#e5e9f0!important}.address-search-dropdown-container .dropdown-item:active{color:currentColor;text-decoration:none;background-color:transparent}.address-search-dropdown-container .dropdown-item:not(:last-child){border-bottom:1px #e5e9f0 solid}.address-search-dropdown-container .dropdown-item.item-selected{background-color:#e5e9f0!important}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressSearchComponent, [{
        type: Component,
        args: [{
                selector: 'vox-address-search',
                templateUrl: './address-search.component.html',
                styleUrls: ['./address-search.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => AddressSearchComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => AddressSearchComponent),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: i0.ApplicationRef }]; }, { placeholder: [{
            type: Input
        }], dense: [{
            type: Input
        }], googleKey: [{
            type: Input
        }], country: [{
            type: Input
        }], allowGeolocation: [{
            type: Input
        }], geolocationError: [{
            type: Output
        }], address: [{
            type: ViewChild,
            args: ['address']
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], civicNumber: [{
            type: ViewChild,
            args: ['number']
        }] }); })();

class VoxAddressSearchModule {
}
VoxAddressSearchModule.ɵfac = function VoxAddressSearchModule_Factory(t) { return new (t || VoxAddressSearchModule)(); };
VoxAddressSearchModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxAddressSearchModule });
VoxAddressSearchModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, LaddaModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxAddressSearchModule, [{
        type: NgModule,
        args: [{
                declarations: [AddressSearchComponent, ClickOutsideDirective$4],
                imports: [CommonModule, LaddaModule],
                exports: [AddressSearchComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxAddressSearchModule, { declarations: [AddressSearchComponent, ClickOutsideDirective$4], imports: [CommonModule, LaddaModule], exports: [AddressSearchComponent] }); })();

class ClickOutsideDirective$3 {
    constructor(el) {
        this.el = el;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside)
            this.clickOutside.emit();
    }
}
ClickOutsideDirective$3.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective$3)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ClickOutsideDirective$3.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClickOutsideDirective$3, selectors: [["", "clickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective$3, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

function LanguagePickerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function LanguagePickerComponent_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const lang_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.select(lang_r1.locale); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", lang_r1.name, " ");
} }
const _c0$f = function (a0, a1) { return { "dropdown-menu-right": a0, show: a1 }; };
class LanguagePickerComponent {
    //
    constructor() {
        this.languagesList = [];
        this.side = "left";
        this.classes = "";
        this.zindex = 999;
        this.selectedEmitter = new EventEmitter();
        this._currentLanguage = "N.A.";
        this.shownLanguage = "N.A.";
        // Dropdown states
        this.dpOpen = false;
    }
    get currentLanguage() {
        return this._currentLanguage;
    }
    set currentLanguage(v) {
        this.languagesList.forEach(el => {
            if (el.locale == v) {
                this._currentLanguage = v;
                this.formatter();
                return;
            }
        });
    }
    select(lang) {
        if (lang != this._currentLanguage) {
            this.currentLanguage = lang;
            this.formatter();
            this.selectedEmitter.emit(this._currentLanguage);
        }
        this.close();
    }
    formatter() {
        this.shownLanguage = this._currentLanguage.split("-")[0];
        this.shownLanguage = this.shownLanguage.split("_")[0];
    }
    ngOnInit() {
        this.languagesList.forEach(el => {
            if (el.locale == this.defaultLanguage) {
                this._currentLanguage = this.defaultLanguage;
                this.formatter();
                return;
            }
        });
    }
    // Dropdown methods
    open() {
        this.dpOpen = true;
    }
    toggle() {
        this.dpOpen = !this.dpOpen;
    }
    close() {
        this.dpOpen = false;
    }
}
LanguagePickerComponent.ɵfac = function LanguagePickerComponent_Factory(t) { return new (t || LanguagePickerComponent)(); };
LanguagePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LanguagePickerComponent, selectors: [["vox-language-picker"]], inputs: { defaultLanguage: ["language", "defaultLanguage"], languagesList: ["availableLanguages", "languagesList"], side: "side", classes: "classes", zindex: "zindex", currentLanguage: "currentLanguage" }, outputs: { selectedEmitter: "selected" }, decls: 7, vars: 11, consts: [[1, "vox-dropdown", "dropdown", 3, "ngClass", "clickOutside"], ["type", "button", 1, "vox-language-picker__btn", "icon-small-globe", "dropdown-toggle", 3, "click"], [1, "dropdown-menu", 3, "ngClass"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]], template: function LanguagePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("clickOutside", function LanguagePickerComponent_Template_div_clickOutside_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵlistener("click", function LanguagePickerComponent_Template_button_click_1_listener() { return ctx.toggle(); });
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "uppercase");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵtemplate(6, LanguagePickerComponent_div_6_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.classes);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, ctx.shownLanguage));
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("z-index", ctx.zindex);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0$f, ctx.side === "right", ctx.dpOpen));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.languagesList);
    } }, directives: [i1.NgClass, ClickOutsideDirective$3, i1.NgForOf], pipes: [i1.UpperCasePipe], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.vox-language-picker__btn[_ngcontent-%COMP%]{background-color:transparent;border:none;outline:none!important;color:currentColor}.vox-language-picker__btn[_ngcontent-%COMP%]:hover{background-color:#00000008;cursor:pointer}.vox-dropdown[_ngcontent-%COMP%]{height:100%}.vox-dropdown-item[_ngcontent-%COMP%]{padding:.5rem .3rem}.vox-dropdown-item[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e9f0}.vox-dropdown-item[_ngcontent-%COMP%]:hover{cursor:pointer}.vox-dropdown-menu[_ngcontent-%COMP%]{padding:0;z-index:999;background-color:#fff;overflow:hidden;border:1px solid #b5bac2;border-radius:2px}.text-black[_ngcontent-%COMP%]{color:#000}.text-white[_ngcontent-%COMP%]{color:#fff}@media only screen and (max-width: 992px){.vox-language-picker__btn[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:none}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LanguagePickerComponent, [{
        type: Component,
        args: [{
                selector: "vox-language-picker",
                templateUrl: "./language-picker.component.html",
                styleUrls: ["./language-picker.component.scss"]
            }]
    }], function () { return []; }, { defaultLanguage: [{
            type: Input,
            args: ["language"]
        }], languagesList: [{
            type: Input,
            args: ["availableLanguages"]
        }], side: [{
            type: Input,
            args: ["side"]
        }], classes: [{
            type: Input
        }], zindex: [{
            type: Input
        }], selectedEmitter: [{
            type: Output,
            args: ["selected"]
        }], currentLanguage: [{
            type: Input
        }] }); })();

class VoxLanguagePickerModule {
}
VoxLanguagePickerModule.ɵfac = function VoxLanguagePickerModule_Factory(t) { return new (t || VoxLanguagePickerModule)(); };
VoxLanguagePickerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxLanguagePickerModule });
VoxLanguagePickerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxLanguagePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [LanguagePickerComponent, ClickOutsideDirective$3],
                imports: [CommonModule],
                exports: [LanguagePickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxLanguagePickerModule, { declarations: [LanguagePickerComponent, ClickOutsideDirective$3], imports: [CommonModule], exports: [LanguagePickerComponent] }); })();

class StatesData {
    constructor() {
        this.allCountries = [
            {
                name: 'United States',
                iso2: 'us',
                phoneCode: '1'
            },
            {
                name: 'United Kingdom',
                iso2: 'gb',
                phoneCode: '44'
            },
            {
                name: 'Afghanistan (‫افغانستان‬‎)',
                iso2: 'af',
                phoneCode: '93'
            },
            {
                name: 'Albania (Shqipëri)',
                iso2: 'al',
                phoneCode: '355'
            },
            {
                name: 'Algeria (‫الجزائر‬‎)',
                iso2: 'dz',
                phoneCode: '213'
            },
            {
                name: 'American Samoa',
                iso2: 'as',
                phoneCode: '1684'
            },
            {
                name: 'Andorra',
                iso2: 'ad',
                phoneCode: '376'
            },
            {
                name: 'Angola',
                iso2: 'ao',
                phoneCode: '244'
            },
            {
                name: 'Anguilla',
                iso2: 'ai',
                phoneCode: '1264'
            },
            {
                name: 'Antigua and Barbuda',
                iso2: 'ag',
                phoneCode: '1268'
            },
            {
                name: 'Argentina',
                iso2: 'ar',
                phoneCode: '54'
            },
            {
                name: 'Armenia (Հայաստան)',
                iso2: 'am',
                phoneCode: '374'
            },
            {
                name: 'Aruba',
                iso2: 'aw',
                phoneCode: '297'
            },
            {
                name: 'Australia',
                iso2: 'au',
                phoneCode: '61'
            },
            {
                name: 'Austria (Österreich)',
                iso2: 'at',
                phoneCode: '43'
            },
            {
                name: 'Azerbaijan (Azərbaycan)',
                iso2: 'az',
                phoneCode: '994'
            },
            {
                name: 'Bahamas',
                iso2: 'bs',
                phoneCode: '1242'
            },
            {
                name: 'Bahrain (‫البحرين‬‎)',
                iso2: 'bh',
                phoneCode: '973'
            },
            {
                name: 'Bangladesh (বাংলাদেশ)',
                iso2: 'bd',
                phoneCode: '880'
            },
            {
                name: 'Barbados',
                iso2: 'bb',
                phoneCode: '1246'
            },
            {
                name: 'Belarus (Беларусь)',
                iso2: 'by',
                phoneCode: '375'
            },
            {
                name: 'Belgium (België)',
                iso2: 'be',
                phoneCode: '32'
            },
            {
                name: 'Belize',
                iso2: 'bz',
                phoneCode: '501'
            },
            {
                name: 'Benin (Bénin)',
                iso2: 'bj',
                phoneCode: '229'
            },
            {
                name: 'Bermuda',
                iso2: 'bm',
                phoneCode: '1441'
            },
            {
                name: 'Bhutan (འབྲུག)',
                iso2: 'bt',
                phoneCode: '975'
            },
            {
                name: 'Bolivia',
                iso2: 'bo',
                phoneCode: '591'
            },
            {
                name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
                iso2: 'ba',
                phoneCode: '387'
            },
            {
                name: 'Botswana',
                iso2: 'bw',
                phoneCode: '267'
            },
            {
                name: 'Brazil (Brasil)',
                iso2: 'br',
                phoneCode: '55'
            },
            {
                name: 'British Indian Ocean Territory',
                iso2: 'io',
                phoneCode: '246'
            },
            {
                name: 'British Virgin Islands',
                iso2: 'vg',
                phoneCode: '1284'
            },
            {
                name: 'Brunei',
                iso2: 'bn',
                phoneCode: '673'
            },
            {
                name: 'Bulgaria (България)',
                iso2: 'bg',
                phoneCode: '359'
            },
            {
                name: 'Burkina Faso',
                iso2: 'bf',
                phoneCode: '226'
            },
            {
                name: 'Burundi (Uburundi)',
                iso2: 'bi',
                phoneCode: '257'
            },
            {
                name: 'Cambodia (កម្ពុជា)',
                iso2: 'kh',
                phoneCode: '855'
            },
            {
                name: 'Cameroon (Cameroun)',
                iso2: 'cm',
                phoneCode: '237'
            },
            {
                name: 'Canada',
                iso2: 'ca',
                phoneCode: '1',
                areaCode: [
                    '204',
                    '226',
                    '236',
                    '249',
                    '250',
                    '289',
                    '306',
                    '343',
                    '365',
                    '387',
                    '403',
                    '416',
                    '418',
                    '431',
                    '437',
                    '438',
                    '450',
                    '506',
                    '514',
                    '519',
                    '548',
                    '579',
                    '581',
                    '587',
                    '604',
                    '613',
                    '639',
                    '647',
                    '672',
                    '705',
                    '709',
                    '742',
                    '778',
                    '780',
                    '782',
                    '807',
                    '819',
                    '825',
                    '867',
                    '873',
                    '902',
                    '905'
                ]
            },
            {
                name: 'Cape Verde (Kabu Verdi)',
                iso2: 'cv',
                phoneCode: '238'
            },
            {
                name: 'Caribbean Netherlands',
                iso2: 'bq',
                phoneCode: '599'
            },
            {
                name: 'Cayman Islands',
                iso2: 'ky',
                phoneCode: '1345'
            },
            {
                name: 'Central African Republic (République centrafricaine)',
                iso2: 'cf',
                phoneCode: '236'
            },
            {
                name: 'Chad (Tchad)',
                iso2: 'td',
                phoneCode: '235'
            },
            {
                name: 'Chile',
                iso2: 'cl',
                phoneCode: '56'
            },
            {
                name: 'China (中国)',
                iso2: 'cn',
                phoneCode: '86'
            },
            {
                name: 'Christmas Island',
                iso2: 'cx',
                phoneCode: '61'
            },
            {
                name: 'Cocos (Keeling) Islands',
                iso2: 'cc',
                phoneCode: '61'
            },
            {
                name: 'Colombia',
                iso2: 'co',
                phoneCode: '57'
            },
            {
                name: 'Comoros (‫جزر القمر‬‎)',
                iso2: 'km',
                phoneCode: '269'
            },
            {
                name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
                iso2: 'cd',
                phoneCode: '243'
            },
            {
                name: 'Congo (Republic) (Congo-Brazzaville)',
                iso2: 'cg',
                phoneCode: '242'
            },
            {
                name: 'Cook Islands',
                iso2: 'ck',
                phoneCode: '682'
            },
            {
                name: 'Costa Rica',
                iso2: 'cr',
                phoneCode: '506'
            },
            {
                name: 'Côte d’Ivoire',
                iso2: 'ci',
                phoneCode: '225'
            },
            {
                name: 'Croatia (Hrvatska)',
                iso2: 'hr',
                phoneCode: '385'
            },
            {
                name: 'Cuba',
                iso2: 'cu',
                phoneCode: '53'
            },
            {
                name: 'Curaçao',
                iso2: 'cw',
                phoneCode: '599'
            },
            {
                name: 'Cyprus (Κύπρος)',
                iso2: 'cy',
                phoneCode: '357'
            },
            {
                name: 'Czech Republic (Česká republika)',
                iso2: 'cz',
                phoneCode: '420'
            },
            {
                name: 'Denmark (Danmark)',
                iso2: 'dk',
                phoneCode: '45'
            },
            {
                name: 'Djibouti',
                iso2: 'dj',
                phoneCode: '253'
            },
            {
                name: 'Dominica',
                iso2: 'dm',
                phoneCode: '1767'
            },
            {
                name: 'Dominican Republic (República Dominicana)',
                iso2: 'do',
                phoneCode: '1',
                areaCode: ['809', '829', '849']
            },
            {
                name: 'Ecuador',
                iso2: 'ec',
                phoneCode: '593'
            },
            {
                name: 'Egypt (‫مصر‬‎)',
                iso2: 'eg',
                phoneCode: '20'
            },
            {
                name: 'El Salvador',
                iso2: 'sv',
                phoneCode: '503'
            },
            {
                name: 'Equatorial Guinea (Guinea Ecuatorial)',
                iso2: 'gq',
                phoneCode: '240'
            },
            {
                name: 'Eritrea',
                iso2: 'er',
                phoneCode: '291'
            },
            {
                name: 'Estonia (Eesti)',
                iso2: 'ee',
                phoneCode: '372'
            },
            {
                name: 'Ethiopia',
                iso2: 'et',
                phoneCode: '251'
            },
            {
                name: 'Falkland Islands (Islas Malvinas)',
                iso2: 'fk',
                phoneCode: '500'
            },
            {
                name: 'Faroe Islands (Føroyar)',
                iso2: 'fo',
                phoneCode: '298'
            },
            {
                name: 'Fiji',
                iso2: 'fj',
                phoneCode: '679'
            },
            {
                name: 'Finland (Suomi)',
                iso2: 'fi',
                phoneCode: '358'
            },
            {
                name: 'France',
                iso2: 'fr',
                phoneCode: '33'
            },
            {
                name: 'French Guiana (Guyane française)',
                iso2: 'gf',
                phoneCode: '594'
            },
            {
                name: 'French Polynesia (Polynésie française)',
                iso2: 'pf',
                phoneCode: '689'
            },
            {
                name: 'Gabon',
                iso2: 'ga',
                phoneCode: '241'
            },
            {
                name: 'Gambia',
                iso2: 'gm',
                phoneCode: '220'
            },
            {
                name: 'Georgia (საქართველო)',
                iso2: 'ge',
                phoneCode: '995'
            },
            {
                name: 'Germany (Deutschland)',
                iso2: 'de',
                phoneCode: '49'
            },
            {
                name: 'Ghana (Gaana)',
                iso2: 'gh',
                phoneCode: '233'
            },
            {
                name: 'Gibraltar',
                iso2: 'gi',
                phoneCode: '350'
            },
            {
                name: 'Greece (Ελλάδα)',
                iso2: 'gr',
                phoneCode: '30'
            },
            {
                name: 'Greenland (Kalaallit Nunaat)',
                iso2: 'gl',
                phoneCode: '299'
            },
            {
                name: 'Grenada',
                iso2: 'gd',
                phoneCode: '1473'
            },
            {
                name: 'Guadeloupe',
                iso2: 'gp',
                phoneCode: '590'
            },
            {
                name: 'Guam',
                iso2: 'gu',
                phoneCode: '1671'
            },
            {
                name: 'Guatemala',
                iso2: 'gt',
                phoneCode: '502'
            },
            {
                name: 'Guernsey',
                iso2: 'gg',
                phoneCode: '44'
            },
            {
                name: 'Guinea (Guinée)',
                iso2: 'gn',
                phoneCode: '224'
            },
            {
                name: 'Guinea-Bissau (Guiné Bissau)',
                iso2: 'gw',
                phoneCode: '245'
            },
            {
                name: 'Guyana',
                iso2: 'gy',
                phoneCode: '592'
            },
            {
                name: 'Haiti',
                iso2: 'ht',
                phoneCode: '509'
            },
            {
                name: 'Honduras',
                iso2: 'hn',
                phoneCode: '504'
            },
            {
                name: 'Hong Kong (香港)',
                iso2: 'hk',
                phoneCode: '852'
            },
            {
                name: 'Hungary (Magyarország)',
                iso2: 'hu',
                phoneCode: '36'
            },
            {
                name: 'Iceland (Ísland)',
                iso2: 'is',
                phoneCode: '354'
            },
            {
                name: 'India (भारत)',
                iso2: 'in',
                phoneCode: '91'
            },
            {
                name: 'Indonesia',
                iso2: 'id',
                phoneCode: '62'
            },
            {
                name: 'Iran (‫ایران‬‎)',
                iso2: 'ir',
                phoneCode: '98'
            },
            {
                name: 'Iraq (‫العراق‬‎)',
                iso2: 'iq',
                phoneCode: '964'
            },
            {
                name: 'Ireland',
                iso2: 'ie',
                phoneCode: '353'
            },
            {
                name: 'Isle of Man',
                iso2: 'im',
                phoneCode: '44'
            },
            {
                name: 'Israel (‫ישראל‬‎)',
                iso2: 'il',
                phoneCode: '972'
            },
            {
                name: 'Italy (Italia)',
                iso2: 'it',
                phoneCode: '39'
            },
            {
                name: 'Jamaica',
                iso2: 'jm',
                phoneCode: '1876'
            },
            {
                name: 'Japan (日本)',
                iso2: 'jp',
                phoneCode: '81'
            },
            {
                name: 'Jersey',
                iso2: 'je',
                phoneCode: '44'
            },
            {
                name: 'Jordan (‫الأردن‬‎)',
                iso2: 'jo',
                phoneCode: '962'
            },
            {
                name: 'Kazakhstan (Казахстан)',
                iso2: 'kz',
                phoneCode: '7'
            },
            {
                name: 'Kenya',
                iso2: 'ke',
                phoneCode: '254'
            },
            {
                name: 'Kiribati',
                iso2: 'ki',
                phoneCode: '686'
            },
            {
                name: 'Kosovo',
                iso2: 'xk',
                phoneCode: '383'
            },
            {
                name: 'Kuwait (‫الكويت‬‎)',
                iso2: 'kw',
                phoneCode: '965'
            },
            {
                name: 'Kyrgyzstan (Кыргызстан)',
                iso2: 'kg',
                phoneCode: '996'
            },
            {
                name: 'Laos (ລາວ)',
                iso2: 'la',
                phoneCode: '856'
            },
            {
                name: 'Latvia (Latvija)',
                iso2: 'lv',
                phoneCode: '371'
            },
            {
                name: 'Lebanon (‫لبنان‬‎)',
                iso2: 'lb',
                phoneCode: '961'
            },
            {
                name: 'Lesotho',
                iso2: 'ls',
                phoneCode: '266'
            },
            {
                name: 'Liberia',
                iso2: 'lr',
                phoneCode: '231'
            },
            {
                name: 'Libya (‫ليبيا‬‎)',
                iso2: 'ly',
                phoneCode: '218'
            },
            {
                name: 'Liechtenstein',
                iso2: 'li',
                phoneCode: '423'
            },
            {
                name: 'Lithuania (Lietuva)',
                iso2: 'lt',
                phoneCode: '370'
            },
            {
                name: 'Luxembourg',
                iso2: 'lu',
                phoneCode: '352'
            },
            {
                name: 'Macau (澳門)',
                iso2: 'mo',
                phoneCode: '853'
            },
            {
                name: 'Macedonia (FYROM) (Македонија)',
                iso2: 'mk',
                phoneCode: '389'
            },
            {
                name: 'Madagascar (Madagasikara)',
                iso2: 'mg',
                phoneCode: '261'
            },
            {
                name: 'Malawi',
                iso2: 'mw',
                phoneCode: '265'
            },
            {
                name: 'Malaysia',
                iso2: 'my',
                phoneCode: '60'
            },
            {
                name: 'Maldives',
                iso2: 'mv',
                phoneCode: '960'
            },
            {
                name: 'Mali',
                iso2: 'ml',
                phoneCode: '223'
            },
            {
                name: 'Malta',
                iso2: 'mt',
                phoneCode: '356'
            },
            {
                name: 'Marshall Islands',
                iso2: 'mh',
                phoneCode: '692'
            },
            {
                name: 'Martinique',
                iso2: 'mq',
                phoneCode: '596'
            },
            {
                name: 'Mauritania (‫موريتانيا‬‎)',
                iso2: 'mr',
                phoneCode: '222'
            },
            {
                name: 'Mauritius (Moris)',
                iso2: 'mu',
                phoneCode: '230'
            },
            {
                name: 'Mayotte',
                iso2: 'yt',
                phoneCode: '262'
            },
            {
                name: 'Mexico (México)',
                iso2: 'mx',
                phoneCode: '52'
            },
            {
                name: 'Micronesia',
                iso2: 'fm',
                phoneCode: '691'
            },
            {
                name: 'Moldova (Republica Moldova)',
                iso2: 'md',
                phoneCode: '373'
            },
            {
                name: 'Monaco',
                iso2: 'mc',
                phoneCode: '377'
            },
            {
                name: 'Mongolia (Монгол)',
                iso2: 'mn',
                phoneCode: '976'
            },
            {
                name: 'Montenegro (Crna Gora)',
                iso2: 'me',
                phoneCode: '382'
            },
            {
                name: 'Montserrat',
                iso2: 'ms',
                phoneCode: '1664'
            },
            {
                name: 'Morocco (‫المغرب‬‎)',
                iso2: 'ma',
                phoneCode: '212'
            },
            {
                name: 'Mozambique (Moçambique)',
                iso2: 'mz',
                phoneCode: '258'
            },
            {
                name: 'Myanmar (Burma) (မြန်မာ)',
                iso2: 'mm',
                phoneCode: '95'
            },
            {
                name: 'Namibia (Namibië)',
                iso2: 'na',
                phoneCode: '264'
            },
            {
                name: 'Nauru',
                iso2: 'nr',
                phoneCode: '674'
            },
            {
                name: 'Nepal (नेपाल)',
                iso2: 'np',
                phoneCode: '977'
            },
            {
                name: 'Netherlands (Nederland)',
                iso2: 'nl',
                phoneCode: '31'
            },
            {
                name: 'New Caledonia (Nouvelle-Calédonie)',
                iso2: 'nc',
                phoneCode: '687'
            },
            {
                name: 'New Zealand',
                iso2: 'nz',
                phoneCode: '64'
            },
            {
                name: 'Nicaragua',
                iso2: 'ni',
                phoneCode: '505'
            },
            {
                name: 'Niger (Nijar)',
                iso2: 'ne',
                phoneCode: '227'
            },
            {
                name: 'Nigeria',
                iso2: 'ng',
                phoneCode: '234'
            },
            {
                name: 'Niue',
                iso2: 'nu',
                phoneCode: '683'
            },
            {
                name: 'Norfolk Island',
                iso2: 'nf',
                phoneCode: '672'
            },
            {
                name: 'North Korea (조선 민주주의 인민 공화국)',
                iso2: 'kp',
                phoneCode: '850'
            },
            {
                name: 'Northern Mariana Islands',
                iso2: 'mp',
                phoneCode: '1670'
            },
            {
                name: 'Norway (Norge)',
                iso2: 'no',
                phoneCode: '47'
            },
            {
                name: 'Oman (‫عُمان‬‎)',
                iso2: 'om',
                phoneCode: '968'
            },
            {
                name: 'Pakistan (‫پاکستان‬‎)',
                iso2: 'pk',
                phoneCode: '92'
            },
            {
                name: 'Palau',
                iso2: 'pw',
                phoneCode: '680'
            },
            {
                name: 'Palestine (‫فلسطين‬‎)',
                iso2: 'ps',
                phoneCode: '970'
            },
            {
                name: 'Panama (Panamá)',
                iso2: 'pa',
                phoneCode: '507'
            },
            {
                name: 'Papua New Guinea',
                iso2: 'pg',
                phoneCode: '675'
            },
            {
                name: 'Paraguay',
                iso2: 'py',
                phoneCode: '595'
            },
            {
                name: 'Peru (Perú)',
                iso2: 'pe',
                phoneCode: '51'
            },
            {
                name: 'Philippines',
                iso2: 'ph',
                phoneCode: '63'
            },
            {
                name: 'Poland (Polska)',
                iso2: 'pl',
                phoneCode: '48'
            },
            {
                name: 'Portugal',
                iso2: 'pt',
                phoneCode: '351'
            },
            {
                name: 'Puerto Rico',
                iso2: 'pr',
                phoneCode: '1',
                areaCode: ['787', '939']
            },
            {
                name: 'Qatar (‫قطر‬‎)',
                iso2: 'qa',
                phoneCode: '974'
            },
            {
                name: 'Réunion (La Réunion)',
                iso2: 're',
                phoneCode: '262'
            },
            {
                name: 'Romania (România)',
                iso2: 'ro',
                phoneCode: '40'
            },
            {
                name: 'Russia (Россия)',
                iso2: 'ru',
                phoneCode: '7'
            },
            {
                name: 'Rwanda',
                iso2: 'rw',
                phoneCode: '250'
            },
            {
                name: 'Saint Barthélemy (Saint-Barthélemy)',
                iso2: 'bl',
                phoneCode: '590'
            },
            {
                name: 'Saint Helena',
                iso2: 'sh',
                phoneCode: '290'
            },
            {
                name: 'Saint Kitts and Nevis',
                iso2: 'kn',
                phoneCode: '1869'
            },
            {
                name: 'Saint Lucia',
                iso2: 'lc',
                phoneCode: '1758'
            },
            {
                name: 'Saint Martin (Saint-Martin (partie française))',
                iso2: 'mf',
                phoneCode: '590'
            },
            {
                name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
                iso2: 'pm',
                phoneCode: '508'
            },
            {
                name: 'Saint Vincent and the Grenadines',
                iso2: 'vc',
                phoneCode: '1784'
            },
            {
                name: 'Samoa',
                iso2: 'ws',
                phoneCode: '685'
            },
            {
                name: 'San Marino',
                iso2: 'sm',
                phoneCode: '378'
            },
            {
                name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
                iso2: 'st',
                phoneCode: '239'
            },
            {
                name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
                iso2: 'sa',
                phoneCode: '966'
            },
            {
                name: 'Senegal (Sénégal)',
                iso2: 'sn',
                phoneCode: '221'
            },
            {
                name: 'Serbia (Србија)',
                iso2: 'rs',
                phoneCode: '381'
            },
            {
                name: 'Seychelles',
                iso2: 'sc',
                phoneCode: '248'
            },
            {
                name: 'Sierra Leone',
                iso2: 'sl',
                phoneCode: '232'
            },
            {
                name: 'Singapore',
                iso2: 'sg',
                phoneCode: '65'
            },
            {
                name: 'Sint Maarten',
                iso2: 'sx',
                phoneCode: '1721'
            },
            {
                name: 'Slovakia (Slovensko)',
                iso2: 'sk',
                phoneCode: '421'
            },
            {
                name: 'Slovenia (Slovenija)',
                iso2: 'si',
                phoneCode: '386'
            },
            {
                name: 'Solomon Islands',
                iso2: 'sb',
                phoneCode: '677'
            },
            {
                name: 'Somalia (Soomaaliya)',
                iso2: 'so',
                phoneCode: '252'
            },
            {
                name: 'South Africa',
                iso2: 'za',
                phoneCode: '27'
            },
            {
                name: 'South Korea (대한민국)',
                iso2: 'kr',
                phoneCode: '82'
            },
            {
                name: 'South Sudan (‫جنوب السودان‬‎)',
                iso2: 'ss',
                phoneCode: '211'
            },
            {
                name: 'Spain (España)',
                iso2: 'es',
                phoneCode: '34'
            },
            {
                name: 'Sri Lanka (ශ්‍රී ලංකාව)',
                iso2: 'lk',
                phoneCode: '94'
            },
            {
                name: 'Sudan (‫السودان‬‎)',
                iso2: 'sd',
                phoneCode: '249'
            },
            {
                name: 'Suriname',
                iso2: 'sr',
                phoneCode: '597'
            },
            {
                name: 'Svalbard and Jan Mayen',
                iso2: 'sj',
                phoneCode: '47'
            },
            {
                name: 'Swaziland',
                iso2: 'sz',
                phoneCode: '268'
            },
            {
                name: 'Sweden (Sverige)',
                iso2: 'se',
                phoneCode: '46'
            },
            {
                name: 'Switzerland (Schweiz)',
                iso2: 'ch',
                phoneCode: '41'
            },
            {
                name: 'Syria (‫سوريا‬‎)',
                iso2: 'sy',
                phoneCode: '963'
            },
            {
                name: 'Taiwan (台灣)',
                iso2: 'tw',
                phoneCode: '886'
            },
            {
                name: 'Tajikistan',
                iso2: 'tj',
                phoneCode: '992'
            },
            {
                name: 'Tanzania',
                iso2: 'tz',
                phoneCode: '255'
            },
            {
                name: 'Thailand (ไทย)',
                iso2: 'th',
                phoneCode: '66'
            },
            {
                name: 'Timor-Leste',
                iso2: 'tl',
                phoneCode: '670'
            },
            {
                name: 'Togo',
                iso2: 'tg',
                phoneCode: '228'
            },
            {
                name: 'Tokelau',
                iso2: 'tk',
                phoneCode: '690'
            },
            {
                name: 'Tonga',
                iso2: 'to',
                phoneCode: '676'
            },
            {
                name: 'Trinidad and Tobago',
                iso2: 'tt',
                phoneCode: '1868'
            },
            {
                name: 'Tunisia (‫تونس‬‎)',
                iso2: 'tn',
                phoneCode: '216'
            },
            {
                name: 'Turkey (Türkiye)',
                iso2: 'tr',
                phoneCode: '90'
            },
            {
                name: 'Turkmenistan',
                iso2: 'tm',
                phoneCode: '993'
            },
            {
                name: 'Turks and Caicos Islands',
                iso2: 'tc',
                phoneCode: '1649'
            },
            {
                name: 'Tuvalu',
                iso2: 'tv',
                phoneCode: '688'
            },
            {
                name: 'U.S. Virgin Islands',
                iso2: 'vi',
                phoneCode: '1340'
            },
            {
                name: 'Uganda',
                iso2: 'ug',
                phoneCode: '256'
            },
            {
                name: 'Ukraine (Україна)',
                iso2: 'ua',
                phoneCode: '380'
            },
            {
                name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
                iso2: 'ae',
                phoneCode: '971'
            },
            {
                name: 'Uruguay',
                iso2: 'uy',
                phoneCode: '598'
            },
            {
                name: 'Uzbekistan (Oʻzbekiston)',
                iso2: 'uz',
                phoneCode: '998'
            },
            {
                name: 'Vanuatu',
                iso2: 'vu',
                phoneCode: '678'
            },
            {
                name: 'Vatican City (Città del Vaticano)',
                iso2: 'va',
                phoneCode: '39'
            },
            {
                name: 'Venezuela',
                iso2: 've',
                phoneCode: '58'
            },
            {
                name: 'Vietnam (Việt Nam)',
                iso2: 'vn',
                phoneCode: '84'
            },
            {
                name: 'Wallis and Futuna',
                iso2: 'wf',
                phoneCode: '681'
            },
            {
                name: 'Western Sahara (‫الصحراء الغربية‬‎)',
                iso2: 'eh',
                phoneCode: '212'
            },
            {
                name: 'Yemen (‫اليمن‬‎)',
                iso2: 'ye',
                phoneCode: '967'
            },
            {
                name: 'Zambia',
                iso2: 'zm',
                phoneCode: '260'
            },
            {
                name: 'Zimbabwe',
                iso2: 'zw',
                phoneCode: '263'
            },
            {
                name: 'Åland Islands',
                iso2: 'ax',
                phoneCode: '358'
            }
        ];
    }
}
StatesData.ɵfac = function StatesData_Factory(t) { return new (t || StatesData)(); };
StatesData.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StatesData, factory: StatesData.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatesData, [{
        type: Injectable
    }], null, null); })();

const _c0$e = ["t"];
function PhoneTextFieldComponent_div_12_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵlistener("click", function PhoneTextFieldComponent_div_12_li_6_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const s_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.onSelect(s_r3); });
    i0.ɵɵelementStart(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", s_r3.name, "");
} }
function PhoneTextFieldComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementStart(3, "input", 13);
    i0.ɵɵlistener("ngModelChange", function PhoneTextFieldComponent_div_12_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.filteringString = $event; })("ngModelChange", function PhoneTextFieldComponent_div_12_Template_input_ngModelChange_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.filter(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 14);
    i0.ɵɵelementStart(5, "ul", 15);
    i0.ɵɵtemplate(6, PhoneTextFieldComponent_div_12_li_6_Template, 3, 1, "li", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r1.filteringString);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredStates);
} }
const _c1$b = function (a0) { return { width: a0 }; };
const _c2$a = function (a0) { return { disabled: a0 }; };
const _c3$8 = function (a1) { return { "flag-container": true, dense: a1 }; };
const _c4$3 = function (a1) { return ["flag-selected", a1]; };
const _c5$3 = function (a1) { return ["flag flag-select flag-icon", a1]; };
const _c6$3 = function (a1) { return { "phone-prefix": true, dense: a1 }; };
const _c7$2 = function (a1) { return { "phone-input": true, dense: a1 }; };
const _c8$2 = function (a0) { return { dense: a0 }; };
const DEFAULT_STATE = 'gb';
class PhoneTextFieldComponent {
    constructor(selfRef) {
        this.selfRef = selfRef;
        this.tWidth = "100%";
        this.initialState = "";
        this.lockState = false;
        this.dense = false;
        this.onStateChanged = new EventEmitter();
        this.dropdown = false;
        this.states = new StatesData().allCountries;
        this.filteringString = "";
        this.filteredStates = this.states;
        this.shownStates = [];
        this.phoneNumber = "";
        this.phoneRegex = /^\+?\d+(-?\d+)*/;
        //control value accessor callbacks
        this.onChange = (_) => { };
        this.onTouch = () => { };
    }
    ngOnChanges(changes) {
        if (changes.initialState && !changes.initialState.firstChange) {
            const foundState = this.states.find(s => s.iso2 === changes.initialState.currentValue);
            this.selected = foundState ? foundState : this.states.find(s => s.iso2 === DEFAULT_STATE);
            this.onProcess();
        }
    }
    ngOnInit() {
        this.pnf = lpb.PhoneNumberFormat;
        this.pnu = lpb.PhoneNumberUtil.getInstance();
        if (this.initialState !== "") {
            this.selected = this.states.find(this.findInitialStateByICode, this);
        }
        else {
            this.selected = this.states[0];
        }
    }
    //close dropdown if click is outside of my component
    onclick(event, targetElement) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this.selfRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.reset();
        }
    }
    onTouchEnd(event, targetElement) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this.selfRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.reset();
        }
    }
    onModelChange(e) {
        this.phoneNumber = e;
        this.onProcess();
        this.checkStateChange();
    }
    onPaste(event) {
        const val = event.clipboardData.getData('text').trim();
        if (!this.phoneRegex.test(val)) {
            event.preventDefault();
        }
    }
    onClick() {
        if (!this.disabled && !this.lockState)
            this.dropdown = !this.dropdown;
    }
    reset() {
        this.dropdown = false;
        this.filteringString = "";
        this.filteredStates = this.states;
    }
    onSelect(s) {
        this.selected = s;
        this.dropdown = false;
        this.onProcess();
        this.onStateChanged.emit(s);
    }
    filterFn(item) {
        var re = new RegExp(this.filteringString, "i");
        return re.test(item.name);
    }
    filter() {
        this.filteredStates = this.states.filter(this.filterFn, this);
    }
    findStateByICode(item) {
        return item.phoneCode == this.num.getCountryCode();
    }
    findInitialStateByICode(item) {
        return item.iso2 == this.initialState;
    }
    onNumberChange(e) {
        switch (e.key) {
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "+":
            case "-":
                break;
            case 'r': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'z': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'a': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'x': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'v': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'c': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case "Tab":
            case "Home":
            case "End":
            case "ArrowLeft":
            case "ArrowRight":
            case "Backspace":
            case "Delete":
                this.onProcess();
                break;
            default:
                this.breakEvent(e);
        }
    }
    onProcess() {
        this.processNumber();
        if (this.num && this.possible) {
            this.onChange(this.pnu.format(this.num, this.pnf.E164));
        }
        else {
            this.onChange(this.phoneNumber);
        }
    }
    preventDef(e) {
        switch (e.key) {
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "+":
            case "-":
                break;
            case 'r': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'z': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'a': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'x': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'v': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case 'c': {
                if (!e.ctrlKey)
                    this.breakEvent(e);
            }
            case "Tab":
            case "Home":
            case "End":
            case "ArrowLeft":
            case "ArrowRight":
            case "Backspace":
            case "Delete":
                this.onProcess();
                break;
            default:
                this.breakEvent(e);
        }
    }
    checkStateChange() {
        if (this.num) {
            const regionCode = this.pnu.getRegionCodeForNumber(this.num);
            const sameState = regionCode ? regionCode.toLowerCase() === this.selected.iso2.toLowerCase() : false;
            if (!this.lockState || sameState) {
                this.phoneNumber = this.getNationalNumber();
            }
        }
    }
    breakEvent(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    processNumber() {
        if (/^\+/.test(this.phoneNumber)) {
            try {
                this.num = this.pnu.parseAndKeepRawInput(this.phoneNumber.toString());
                if (!this.lockState) {
                    this.selected = this.states.find(this.findStateByICode, this);
                    this.onStateChanged.emit(this.selected);
                }
            }
            catch (err) {
                this.lastError = err;
                this.num = undefined;
            }
        }
        else {
            try {
                this.num = this.pnu.parseAndKeepRawInput(this.phoneNumber.toString(), this.selected.iso2.toUpperCase());
            }
            catch (err) {
                this.lastError = err;
                this.num = undefined;
            }
        }
        if (this.num) {
            this.possible = this.pnu.isPossibleNumber(this.num);
            this.valid = this.pnu.isValidNumber(this.num);
            this.regionValid = undefined;
            this.regionValid = this.pnu.isValidNumberForRegion(this.num, this.selected.iso2.toUpperCase());
        }
    }
    getLastError() {
        if (!this.lastError)
            return;
        switch (this.lastError.message) {
            case "The string supplied is too long to be a phone number":
                return "too long" /* TOO_LONG */;
            case "The string supplied did not seem to be a phone number":
            default:
                return "not a number" /* NOT_A_NUMBER */;
        }
    }
    getNationalNumber() {
        let isItalianLeadingZero = this.num.getItalianLeadingZero();
        if (isItalianLeadingZero)
            return '0' + this.num.getNationalNumber();
        return this.num.getNationalNumber();
    }
    //control value accessor methods
    writeValue(obj) {
        // workaround to allow register onChange to be called before timeout callback
        setTimeout(() => {
            if (obj) {
                // if obj valid number
                this.phoneNumber = obj;
                this.onProcess();
                if (this.num) {
                    this.phoneNumber = this.getNationalNumber();
                }
                else {
                    this.phoneNumber = this.getLastError() === "too long" /* TOO_LONG */ ? obj : null;
                    if (obj.startsWith('+')) {
                        const searchValue = obj.substring(1);
                        // if obj not valid number and starts with '+'
                        this.selected = this.states.find(el => el.phoneCode === searchValue);
                        if (!this.selected) {
                            this.selected = this.states.find(this.findInitialStateByICode, this);
                        }
                        if (!this.selected) {
                            this.selected = this.states.find(el => el.iso2 === DEFAULT_STATE);
                        }
                        this.onChange(null);
                    }
                    else {
                        // if obj not valid number and NOT starts with '+'
                        this.onChange(null);
                    }
                }
            }
            else {
                // reset the number shown in the input
                this.phoneNumber = null;
                // reset the dropdown status (closed, with no filtering string)
                this.reset();
            }
        }, 0);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    //Validator methods
    validate(control) {
        if (this.phoneNumber === '' || this.phoneNumber === null || this.num && this.valid && !this.lockState) {
            return null;
        }
        if (this.num &&
            this.valid &&
            this.lockState &&
            this.pnu.getRegionCodeForNumber(this.num).toLowerCase() === this.selected.iso2.toLowerCase())
            return null;
        return {
            error: "Invalid number"
        };
    }
}
PhoneTextFieldComponent.ɵfac = function PhoneTextFieldComponent_Factory(t) { return new (t || PhoneTextFieldComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
PhoneTextFieldComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PhoneTextFieldComponent, selectors: [["vox-phone-text-field"]], viewQuery: function PhoneTextFieldComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$e, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostBindings: function PhoneTextFieldComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function PhoneTextFieldComponent_click_HostBindingHandler($event) { return ctx.onclick($event, $event.target); }, false, i0.ɵɵresolveDocument)("touchend", function PhoneTextFieldComponent_touchend_HostBindingHandler($event) { return ctx.onTouchEnd($event, $event.target); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { tWidth: ["width", "tWidth"], initialState: ["state", "initialState"], lockState: "lockState", dense: "dense" }, outputs: { onStateChanged: "onStateChanged" }, features: [i0.ɵɵProvidersFeature([
            StatesData,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PhoneTextFieldComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => PhoneTextFieldComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 13, vars: 29, consts: [[1, "phone-tf-container", 3, "ngStyle"], ["tabindex", "-1", 1, "input-container", "vox-dropdown", "dropdown", 3, "ngClass"], [3, "ngClass"], [3, "title", "ngClass", "click"], ["autocomplete", "off", "name", "phone", "type", "tel", 3, "ngClass", "ngModel", "disabled", "ngModelChange", "keyup", "keydown", "keypress", "focus", "blur", "paste"], ["t", ""], [1, "icon-container", 3, "ngClass", "click"], [1, "icon-small-check"], [1, "icon-small-alert"], ["class", "dropdown-container dropdown-menu", 4, "ngIf"], [1, "dropdown-container", "dropdown-menu"], [1, "search-container", "dropdown-item"], [1, "icon-small-search"], ["type", "text", "placeholder", "Search", 1, "filter", 3, "ngModel", "ngModelChange"], [1, "separator"], [1, "states-list"], ["class", "state-item dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "state-item", "dropdown-item", 3, "click"], [1, "states-name"]], template: function PhoneTextFieldComponent_Template(rf, ctx) { if (rf & 1) {
        const _r9 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵlistener("click", function PhoneTextFieldComponent_Template_span_click_4_listener() { return ctx.onClick(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "input", 4, 5);
        i0.ɵɵlistener("ngModelChange", function PhoneTextFieldComponent_Template_input_ngModelChange_7_listener($event) { return ctx.phoneNumber = $event; })("ngModelChange", function PhoneTextFieldComponent_Template_input_ngModelChange_7_listener($event) { return ctx.onModelChange($event); })("keyup", function PhoneTextFieldComponent_Template_input_keyup_7_listener($event) { return ctx.onNumberChange($event); })("keydown", function PhoneTextFieldComponent_Template_input_keydown_7_listener($event) { return ctx.preventDef($event); })("keypress", function PhoneTextFieldComponent_Template_input_keypress_7_listener($event) { return ctx.preventDef($event); })("focus", function PhoneTextFieldComponent_Template_input_focus_7_listener() { return ctx.reset(); })("blur", function PhoneTextFieldComponent_Template_input_blur_7_listener() { return ctx.onTouch(); })("paste", function PhoneTextFieldComponent_Template_input_paste_7_listener($event) { return ctx.onPaste($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵlistener("click", function PhoneTextFieldComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r9); const _r0 = i0.ɵɵreference(8); return _r0.focus(); });
        i0.ɵɵelement(10, "span", 7);
        i0.ɵɵelement(11, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, PhoneTextFieldComponent_div_12_Template, 7, 2, "div", 9);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(13, _c1$b, ctx.tWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2$a, ctx.disabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$8, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c4$3, ctx.lockState ? "state-locked" : ""));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("title", ctx.selected.name)("ngClass", i0.ɵɵpureFunction1(21, _c5$3, "flag-icon-" + ctx.selected.iso2));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c6$3, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("+", ctx.selected == null ? null : ctx.selected.phoneCode, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c7$2, ctx.dense))("ngModel", ctx.phoneNumber)("disabled", ctx.disabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c8$2, ctx.dense));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.dropdown);
    } }, directives: [i1.NgStyle, i1.NgClass, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i1.NgIf, i1.NgForOf], styles: ["@charset \"UTF-8\";body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.phone-tf-container[_ngcontent-%COMP%]{position:relative;display:block;text-align:start;font-size:20px}.was-validated[_nghost-%COMP%]   .flag-container[_ngcontent-%COMP%], .was-validated[_nghost-%COMP%]   .icon-container[_ngcontent-%COMP%], .was-validated[_nghost-%COMP%]   .phone-input[_ngcontent-%COMP%], .was-validated[_nghost-%COMP%]   .phone-prefix[_ngcontent-%COMP%]{border:2px solid #ff3465!important}.input-container[_ngcontent-%COMP%]:hover   .flag-container[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:hover   .icon-container[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:hover   .phone-input[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:hover   .phone-prefix[_ngcontent-%COMP%]{border:2px solid #868990}.input-container[_ngcontent-%COMP%]:focus-within   .flag-container[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:focus-within   .icon-container[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:focus-within   .phone-prefix[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:focus-within   .phone-input[_ngcontent-%COMP%]{border:2px solid #000000!important}.input-container.disabled[_ngcontent-%COMP%]   .phone-prefix[_ngcontent-%COMP%], .input-container.disabled[_ngcontent-%COMP%]   .phone-input[_ngcontent-%COMP%]:disabled, .input-container.disabled[_ngcontent-%COMP%]   .icon-container[_ngcontent-%COMP%], .input-container.disabled[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]{border:2px solid #e5e9f0!important;background-color:#e5e9f0!important}.input-container[_ngcontent-%COMP%]{outline:none;display:flex}.input-container[_ngcontent-%COMP%]:hover   .phone-input[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:hover   .phone-prefix[_ngcontent-%COMP%]{border-width:2px 0 2px 0!important;border-radius:0!important}.input-container[_ngcontent-%COMP%]:hover   .icon-container[_ngcontent-%COMP%]{border-width:2px 2px 2px 0!important;border-radius:0 5px 5px 0!important}.input-container[_ngcontent-%COMP%]:hover   .flag-container[_ngcontent-%COMP%]{border-width:2px 0 2px 2px!important;border-radius:5px 0 0 5px!important}.input-container[_ngcontent-%COMP%]:focus-within   .phone-input[_ngcontent-%COMP%]{border-width:2px 0 2px 0!important;border-radius:0!important}.input-container[_ngcontent-%COMP%]:focus-within   div.phone-prefix[_ngcontent-%COMP%]{border-radius:0!important;border-right:0!important}.input-container[_ngcontent-%COMP%]:focus-within   .icon-container[_ngcontent-%COMP%], .input-container[_ngcontent-%COMP%]:focus-within   .phone-prefix[_ngcontent-%COMP%]{border-width:2px 2px 2px 0!important;border-radius:0 5px 5px 0!important}.input-container[_ngcontent-%COMP%]:focus-within   .flag-container[_ngcontent-%COMP%]{border-width:2px 0 2px 2px!important;border-radius:5px 0 0 5px!important}.input-container.disabled[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]{border-width:2px 0 2px 2px!important;border-radius:5px 0 0 5px!important}.input-container.disabled[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]   .flag-selected[_ngcontent-%COMP%]{cursor:auto}.input-container.disabled[_ngcontent-%COMP%]   .icon-container[_ngcontent-%COMP%]{border-width:2px 2px 2px 0!important;border-radius:0 5px 5px 0!important;cursor:auto}.input-container.disabled[_ngcontent-%COMP%]   .phone-input[_ngcontent-%COMP%]:disabled{border-width:2px 0 2px 0!important;border-radius:0!important}.input-container.disabled[_ngcontent-%COMP%]   .phone-prefix[_ngcontent-%COMP%]{border-width:2px 2px 2px 0!important;border-radius:0!important;cursor:auto}.phone-prefix[_ngcontent-%COMP%]{outline:none;height:3.5rem;line-height:54px;padding-left:.6rem;color:#868990;border-top:2px solid #b5bac2;border-bottom:2px solid #b5bac2;border-width:2px 0 2px 2px;border-radius:0!important}.phone-prefix.dense[_ngcontent-%COMP%]{line-height:36px}.was-validated[_nghost-%COMP%]   .phone-prefix[_ngcontent-%COMP%]{border-width:2px 0 2px 0!important;border-radius:0!important}.phone-input[_ngcontent-%COMP%]{outline:none;height:3.5rem;width:100%;padding-left:.5rem;border:2px solid #b5bac2;border-width:2px 0 2px 0;border-radius:0}.was-validated[_nghost-%COMP%]   .phone-input[_ngcontent-%COMP%]{border-width:2px 0 2px 0!important;border-radius:0!important}.icon-container[_ngcontent-%COMP%]{position:relative;height:3.5rem;width:3.5rem;border:2px solid #b5bac2;border-width:2px 2px 2px 0;border-radius:0 5px 5px 0;cursor:text}.was-validated[_nghost-%COMP%]   .icon-container[_ngcontent-%COMP%]{border-width:2px 2px 2px 0!important;border-radius:0 5px 5px 0!important}.icon-small-check[_ngcontent-%COMP%], .icon-small-alert[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:transparent;display:none}.icon-small-alert[_ngcontent-%COMP%]{color:#ff3465}.ng-valid[_nghost-%COMP%]   .icon-small-alert[_ngcontent-%COMP%]{display:none}.was-validated[_nghost-%COMP%]   .icon-small-alert[_ngcontent-%COMP%]{display:block}.icon-small-check[_ngcontent-%COMP%]{color:#25edb5}.ng-valid[_nghost-%COMP%]   .icon-small-check[_ngcontent-%COMP%]{display:block}.was-validated[_nghost-%COMP%]   .icon-small-check[_ngcontent-%COMP%]{display:none}.dropdown-container[_ngcontent-%COMP%]{position:absolute;left:0;right:0;max-height:10rem;text-align:start;display:block;box-shadow:0 3px 6px #00000078;border-radius:5px;padding-left:.3rem;padding-right:.3rem;padding-top:.2rem}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]{background-color:#fff;position:-webkit-sticky;position:sticky;top:0;left:0;padding-left:.1rem;display:flex;flex-direction:row}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:18px;color:#636c72;align-self:center;padding-top:.3rem;padding-bottom:.3rem}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]{width:100%;height:1.6rem;outline:none;border:none;padding-left:.5rem;padding-top:.3rem;padding-bottom:.3rem;margin-top:.2rem;font-weight:400}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]::-moz-placeholder{color:#636c72;opacity:1}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]:-ms-input-placeholder{color:#636c72}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   .filter[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#636c72}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]:hover{background-color:#fff}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]:active{background-color:#fff}.dropdown-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]:focus{outline:none}.dropdown-container[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.1);position:-webkit-sticky;position:sticky}.dropdown-container[_ngcontent-%COMP%]   .states-list[_ngcontent-%COMP%]{list-style:none;padding-left:0;margin-top:.5rem;margin-bottom:.5rem;overflow:auto;overflow-x:hidden;height:6.5rem}.dropdown-container[_ngcontent-%COMP%]   .states-list[_ngcontent-%COMP%]   .state-item[_ngcontent-%COMP%]:hover{background-color:#e5e9f0;cursor:pointer}.flag-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;height:3.5rem;width:3.5rem;border:2px solid #b5bac2;border-width:2px 0 2px 2px;border-radius:5px 0 0 5px}.was-validated[_nghost-%COMP%]   .flag-container[_ngcontent-%COMP%]{border-width:2px 0 2px 2px!important;border-radius:5px 0 0 5px!important}.flag-selected[_ngcontent-%COMP%]{cursor:pointer;left:-.1rem}.flag-selected.state-locked[_ngcontent-%COMP%]{cursor:default}.flag-selected.state-locked[_ngcontent-%COMP%]   .flag-select[_ngcontent-%COMP%]:after{display:none}.flag[_ngcontent-%COMP%]{position:relative;height:1.125rem;width:1.125rem;border:none;outline:none;border-radius:5px}.flag-select[_ngcontent-%COMP%]:after{content:\"\\25be\";position:absolute;font-size:.9rem;top:0;right:-1rem}.dense[_ngcontent-%COMP%]{height:40px!important;font-size:16px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneTextFieldComponent, [{
        type: Component,
        args: [{
                selector: "vox-phone-text-field",
                templateUrl: "./phone-text-field.component.html",
                styleUrls: ["./phone-text-field.component.scss"],
                providers: [
                    StatesData,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PhoneTextFieldComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => PhoneTextFieldComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { tWidth: [{
            type: Input,
            args: ["width"]
        }], initialState: [{
            type: Input,
            args: ["state"]
        }], lockState: [{
            type: Input,
            args: ["lockState"]
        }], dense: [{
            type: Input,
            args: ["dense"]
        }], onStateChanged: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ["t"]
        }], onclick: [{
            type: HostListener,
            args: ["document:click", ["$event", "$event.target"]]
        }], onTouchEnd: [{
            type: HostListener,
            args: ["document:touchend", ["$event", "$event.target"]]
        }] }); })();

class VoxPhoneTextFieldModule {
}
VoxPhoneTextFieldModule.ɵfac = function VoxPhoneTextFieldModule_Factory(t) { return new (t || VoxPhoneTextFieldModule)(); };
VoxPhoneTextFieldModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxPhoneTextFieldModule });
VoxPhoneTextFieldModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxPhoneTextFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [PhoneTextFieldComponent],
                imports: [CommonModule, FormsModule],
                exports: [PhoneTextFieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxPhoneTextFieldModule, { declarations: [PhoneTextFieldComponent], imports: [CommonModule, FormsModule], exports: [PhoneTextFieldComponent] }); })();

const _c0$d = ["field"];
function SmsCodeInputComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 2, 3);
    i0.ɵɵlistener("keyup", function SmsCodeInputComponent_input_1_Template_input_keyup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const i_r2 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.keyEvent($event, i_r2); })("keydown", function SmsCodeInputComponent_input_1_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.preventDef($event); })("keypress", function SmsCodeInputComponent_input_1_Template_input_keypress_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.preventDef($event); })("blur", function SmsCodeInputComponent_input_1_Template_input_blur_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onTouch(); });
    i0.ɵɵelementEnd();
} }
class SmsCodeInputComponent {
    constructor() {
        this.len = 3;
        this.complete = new EventEmitter();
        this.onChange = (_) => { };
        this.code = [];
    }
    ngOnInit() {
        this.code.length = this.len;
    }
    trackByFn(item) {
        return item;
    }
    preventDef(e) {
        if (e.key != 'Delete' && e.key != 'Backspace') {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    keyEvent(e, i) {
        e.preventDefault();
        e.stopPropagation();
        switch (e.key) {
            // 0 - 9
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                this.code[i] = undefined;
                this.code[i] = Number(e.key);
                this.fields.toArray()[i].nativeElement.value =
                    this.code[i] != undefined ? this.code[i] : '';
                this.onChange(this.code.join(''));
                // if i >= len-1 then it is the last box and it should lose focus
                // else it's not and then it should focus the next one
                if (i >= this.len - 1) {
                    this.fields.toArray()[i].nativeElement.blur();
                }
                else {
                    this.fields.toArray()[i + 1].nativeElement.focus();
                }
                if (this.code.join('').length == this.len) {
                    this.complete.emit(this.code.join(''));
                }
                break;
            // Backspace and Delete
            case 'Backspace':
            case 'Delete':
                if (this.code[i]) {
                    this.code[i] = undefined;
                    this.onChange(this.code.join(''));
                    this.fields.toArray()[i].nativeElement.value = '';
                }
                //if i <= 0 then it is the first box and the with backspace it lose focus
                //else it's not the first and then focus should be setted to i - 1
                else if (i > 0) {
                    this.fields.toArray()[i - 1].nativeElement.focus();
                }
                break;
            //Tab and Shift Tab
            case 'Tab':
                if (e.shiftKey) {
                    if (i <= 0) {
                        //this.fields.toArray()[i].nativeElement.blur();
                    }
                    else {
                        this.fields.toArray()[i - 1].nativeElement.focus();
                    }
                }
                else {
                    if (i >= this.len - 1) {
                        this.fields.toArray()[i].nativeElement.blur();
                    }
                    else {
                        this.fields.toArray()[i + 1].nativeElement.focus();
                    }
                }
                break;
            default:
                break;
        }
    }
    //Accessor Value Interface Methods
    writeValue(value) {
        if (value && value.length == this.len) {
            var digits = value.split('');
            this.code = digits.map(Number);
            for (var i = 0; i < this.len; ++i) {
                this.fields.toArray()[i].nativeElement.value = this.code[i];
            }
            this.complete.emit(this.code.join(''));
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        for (var i = 0; i < this.len; ++i) {
            this.fields.toArray()[i].nativeElement.disabled = this.disabled;
        }
    }
    // Interface Validator
    validate(control) {
        if (this.fields) {
            let fieldArray = this.fields.toArray();
            for (let i = 0; i < fieldArray.length; ++i) {
                if (!fieldArray[i].nativeElement.value) {
                    return {
                        error: 'All fields required'
                    };
                }
            }
            return null;
        }
        else {
            return { error: 'Not initialized' };
        }
    }
}
SmsCodeInputComponent.ɵfac = function SmsCodeInputComponent_Factory(t) { return new (t || SmsCodeInputComponent)(); };
SmsCodeInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SmsCodeInputComponent, selectors: [["vox-sms-code-input"]], viewQuery: function SmsCodeInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$d, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fields = _t);
    } }, inputs: { len: "len" }, outputs: { complete: "complete" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SmsCodeInputComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => SmsCodeInputComponent),
                multi: true
            }
        ])], decls: 2, vars: 2, consts: [[1, "code-container"], ["class", "vox-text-field vox-text-field_number", "type", "number", 3, "keyup", "keydown", "keypress", "blur", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "number", 1, "vox-text-field", "vox-text-field_number", 3, "keyup", "keydown", "keypress", "blur"], ["field", ""]], template: function SmsCodeInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SmsCodeInputComponent_input_1_Template, 2, 0, "input", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.code)("ngForTrackBy", ctx.trackByFn);
    } }, directives: [i1.NgForOf], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.code-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}.code-container[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:not(:last-child){margin-right:15px}.was-validated[_nghost-%COMP%]   input[_ngcontent-%COMP%]{border:2px solid #ff3465!important}@media only screen and (max-width: 576px){.code-container[_ngcontent-%COMP%]{justify-content:space-between}.code-container[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmsCodeInputComponent, [{
        type: Component,
        args: [{
                selector: 'vox-sms-code-input',
                templateUrl: './sms-code-input.component.html',
                styleUrls: ['./sms-code-input.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SmsCodeInputComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => SmsCodeInputComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { fields: [{
            type: ViewChildren,
            args: ['field']
        }], len: [{
            type: Input
        }], complete: [{
            type: Output
        }] }); })();

class VoxSmsCodeInputModule {
}
VoxSmsCodeInputModule.ɵfac = function VoxSmsCodeInputModule_Factory(t) { return new (t || VoxSmsCodeInputModule)(); };
VoxSmsCodeInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxSmsCodeInputModule });
VoxSmsCodeInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxSmsCodeInputModule, [{
        type: NgModule,
        args: [{
                declarations: [SmsCodeInputComponent],
                imports: [CommonModule, FormsModule],
                exports: [SmsCodeInputComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxSmsCodeInputModule, { declarations: [SmsCodeInputComponent], imports: [CommonModule, FormsModule], exports: [SmsCodeInputComponent] }); })();

const _c0$c = function (a1) { return { "vox-toggle": true, "vox-toggle_aquamarine": a1 }; };
class ToggleComponent {
    constructor() {
        this.config = { disabled: false, isAquamarine: false };
        this.toggleOnChange = new EventEmitter();
    }
    ngOnInit() {
    }
    valueChange() {
        this.toggleOn = !this.toggleOn;
        this.toggleOnChange.emit(this.toggleOn);
    }
}
ToggleComponent.ɵfac = function ToggleComponent_Factory(t) { return new (t || ToggleComponent)(); };
ToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToggleComponent, selectors: [["vox-toggle"]], inputs: { config: "config", toggleOn: "toggleOn" }, outputs: { toggleOnChange: "toggleOnChange" }, decls: 3, vars: 5, consts: [[3, "ngClass"], ["type", "checkbox", 1, "vox-toggle__input", 3, "checked", "disabled", "change"], [1, "vox-toggle__switcher"]], template: function ToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("change", function ToggleComponent_Template_input_change_1_listener() { return ctx.valueChange(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "span", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$c, ctx.config.isAquamarine));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checked", ctx.toggleOn)("disabled", ctx.config.disabled);
    } }, directives: [i1.NgClass], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleComponent, [{
        type: Component,
        args: [{
                selector: 'vox-toggle',
                templateUrl: './toggle.component.html',
                styleUrls: ['./toggle.component.scss']
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], toggleOn: [{
            type: Input
        }], toggleOnChange: [{
            type: Output
        }] }); })();

class VoxToggleModule {
}
VoxToggleModule.ɵfac = function VoxToggleModule_Factory(t) { return new (t || VoxToggleModule)(); };
VoxToggleModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxToggleModule });
VoxToggleModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [ToggleComponent],
                imports: [CommonModule],
                exports: [ToggleComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxToggleModule, { declarations: [ToggleComponent], imports: [CommonModule], exports: [ToggleComponent] }); })();

function PasswordInputComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PasswordInputComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PasswordInputComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PasswordInputComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PasswordInputComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PasswordInputComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 7);
    i0.ɵɵelement(1, "path", 8);
    i0.ɵɵelementEnd();
} }
const _c0$b = function (a0) { return { "validation-password_show": a0 }; };
const _c1$a = function (a0) { return { "validation-password__item_valid": a0 }; };
const SPECIAL_CHARS_STRING = '!^%@*#+=?<>;.,\'-_$€&/|\\:()';
const DEFAULT_LANGUAGE = 'it';
const SUPPORTED_LANGUAGES = ['it', 'en'];
const CRITERIA_STRINGS = {
    en: {
        length: 'At least 8 chars',
        upperCase: 'At least 1 upper case',
        lowerCase: 'At least 1 lower case',
        digit: 'At least 1 digit',
        special: `At least 1 special char: ${SPECIAL_CHARS_STRING}`
    },
    it: {
        length: "Almeno 8 caratteri",
        upperCase: "1 maiuscola",
        lowerCase: "1 minuscola",
        digit: "1 numero",
        special: `1 carattere speciale: ${SPECIAL_CHARS_STRING}`
    }
};
class PasswordInputComponent {
    constructor() {
        this.hidden = true;
        this.passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!^%@*#+=?<>;.,\-_$€&\/':()\\|])([?]*)[A-Za-z\d!^%@*#+=?<>;.,\-_$€&\/':()\\|]{8,}$/;
        this.criteriaVisible = false;
        this.localLanguage = DEFAULT_LANGUAGE;
        this.criteriaStrings = CRITERIA_STRINGS;
        this.passwordCriteria = {
            length: { regex: /.{8,}/, value: false },
            upperCase: { regex: /[A-Z]/, value: false },
            lowerCase: { regex: /[a-z]/, value: false },
            special: { regex: /[!^%@*#+=>?<;.,_$€&':()\-_\/\\|]/, value: false },
            digit: { regex: /\d/, value: false }
        };
        // Control value accessor callbacks
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    ngOnChanges(c) {
        if (c.language && c.language.currentValue) {
            // support for en, en-US or en_US as input
            let lang = c.language.currentValue.toLowerCase();
            if (lang.includes('-') || lang.includes('_')) {
                lang = lang.includes('-') ? lang.split('-')[0] : lang.split('_')[0];
            }
            if (SUPPORTED_LANGUAGES.includes(lang)) {
                this.localLanguage = lang;
            }
            else {
                this.localLanguage = DEFAULT_LANGUAGE;
            }
        }
        else {
            this.localLanguage = DEFAULT_LANGUAGE;
        }
    }
    // Control value accessor methods
    writeValue(obj) {
        if (obj) {
            this.pwd = obj;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onProcess(evt) {
        this.pwd = evt.target.value;
        Object.keys(this.passwordCriteria).forEach(key => {
            const criteria = this.passwordCriteria[key];
            criteria.value = RegExp(criteria.regex).test(this.pwd);
        });
        this.onChange(this.pwd);
    }
    hide() {
        this.hidden = !this.hidden;
    }
    showCriteria() {
        this.criteriaVisible = true;
    }
    hideCriteria() {
        if (RegExp(this.passwordPattern).test(this.pwd)) {
            this.criteriaVisible = false;
        }
    }
    // Validator methods
    validate(control) {
        if (this.passwordPattern.test(this.pwd)) {
            return null;
        }
        else {
            return {
                pwdInvalid: 'Invalid password'
            };
        }
    }
}
PasswordInputComponent.ɵfac = function PasswordInputComponent_Factory(t) { return new (t || PasswordInputComponent)(); };
PasswordInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasswordInputComponent, selectors: [["vox-password-input"]], inputs: { hidden: "hidden", language: "language" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PasswordInputComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => PasswordInputComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 26, vars: 31, consts: [[1, "pwd-container"], [1, "input-container"], ["name", "pwd", "placeholder", "Password", 1, "vox-text-field", 3, "type", "disabled", "ngModel", "ngModelChange", "focus", "input"], [1, "validation-password", 3, "ngClass"], [1, "validation-password__item", 3, "ngClass"], [4, "ngTemplateOutlet"], ["sparkIcon", ""], ["xmlns", "http://www.w3.org/2000/svg", "width", "14", "height", "14", "viewBox", "0 0 12 18"], ["fill", "#9eabb3", "fill-rule", "evenodd", "d", "M.168 10.46l5.48-.695L2.12 17.45 11.17 6.619l-5.685.72L7.787.496z"]], template: function PasswordInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function PasswordInputComponent_Template_input_ngModelChange_2_listener($event) { return ctx.pwd = $event; })("focus", function PasswordInputComponent_Template_input_focus_2_listener() { return ctx.showCriteria(); })("input", function PasswordInputComponent_Template_input_input_2_listener($event) { return ctx.onProcess($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, PasswordInputComponent_ng_container_5_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵtemplate(9, PasswordInputComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 4);
        i0.ɵɵtemplate(13, PasswordInputComponent_ng_container_13_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 4);
        i0.ɵɵtemplate(17, PasswordInputComponent_ng_container_17_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementStart(18, "span");
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 4);
        i0.ɵɵtemplate(21, PasswordInputComponent_ng_container_21_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementStart(22, "span");
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, PasswordInputComponent_ng_template_24_Template, 2, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r5 = i0.ɵɵreference(25);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("type", ctx.hidden ? "password" : "text")("disabled", ctx.disabled)("ngModel", ctx.pwd);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c0$b, ctx.criteriaVisible));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c1$a, ctx.passwordCriteria.length.value));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.criteriaStrings[ctx.localLanguage].length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c1$a, ctx.passwordCriteria.upperCase.value));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.criteriaStrings[ctx.localLanguage].upperCase);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c1$a, ctx.passwordCriteria.lowerCase.value));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.criteriaStrings[ctx.localLanguage].lowerCase);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c1$a, ctx.passwordCriteria.digit.value));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.criteriaStrings[ctx.localLanguage].digit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c1$a, ctx.passwordCriteria.special.value));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.criteriaStrings[ctx.localLanguage].special);
    } }, directives: [i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i1.NgClass, i1.NgTemplateOutlet], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}.pwd-container[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\"}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]{height:0;display:flex;flex-direction:row;justify-content:stretch;align-items:stretch;flex-wrap:wrap;margin-top:5px;transition:height .3s ease-out;overflow:hidden}.pwd-container[_ngcontent-%COMP%]   .validation-password_show[_ngcontent-%COMP%]{height:100%;transition:height .3s ease-in}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:stretch;align-items:center;width:50%;min-width:225px;margin-bottom:5px}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item[_ngcontent-%COMP%]:nth-last-of-type(1){margin-bottom:0}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%]{min-width:14px}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{font-size:14px;fill:#868990;margin-right:5px}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:14px;color:#868990;white-space:nowrap}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item_valid[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:#25edb5}.pwd-container[_ngcontent-%COMP%]   .validation-password[_ngcontent-%COMP%]   .validation-password__item_valid[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{color:#25edb5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordInputComponent, [{
        type: Component,
        args: [{
                selector: 'vox-password-input',
                templateUrl: './password-input.component.html',
                styleUrls: ['./password-input.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PasswordInputComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => PasswordInputComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { hidden: [{
            type: Input
        }], language: [{
            type: Input
        }] }); })();

class VoxPasswordComponentModule {
}
VoxPasswordComponentModule.ɵfac = function VoxPasswordComponentModule_Factory(t) { return new (t || VoxPasswordComponentModule)(); };
VoxPasswordComponentModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxPasswordComponentModule });
VoxPasswordComponentModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxPasswordComponentModule, [{
        type: NgModule,
        args: [{
                declarations: [PasswordInputComponent],
                imports: [CommonModule, FormsModule],
                exports: [PasswordInputComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxPasswordComponentModule, { declarations: [PasswordInputComponent], imports: [CommonModule, FormsModule], exports: [PasswordInputComponent] }); })();

const fallbackVats = [
    {
        prefix: "IT",
        name: "Italy (Italia)",
        regex: /^IT[0-9]{11}$|^IT[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/
    },
    {
        prefix: "BE",
        name: "Belgium (Belgique)",
        regex: /.*/
    },
    {
        prefix: "BG",
        name: "Bulgaria (България)",
        regex: /.*/
    },
    {
        prefix: "CZ",
        name: "Czechia (Česká republika)",
        regex: /.*/
    },
    {
        prefix: "DK",
        name: "Denmark (Kongeriget Danmark)",
        regex: /.*/
    },
    {
        prefix: "DE",
        name: "Germany (Bundesrepublik Deutschland)",
        regex: /.*/
    },
    {
        prefix: "EE",
        name: "Estonia (Eesti Vabariik)",
        regex: /.*/
    },
    {
        prefix: "IE",
        name: "Ireland (Éire)",
        regex: /.*/
    },
    {
        prefix: "EL",
        name: "Greece (Ελλάδα)",
        regex: /.*/
    },
    {
        prefix: "ES",
        name: "Spain (España)",
        regex: /.*/
    },
    {
        prefix: "FR",
        name: "France (France)",
        regex: /.*/
    },
    {
        prefix: "HR",
        name: "Croatia (Republika Hrvatska)",
        regex: /.*/
    },
    {
        prefix: "CY",
        name: "Cyprus (Κύπρος)",
        regex: /.*/
    },
    {
        prefix: "LV",
        name: "Latvia (Latvijas Republika)",
        regex: /.*/
    },
    {
        prefix: "LT",
        name: "Lithuania (Kongeriget Danmark)",
        regex: /.*/
    },
    {
        prefix: "LU",
        name: "Luxembourg (Groussherzogtum Lëtzebuerg)",
        regex: /.*/
    },
    {
        prefix: "HU",
        name: "Hungary (Magyarország)",
        regex: /.*/
    },
    {
        prefix: "MT",
        name: "Malta (Repubblika ta' Malta)",
        regex: /.*/
    },
    {
        prefix: "NL",
        name: "Netherlands (Nederland)",
        regex: /.*/
    },
    {
        prefix: "AT",
        name: "Austria (Ésterreich)",
        regex: /.*/
    },
    {
        prefix: "PL",
        name: "Poland (Rzeczpospolita Polska)",
        regex: /.*/
    },
    {
        prefix: "PT",
        name: "Portugal (Portugal)",
        regex: /.*/
    },
    {
        prefix: "RO",
        name: "Romania (România)",
        regex: /.*/
    },
    {
        prefix: "SI",
        name: "Slovenia (Republika Slovenija)",
        regex: /.*/
    },
    {
        prefix: "SK",
        name: "Slovakia (Slovensko)",
        regex: /.*/
    },
    {
        prefix: "FI",
        name: "Finland (Suomi)",
        regex: /.*/
    },
    {
        prefix: "SE",
        name: "Sweden (Sverige)",
        regex: /.*/
    },
    {
        prefix: "GB",
        name: "United Kingdom (United Kingdom)",
        regex: /.*/
    },
    {
        prefix: "IS",
        name: "Iceland (Lýðveldið Ísland)",
        regex: /.*/
    },
    {
        prefix: "LI",
        name: "Liechtenstein (Liechtenstein)",
        regex: /.*/
    },
    {
        prefix: "NO",
        name: "Norway (Kongeriket Norge)",
        regex: /.*/
    },
    {
        prefix: "CH",
        name: "Switzerland (Schweizerische Eidgenossenschaft)",
        regex: /.*/
    },
    // NEW
    {
        prefix: "AL",
        name: "Albania (Republika e Shqipërisë)",
        regex: /.*/
    },
    {
        prefix: "MK",
        name: "North Macedonia (Република Северна Македонија)",
        regex: /.*/
    },
    {
        prefix: "AU",
        name: "Australia (Commonwealth of Australia)",
        regex: /.*/
    },
    {
        prefix: "BY",
        name: "Belarus (Белару́сь)",
        regex: /.*/
    },
    {
        prefix: "CA",
        name: "Canada (Canada)",
        regex: /.*/
    },
    {
        prefix: "IN",
        name: "India (भारत गणराज्य)",
        regex: /.*/
    },
    {
        prefix: "ID",
        name: "Indonesia (Republik Indonesia)",
        regex: /.*/
    },
    {
        prefix: "IL",
        name: "Israel (دولة اسرائيل)",
        regex: /.*/
    },
    {
        prefix: "KZ",
        name: "Kazakhstan (Қазақстан Республикасы)",
        regex: /.*/
    },
    {
        prefix: "NZ",
        name: "New Zealand (New Zealand)",
        regex: /.*/
    },
    {
        prefix: "NG",
        name: "Nigeria (Federal Republic of Nigeria)",
        regex: /.*/
    },
    {
        prefix: "PH",
        name: "Philippines (Republika ng Pilipinas)",
        regex: /.*/
    },
    {
        prefix: "RU",
        name: "Russia (Росси́йская Федера́ция)",
        regex: /.*/
    },
    {
        prefix: "SA",
        name: "Saudi Arabia (المملكة العربية السعودية)",
        regex: /.*/
    },
    {
        prefix: "RS",
        name: "Serbia (Република Србија)",
        regex: /.*/
    },
    {
        prefix: "TR",
        name: "Turkey (Türkiye Cumhuriyeti)",
        regex: /.*/
    },
    {
        prefix: "UA",
        name: "Ukraine (Українська Народна Республіка)",
        regex: /.*/
    },
    {
        prefix: "UZ",
        name: "Uzbekistan (O‘zbekiston Respublikasi)",
        regex: /.*/
    },
    {
        prefix: "AR",
        name: "Argentina (República Argentina)",
        regex: /.*/
    },
    {
        prefix: "BO",
        name: "Bolivia (Estado Plurinacional de Bolivia)",
        regex: /.*/
    },
    {
        prefix: "BR",
        name: "Brazil (República Federativa do Brasil)",
        regex: /.*/
    },
    {
        prefix: "CL",
        name: "Chile (República de Chile)",
        regex: /.*/
    },
    {
        prefix: "CO",
        name: "Colombia (República de Colombia)",
        regex: /.*/
    },
    {
        prefix: "CR",
        name: "Costa Rica (República de Costa Rica)",
        regex: /.*/
    },
    {
        prefix: "EC",
        name: "Ecuador (República de Ecuador)",
        regex: /.*/
    },
    {
        prefix: "SV",
        name: "El Salvador (República de El Salvador)",
        regex: /.*/
    },
    {
        prefix: "GT",
        name: "Guatemala (Guatemala)",
        regex: /.*/
    },
    {
        prefix: "HN",
        name: "Honduras (República de Honduras)",
        regex: /.*/
    },
    {
        prefix: "MX",
        name: "Mexico (Estados Unidos Mexicanos)",
        regex: /.*/
    },
    {
        prefix: "NI",
        name: "Nicaragua (República de Nicaragua)",
        regex: /.*/
    },
    {
        prefix: "PA",
        name: "Panama (República de Panamá)",
        regex: /.*/
    },
    {
        prefix: "PY",
        name: "Paraguay (República del Paraguay)",
        regex: /.*/
    },
    {
        prefix: "PE",
        name: "Peru (República del Perú)",
        regex: /.*/
    },
    {
        prefix: "DO",
        name: "Dominican Republic (República Dominicana)",
        regex: /.*/
    },
    {
        prefix: "UY",
        name: "Uruguay (República Oriental del Uruguay)",
        regex: /.*/
    },
    {
        prefix: "VE",
        name: "Venezuela (República Bolivariana de Venezuela)",
        regex: /.*/
    }
];
const localTranslations = {
    'it': {
        'search': 'Cerca',
        'no-results': 'Nessun risultato',
        'placeholder': '0123456789'
    },
    'en': {
        'search': 'Search',
        'no-results': 'No results',
        'placeholder': '0123456789'
    }
};

class ClickOutsideDirective$2 {
    constructor(el) {
        this.el = el;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside)
            this.clickOutside.emit();
    }
}
ClickOutsideDirective$2.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective$2)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ClickOutsideDirective$2.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClickOutsideDirective$2, selectors: [["", "clickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective$2, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

function VatFieldComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function VatFieldComponent_div_8_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const v_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.handleSelection(v_r3); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(v_r3.prefix);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(v_r3.name);
} }
function VatFieldComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, VatFieldComponent_div_8_div_1_Template, 5, 2, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayedVats);
} }
function VatFieldComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.translations[ctx_r1._language]["no-results"]);
} }
const _c0$a = function (a0, a1) { return { "vox-input-group-field_focus": a0, "vox-input-group-field_dense": a1 }; };
const _c1$9 = function (a0) { return { "d-none": a0 }; };
const _c2$9 = function (a0) { return { show: a0 }; };
const _c3$7 = function (a0) { return { "dropdown-item_search-field_dense": a0 }; };
class VatFieldComponent {
    // Private variables
    constructor() {
        //Control Value Accessor variables
        this.onChange = (_) => { };
        this.onTouch = (_) => { };
        //Input / Output variables
        this.dense = false;
        this.locked = false;
        this._language = 'en';
        // Public variables
        this.ddVisible = false;
        this.vat = "";
        this.selectedVat = null;
        this._vatsInfo = fallbackVats;
        this.translations = localTranslations;
        this.filterString = "";
        this.focus = false;
        this.isFocus = new EventEmitter();
    }
    set vatsInfo(v) {
        const tmp = this._vatsInfo;
        this._vatsInfo = v ? v : fallbackVats;
        // if the list changed
        // let's search if we have the selected country
        if (this._vatsInfo !== tmp) {
            // if no selected vat return null from the search
            let vat = this.selectedVat ?
                this._vatsInfo.find(vt => vt.prefix.toLowerCase() === this.selectedVat.prefix.toLowerCase()) :
                null;
            if (!vat) {
                this.selectedVat = this._vatsInfo[0];
                setTimeout(() => { this.onChange(this.outputValue()); }, 0);
            }
        }
    }
    set defaultVat(v) {
        if (!v && !this.selectedVat) {
            this.selectedVat = this._vatsInfo[0];
        }
        if (v) {
            let vat = this._vatsInfo.find(vt => vt.prefix.toLowerCase() === v.toLowerCase());
            if (vat) {
                this.selectedVat = vat;
                setTimeout(() => { this.onChange(this.outputValue()); }, 0);
            }
        }
    }
    ;
    set language(v) {
        const lowerV = v && v.toLowerCase(); // to avoid case errors
        this._language = localTranslations[lowerV] ? lowerV : 'en';
    }
    ngOnInit() {
        // if we set a valid vat in default vat then selectedVat will be that
        // otherwise the first
        this.selectedVat = this.selectedVat || this._vatsInfo[0];
        this.displayedVats = this._vatsInfo;
    }
    handleVatInput(e) {
        this.vat = e.target.value.toUpperCase();
        this.onChange(this.outputValue());
    }
    handleFilter(e) {
        this.filterString = e.target.value;
        let temp = [];
        const re = new RegExp(`${this.filterString}`, "i");
        this._vatsInfo.forEach((vat) => {
            if (re.test(vat.prefix) || re.test(vat.name)) {
                temp.push(vat);
            }
        });
        this.displayedVats = temp;
    }
    handleSelection(v) {
        if (v) {
            this.selectedVat = v;
            this.onChange(this.outputValue());
            this.close();
        }
    }
    formatVat() {
        if (this.vat === "")
            return this.selectedVat.prefix;
        return this.vat.startsWith(this.selectedVat.prefix)
            ? this.vat
            : `${this.selectedVat.prefix}${this.vat}`;
    }
    outputValue() {
        return { country: this.selectedVat.prefix, vat: this.vat };
    }
    onFocus() {
        this.focus = true;
        this.isFocus.emit(true);
    }
    onBlur() {
        this.focus = false;
        this.isFocus.emit(false);
    }
    toggle() {
        this.ddVisible ? this.close() : this.open();
    }
    open() {
        this.focus = true;
        if (this._vatsInfo.length > 1)
            this.ddVisible = true;
    }
    close() {
        this.focus = false;
        this.ddVisible = false;
        this.displayedVats = this._vatsInfo;
        this.filterString = "";
    }
    writeValue(obj) {
        if (obj && obj.country && obj.vat) {
            this.handleSelection(this._vatsInfo.find(v => v.prefix === obj.country.toUpperCase()) || this._vatsInfo[0]);
            this.vat = obj.vat;
        }
        else {
            this.vat = '';
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    validate(control) {
        if (RegExp(this.selectedVat.regex).test(this.formatVat())) {
            return null;
        }
        else {
            return { invalidVat: "Invalid Vat" };
        }
    }
}
VatFieldComponent.ɵfac = function VatFieldComponent_Factory(t) { return new (t || VatFieldComponent)(); };
VatFieldComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VatFieldComponent, selectors: [["vox-vat-field"]], inputs: { dense: "dense", vatsInfo: "vatsInfo", defaultVat: "defaultVat", placeholder: "placeholder", locked: "locked", language: "language" }, outputs: { isFocus: "isFocus" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => VatFieldComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => VatFieldComponent),
                multi: true
            }
        ])], decls: 11, vars: 21, consts: [[1, "vox-input-group-field", 3, "ngClass", "clickOutside"], ["type", "button", 1, "vox-input-group-field_toggle", 3, "disabled", "click"], [1, "icon-small-arrow-dropdown", 3, "ngClass"], [1, "dropdown-menu", 3, "ngClass"], [1, "dropdown-item_search"], [1, "icon-small-search"], ["type", "text", 1, "dropdown-item_search-field", 3, "ngClass", "placeholder", "value", "input"], ["class", "dropdown-item_scroll", 4, "ngIf"], ["type", "text", 1, "vox-input-group-field_input", 3, "value", "placeholder", "input", "focus", "blur"], [1, "dropdown-item_scroll"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"], [1, "dropdown-item"]], template: function VatFieldComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("clickOutside", function VatFieldComponent_Template_div_clickOutside_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵlistener("click", function VatFieldComponent_Template_button_click_1_listener() { return ctx.toggle(); });
        i0.ɵɵtext(2);
        i0.ɵɵelement(3, "i", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "i", 5);
        i0.ɵɵelementStart(7, "input", 6);
        i0.ɵɵlistener("input", function VatFieldComponent_Template_input_input_7_listener($event) { return ctx.handleFilter($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, VatFieldComponent_div_8_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(9, VatFieldComponent_div_9_Template, 4, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "input", 8);
        i0.ɵɵlistener("input", function VatFieldComponent_Template_input_input_10_listener($event) { return ctx.handleVatInput($event); })("focus", function VatFieldComponent_Template_input_focus_10_listener() { return ctx.onFocus(); })("blur", function VatFieldComponent_Template_input_blur_10_listener() { return ctx.onBlur(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c0$a, ctx.focus, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.locked);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedVat.prefix, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$9, ctx._vatsInfo.length < 2 || ctx.locked));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c2$9, ctx.ddVisible));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c3$7, ctx.dense))("placeholder", ctx.translations[ctx._language]["search"])("value", ctx.filterString);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayedVats.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayedVats.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.vat)("placeholder", ctx.translations[ctx._language]["placeholder"]);
    } }, directives: [i1.NgClass, ClickOutsideDirective$2, i1.NgIf, i1.NgForOf], styles: [".invalid[_nghost-%COMP%]   .vox-input-group-field[_ngcontent-%COMP%], .invalid   [_nghost-%COMP%]   .vox-input-group-field[_ngcontent-%COMP%]{border-color:#e33!important}.vox-input-group-field[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:row;height:56px;width:100%;font-family:\"GT-Eesti-Pro\";font-size:20px;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:4px;border:2px solid #b5bac2;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field_dense[_ngcontent-%COMP%]{height:40px;font-size:16px}.vox-input-group-field_focus[_ngcontent-%COMP%]{border-color:#000!important;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field[_ngcontent-%COMP%]:hover{border-color:#868990;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field[_ngcontent-%COMP%] ~ *[_ngcontent-%COMP%], .vox-input-group-field_toggle[_ngcontent-%COMP%]{height:100%;display:flex;justify-content:center;align-items:center}.vox-input-group-field_toggle[_ngcontent-%COMP%]{width:4rem;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;background-color:#fff}.vox-input-group-field_toggle[_ngcontent-%COMP%]:active{background-color:#fff}.vox-input-group-field_toggle[_ngcontent-%COMP%]:disabled{color:#000!important}.vox-input-group-field_input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-input-group-field_dropdown[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{padding-top:5px}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;top:calc(100% + 2px);padding-bottom:0!important}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{cursor:pointer}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:last-child{margin-bottom:.5em}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%]{display:flex;padding:0 .5em 5px;font-family:\"GT-Eesti-Pro\";font-size:20px;border-bottom:1px solid #e5e9f0}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{margin-right:5px;padding-top:2px;color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%]   .dropdown-item_search-field_dense[_ngcontent-%COMP%]{font-size:16px}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]::-moz-placeholder{color:#636c72;opacity:1}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{display:inline-block;text-align:center;width:2em;margin-right:1em}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_scroll[_ngcontent-%COMP%]{max-height:6em;overflow-x:hidden;overflow-y:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VatFieldComponent, [{
        type: Component,
        args: [{
                selector: "vox-vat-field",
                templateUrl: "./vat-field.component.html",
                styleUrls: ["./vat-field.component.scss"],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => VatFieldComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => VatFieldComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { dense: [{
            type: Input
        }], vatsInfo: [{
            type: Input
        }], defaultVat: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], locked: [{
            type: Input
        }], language: [{
            type: Input
        }], isFocus: [{
            type: Output
        }] }); })();

class VoxVatFieldModule {
}
VoxVatFieldModule.ɵfac = function VoxVatFieldModule_Factory(t) { return new (t || VoxVatFieldModule)(); };
VoxVatFieldModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxVatFieldModule });
VoxVatFieldModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxVatFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [VatFieldComponent, ClickOutsideDirective$2],
                imports: [CommonModule, FormsModule],
                exports: [VatFieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxVatFieldModule, { declarations: [VatFieldComponent, ClickOutsideDirective$2], imports: [CommonModule, FormsModule], exports: [VatFieldComponent] }); })();

class ClickOutsideDirective$1 {
    constructor(el) {
        this.el = el;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
ClickOutsideDirective$1.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective$1)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ClickOutsideDirective$1.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClickOutsideDirective$1, selectors: [["", "clickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective$1, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

class TimezoneNamePipe {
    constructor() { }
    transform(value) {
        return value.replace(/_/g, ' ');
    }
}
TimezoneNamePipe.ɵfac = function TimezoneNamePipe_Factory(t) { return new (t || TimezoneNamePipe)(); };
TimezoneNamePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "timezoneName", type: TimezoneNamePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimezoneNamePipe, [{
        type: Pipe,
        args: [{
                name: 'timezoneName',
                pure: true
            }]
    }], function () { return []; }, null); })();

const _c0$9 = ["filterEl"];
function TimezoneInputComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function TimezoneInputComponent_div_12_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const t_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.handleSelection(t_r2); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "timezoneName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, t_r2));
} }
const _c1$8 = function (a0, a1) { return { "vox-input-group-field_focus": a0, "vox-input-group-field_dense": a1 }; };
const _c2$8 = function (a0) { return { "d-none": a0 }; };
const _c3$6 = function (a0) { return { "show": a0 }; };
class TimezoneInputComponent {
    constructor() {
        // Public variables
        this.ddVisible = false;
        this.timezones = [];
        this.selectedTimezone = null;
        this.focus = false;
        this.filterString = '';
        this.dense = false;
        this.onChange = (_) => { };
        this.onTouch = (_) => { };
        this.timezones = moment.tz.names();
    }
    ngAfterViewChecked() {
        if (this.focus) {
            this.filterInput.nativeElement.focus();
        }
    }
    open() {
        this.focus = true;
        if (this.timezones.length > 1) {
            this.ddVisible = true;
        }
    }
    close() {
        this.focus = false;
        this.ddVisible = false;
        this.filterString = '';
    }
    toggle() {
        this.ddVisible ? this.close() : this.open();
    }
    get filteredTimezones() {
        if (this.filterString) {
            return this.timezones.filter((e) => e.toLowerCase().includes(this.filterString.toLowerCase()));
        }
        else {
            return this.timezones;
        }
    }
    writeValue(obj) {
        this.selectedTimezone = obj;
        this.onChange(this.selectedTimezone);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    handleSelection(e) {
        this.selectedTimezone = e;
        this.onChange(this.selectedTimezone);
        this.focus = false;
        this.ddVisible = false;
    }
    handleEnter() {
        this.selectedTimezone = this.filteredTimezones.length >= 1 ? this.filteredTimezones[0] : '';
        this.onChange(this.selectedTimezone);
    }
    handleFilter(term) {
        this.filterString = term;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    validate(control) {
        if (this.selectedTimezone === null) {
            return { invalidTimezone: true };
        }
        else {
            return null;
        }
    }
}
TimezoneInputComponent.ɵfac = function TimezoneInputComponent_Factory(t) { return new (t || TimezoneInputComponent)(); };
TimezoneInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TimezoneInputComponent, selectors: [["vox-timezone-input"]], viewQuery: function TimezoneInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$9, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterInput = _t.first);
    } }, inputs: { dense: "dense" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TimezoneInputComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => TimezoneInputComponent),
                multi: true
            }
        ])], decls: 13, vars: 13, consts: [[1, "vox-input-group-field", 3, "ngClass", "clickOutside"], ["type", "button", 1, "vox-input-group-field_toggle", 3, "click"], [1, "icon-small-arrow-dropdown", 3, "ngClass"], [1, "vox-dropdown", "dropdown", "no-arrow", "vox-input-group-field_dropdown"], [1, "dropdown-menu", 3, "ngClass"], [1, "dropdown-item_search"], [1, "icon-small-search"], ["type", "text", "placeholder", "Search timezone", 1, "dropdown-item_search-field", 3, "value", "input", "keydown.enter"], ["filterEl", ""], [1, "dropdown-item_scroll"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]], template: function TimezoneInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("clickOutside", function TimezoneInputComponent_Template_div_clickOutside_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵlistener("click", function TimezoneInputComponent_Template_button_click_1_listener() { return ctx.toggle(); });
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "i", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelement(8, "i", 6);
        i0.ɵɵelementStart(9, "input", 7, 8);
        i0.ɵɵlistener("input", function TimezoneInputComponent_Template_input_input_9_listener($event) { return ctx.handleFilter($event.target.value); })("keydown.enter", function TimezoneInputComponent_Template_input_keydown_enter_9_listener() { return ctx.handleEnter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵtemplate(12, TimezoneInputComponent_div_12_Template, 4, 3, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$8, ctx.focus, ctx.dense));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.selectedTimezone || "Select timezone");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$8, ctx.filteredTimezones.length < 2));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3$6, ctx.ddVisible));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.filterString);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.filteredTimezones);
    } }, directives: [i1.NgClass, ClickOutsideDirective$1, i1.NgForOf], pipes: [TimezoneNamePipe], styles: [".vox-input-group-field[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:56px;width:100%;font-family:\"GT-Eesti-Pro\";font-size:20px;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:4px;border:2px solid #b5bac2;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field_dense[_ngcontent-%COMP%]{height:40px;font-size:16px}.vox-input-group-field_focus[_ngcontent-%COMP%]{border-color:#000!important;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field[_ngcontent-%COMP%]:hover{border-color:#868990;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-input-group-field[_ngcontent-%COMP%] ~ *[_ngcontent-%COMP%], .vox-input-group-field_toggle[_ngcontent-%COMP%]{height:100%}.vox-input-group-field_toggle[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:100%;text-align:left;line-height:1;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;padding-top:12px;padding-bottom:12px;padding-left:16px;background-color:#fff}.vox-input-group-field_toggle[_ngcontent-%COMP%]:active{background-color:#fff}.vox-input-group-field_toggle[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:18px}.vox-input-group-field_input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-input-group-field_dropdown[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{padding-top:5px}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{right:0}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{cursor:pointer}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%]{display:flex;margin-left:.5em;margin-right:.5em;padding-bottom:5px;font-family:\"GT-Eesti-Pro\";font-size:20px;border-bottom:1px solid #e5e9f0}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{margin-right:5px;padding-top:2px;color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%]   .dropdown-item_search-field_dense[_ngcontent-%COMP%]{font-size:16px}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]::-moz-placeholder{color:#636c72;opacity:1}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#636c72}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{display:inline-block;text-align:center;width:2em;margin-right:1em}.vox-input-group-field[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item_scroll[_ngcontent-%COMP%]{max-height:6em;overflow-x:hidden;overflow-y:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimezoneInputComponent, [{
        type: Component,
        args: [{
                selector: 'vox-timezone-input',
                templateUrl: './timezone-input.component.html',
                styleUrls: ['./timezone-input.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TimezoneInputComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => TimezoneInputComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { filterInput: [{
            type: ViewChild,
            args: ['filterEl']
        }], dense: [{
            type: Input
        }] }); })();

class VoxTimezoneInputModule {
}
VoxTimezoneInputModule.ɵfac = function VoxTimezoneInputModule_Factory(t) { return new (t || VoxTimezoneInputModule)(); };
VoxTimezoneInputModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxTimezoneInputModule });
VoxTimezoneInputModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxTimezoneInputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TimezoneInputComponent,
                    ClickOutsideDirective$1,
                    TimezoneNamePipe
                ],
                imports: [CommonModule, FormsModule],
                exports: [TimezoneInputComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxTimezoneInputModule, { declarations: [TimezoneInputComponent,
        ClickOutsideDirective$1,
        TimezoneNamePipe], imports: [CommonModule, FormsModule], exports: [TimezoneInputComponent] }); })();

const TRANSLATIONS$5 = {
    it: {
        "filter-placeholder": "Cerca...",
        "no-selected": "Nessun prefisso selezionato",
        "no-results": "Nessun risultato",
        "error-fetching-message": "Errore nel recupero dei prefissi. Clicca qui per riprovare"
    },
    en: {
        "filter-placeholder": "Search",
        "no-selected": "No prefix selected",
        "no-results": "No results",
        "error-fetching-message": "Error retrieving prefixes. Click here to retry"
    }
};

class Environment {
}

class SelectPrefixService {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    getPrefixes(country, locale) {
        // in case there is no interceptor that set this, we set it as the locale passed to the component
        const headers = new HttpHeaders({ 'Accept-Language': locale });
        return this.http.get(`${this.environment.apiUrl}/api/v1/coverage/countries/${country}/areas`, {
            headers: headers
        });
    }
}
SelectPrefixService.ɵfac = function SelectPrefixService_Factory(t) { return new (t || SelectPrefixService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(Environment)); };
SelectPrefixService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectPrefixService, factory: SelectPrefixService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectPrefixService, [{
        type: Injectable
    }], function () { return [{ type: i1$1.HttpClient }, { type: Environment }]; }, null); })();

class ClickOutsideDirective {
    constructor(el) {
        this.el = el;
        this.clickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
ClickOutsideDirective.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ClickOutsideDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ClickOutsideDirective, selectors: [["", "clickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, i0.ɵɵresolveDocument);
    } }, outputs: { clickOutside: "clickOutside" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { clickOutside: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }] }); })();

const _c0$8 = ["filterEl"];
function SelectPrefixComponent_button_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r5.selectedPrefix.code, " ", ctx_r5.selectedPrefix.localized_name, " ");
} }
function SelectPrefixComponent_button_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.translations[ctx_r6._language]["no-selected"]);
} }
const _c1$7 = function (a0) { return { "vox-input-group-field_toggle-focus": a0 }; };
function SelectPrefixComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function SelectPrefixComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.toggle(); });
    i0.ɵɵtemplate(1, SelectPrefixComponent_button_2_span_1_Template, 2, 2, "span", 14);
    i0.ɵɵtemplate(2, SelectPrefixComponent_button_2_span_2_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$7, ctx_r0.focus))("disabled", ctx_r0.isDisabled)("ladda", ctx_r0.isFetching);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedPrefix);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.selectedPrefix);
} }
function SelectPrefixComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function SelectPrefixComponent_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.refresh(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.translations[ctx_r1._language]["error-fetching-message"]);
} }
function SelectPrefixComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function SelectPrefixComponent_div_11_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const p_r11 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.selectPrefix(p_r11); });
    i0.ɵɵelementStart(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(p_r11.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", p_r11.localized_name, " ");
} }
function SelectPrefixComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.translations[ctx_r4._language]["no-results"]);
} }
const _c2$7 = function (a0) { return { "vox-input-group-field_dense": a0 }; };
const _c3$5 = function (a0) { return { "show": a0 }; };
class SelectPrefixComponent {
    constructor(prefixService) {
        this.prefixService = prefixService;
        // I/O variables
        this._language = 'en';
        this._country = 'IT';
        // I/O
        this.dense = false;
        // Dropdown status
        this.ddopen = false;
        this.focus = false;
        // Component properties
        this.shouldDownload = true;
        this.prefixList = [];
        this.filteredPrefixList = this.prefixList;
        this.isFetching = false;
        this.errorFetching = false;
        this.translations = TRANSLATIONS$5;
        // Control value accessor callbacks and variables
        this.isDisabled = false;
        this.firstRun = true;
        this.onChange = (_) => { };
        this.onTouch = (_) => { };
    }
    set language(v) {
        if (v && v !== this._language) {
            this._language = v.toLowerCase();
            this.getPrefixes();
        }
    }
    ;
    set country(v) {
        if (v && v !== this._country) {
            this._country = v.toUpperCase();
            // no sense in keeping this if we change country
            if (this.shouldDownload) {
                this.selectedPrefix = null;
                this.onChange(this.selectedPrefix);
            }
            ;
            this.getPrefixes();
        }
    }
    set customPrefixList(v) {
        if (v) {
            this.firstRun = false;
            // if we use a custom list passed, we should disable the download
            this.prefixList = v;
            this.filteredPrefixList = this.prefixList;
            this.selectedPrefix = null;
            this.onChange(this.selectedPrefix);
            this.filterInput.nativeElement.value = "";
            this.shouldDownload = false;
            this.errorFetching = false;
        }
        else {
            // if we pass null or undefined then we reenable the download
            this.shouldDownload = true;
            this.selectedPrefix = null;
            this.onChange(this.selectedPrefix);
            this.getPrefixes();
        }
    }
    set disabled(v) {
        this.isDisabled = v ? true : false;
    }
    ngOnInit() {
        // if should download then download the prefixes
        this.getPrefixes();
    }
    ngAfterViewChecked() {
        if (this.focus) {
            this.filterInput.nativeElement.focus();
        }
    }
    getPrefixes() {
        if (this.shouldDownload) {
            this.isFetching = true;
            this.prefixService.getPrefixes(this._country, this._language).subscribe((prefixes) => {
                // we don't know which input get called first so if it's not custom list
                // let's try to check also here if we need to show what we get from
                // backend
                if (!this.shouldDownload) {
                    this.isFetching = false;
                    return;
                }
                this.firstRun = false;
                this.prefixList = prefixes;
                this.filteredPrefixList = prefixes;
                if (this.selectedPrefix) {
                    this.selectedPrefix = this.filteredPrefixList.find(p => p.code === this.selectedPrefix.code);
                    this.onChange(this.selectedPrefix);
                }
                else if (this.writeValueTmp) {
                    this.parseWriteValue(this.writeValueTmp);
                    this.writeValueTmp = null;
                }
                this.isFetching = false;
                this.errorFetching = false;
            }, (error) => {
                this.isFetching = false;
                this.errorFetching = true;
            });
        }
        else {
            // if we have a custom list we just reset the filtered one
            this.filteredPrefixList = this.prefixList;
        }
    }
    selectPrefix(prefix) {
        this.selectedPrefix = prefix;
        this.close();
        this.onChange(this.selectedPrefix);
    }
    onFilterChange(term) {
        if (term.length > 0) {
            this.filteredPrefixList = this.prefixList.filter(p => p.code.includes(term) || p.localized_name.toLowerCase().includes(term.toLowerCase()));
        }
        else {
            this.filteredPrefixList = this.prefixList;
        }
    }
    refresh() {
        this.getPrefixes();
    }
    close() {
        this.focus = false;
        this.ddopen = false;
    }
    open() {
        this.focus = true;
        this.ddopen = true;
    }
    toggle() {
        this.ddopen ? this.close() : this.open();
    }
    parseWriteValue(obj) {
        if (typeof obj === 'object') {
            // prefix model
            this.selectedPrefix = this.prefixList.find(p => p.code === obj.code);
        }
        else {
            // string
            this.selectedPrefix = this.prefixList.find(p => p.code === obj ||
                p.localized_name === obj ||
                `${p.code} ${p.localized_name}` === obj ||
                `${p.code}${p.localized_name}` === obj);
        }
        this.onChange(this.selectPrefix);
    }
    // Control Value Accessor section
    writeValue(obj) {
        if (this.prefixList.length > 0) {
            // Empty so maybe we have yet to fetch it
            this.parseWriteValue(obj);
        }
        else if (this.firstRun) {
            this.writeValueTmp = obj;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
}
SelectPrefixComponent.ɵfac = function SelectPrefixComponent_Factory(t) { return new (t || SelectPrefixComponent)(i0.ɵɵdirectiveInject(SelectPrefixService)); };
SelectPrefixComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectPrefixComponent, selectors: [["vox-select-prefix"]], viewQuery: function SelectPrefixComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$8, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterInput = _t.first);
    } }, inputs: { dense: "dense", language: "language", country: "country", customPrefixList: "customPrefixList", disabled: "disabled" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SelectPrefixComponent),
                multi: true
            },
        ])], decls: 13, vars: 11, consts: [[1, "vox-select-prefix"], [1, "vox-input-group-field", 3, "ngClass", "clickOutside"], ["class", "vox-input-group-field_toggle dropdown-toggle", "type", "button", "data-style", "zoom-in", "data-spinner-color", "gray", 3, "ngClass", "disabled", "ladda", "click", 4, "ngIf"], ["class", "vox-input-group-field_toggle retry-fetching", 3, "click", 4, "ngIf"], [1, "vox-dropdown-input", "dropdown", "no-arrow", "vox-input-group-field_dropdown"], [1, "dropdown-menu", 3, "ngClass"], [1, "dropdown-item_search"], [1, "icon-small-search"], ["type", "text", 1, "dropdown-item_search-field", 3, "placeholder", "input"], ["filterEl", ""], ["itemSize", "32", 1, "vox-select-prefix__cdk-viewport"], ["class", "dropdown-item", 3, "click", 4, "cdkVirtualFor", "cdkVirtualForOf"], ["class", "dropdown-item dropdown-item dropdown-item_disabled", "disabled", "", 4, "ngIf"], ["type", "button", "data-style", "zoom-in", "data-spinner-color", "gray", 1, "vox-input-group-field_toggle", "dropdown-toggle", 3, "ngClass", "disabled", "ladda", "click"], [4, "ngIf"], [1, "vox-input-group-field_toggle", "retry-fetching", 3, "click"], [1, "icon-small-alert"], [1, "dropdown-item", 3, "click"], [1, "dropdown-item_code"], ["disabled", "", 1, "dropdown-item", "dropdown-item", "dropdown-item_disabled"]], template: function SelectPrefixComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("clickOutside", function SelectPrefixComponent_Template_div_clickOutside_1_listener() { return ctx.close(); });
        i0.ɵɵtemplate(2, SelectPrefixComponent_button_2_Template, 3, 7, "button", 2);
        i0.ɵɵtemplate(3, SelectPrefixComponent_div_3_Template, 4, 1, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "i", 7);
        i0.ɵɵelementStart(8, "input", 8, 9);
        i0.ɵɵlistener("input", function SelectPrefixComponent_Template_input_input_8_listener($event) { return ctx.onFilterChange($event.target.value); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "cdk-virtual-scroll-viewport", 10);
        i0.ɵɵtemplate(11, SelectPrefixComponent_div_11_Template, 4, 2, "div", 11);
        i0.ɵɵtemplate(12, SelectPrefixComponent_div_12_Template, 3, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$7, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.errorFetching);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errorFetching);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$5, ctx.ddopen));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("placeholder", ctx.translations[ctx._language]["filter-placeholder"]);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("cdkVirtualForOf", ctx.filteredPrefixList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filteredPrefixList.length === 0);
    } }, directives: [i1.NgClass, ClickOutsideDirective, i1.NgIf, i4.CdkVirtualScrollViewport, i4.CdkFixedSizeVirtualScroll, i4.CdkVirtualForOf, i3.LaddaDirective], styles: [".vox-select-prefix .vox-input-group-field{display:flex;flex-direction:column;height:56px;width:100%;font-family:\"GT-Eesti-Pro\";font-size:20px;-webkit-appearance:none;-moz-appearance:none;appearance:none}.vox-select-prefix .vox-input-group-field_dense{height:40px;font-size:16px}.vox-select-prefix .vox-input-group-field .retry-fetching:hover{cursor:pointer}.vox-select-prefix .vox-input-group-field~*,.vox-select-prefix .vox-input-group-field_toggle{height:100%}.vox-select-prefix .vox-input-group-field_toggle{display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:#000;width:100%;text-align:left;line-height:1;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;padding:12px 16px;background-color:#fff;border-radius:4px;border:2px solid #b5bac2;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-select-prefix .vox-input-group-field_toggle-focus{border-color:#000!important;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-select-prefix .vox-input-group-field_toggle:hover{border-color:#868990;transition-property:border;-o-transition-property:border;-webkit-transition-property:border;-moz-transition-property:border;transition-duration:.3s;-o-transition-duration:.3s;-webkit-transition-duration:.3s;-moz-transition-duration:.3s;transition-timing-function:ease-out;-o-transition-timing-function:ease-out;-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out}.vox-select-prefix .vox-input-group-field_toggle:active{background-color:#fff}.vox-select-prefix .vox-input-group-field_toggle:disabled{border:2px solid #e5e9f0!important;background-color:#e5e9f0!important}.vox-select-prefix .vox-input-group-field_toggle>span{font-size:18px}.vox-select-prefix .vox-input-group-field_input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-select-prefix .vox-input-group-field_dropdown>button>i{padding-top:5px}.vox-select-prefix .vox-input-group-field .dropdown-menu{padding-bottom:0;right:0;height:196px}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item{cursor:pointer}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_disabled{cursor:not-allowed}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_disabled:hover{background-color:#fff}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_disabled:active,.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_disabled:focus{background-color:#fff}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search{display:flex;padding:.3em .5em 5px;font-family:\"GT-Eesti-Pro\";font-size:20px;border-bottom:1px solid #e5e9f0}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search>i{margin-right:5px;padding-top:2px;color:#636c72}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search .dropdown-item_search-field_dense{font-size:16px}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search>input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search>input::-moz-placeholder{color:#636c72;opacity:1}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search>input:-ms-input-placeholder{color:#636c72}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item_search>input::-webkit-input-placeholder{color:#636c72}.vox-select-prefix .vox-input-group-field .dropdown-menu .dropdown-item span:first-child{display:inline-block;text-align:left;margin-right:1em}.vox-select-prefix .vox-input-group-field .ladda-label{width:100%;display:flex;justify-content:space-between;align-items:center}.vox-select-prefix cdk-virtual-scroll-viewport{height:142px}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectPrefixComponent, [{
        type: Component,
        args: [{
                selector: 'vox-select-prefix',
                templateUrl: './select-prefix.component.html',
                styleUrls: ['./select-prefix.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectPrefixComponent),
                        multi: true
                    },
                ],
                encapsulation: ViewEncapsulation.None // hopefully this will not cause problems
            }]
    }], function () { return [{ type: SelectPrefixService }]; }, { dense: [{
            type: Input
        }], language: [{
            type: Input
        }], country: [{
            type: Input
        }], customPrefixList: [{
            type: Input
        }], disabled: [{
            type: Input
        }], filterInput: [{
            type: ViewChild,
            args: ['filterEl']
        }] }); })();

class VoxSelectPrefixModule {
    static forRoot(environment) {
        return {
            ngModule: VoxSelectPrefixModule,
            providers: [
                SelectPrefixService,
                {
                    provide: Environment,
                    useValue: environment
                }
            ]
        };
    }
}
VoxSelectPrefixModule.ɵfac = function VoxSelectPrefixModule_Factory(t) { return new (t || VoxSelectPrefixModule)(); };
VoxSelectPrefixModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxSelectPrefixModule });
VoxSelectPrefixModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [SelectPrefixService], imports: [[
            CommonModule,
            FormsModule,
            HttpClientModule,
            ScrollingModule,
            LaddaModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxSelectPrefixModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectPrefixComponent, ClickOutsideDirective],
                imports: [
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    ScrollingModule,
                    LaddaModule
                ],
                providers: [SelectPrefixService],
                exports: [SelectPrefixComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxSelectPrefixModule, { declarations: [SelectPrefixComponent, ClickOutsideDirective], imports: [CommonModule,
        FormsModule,
        HttpClientModule,
        ScrollingModule,
        LaddaModule], exports: [SelectPrefixComponent] }); })();

const TRANSLATIONS$4 = {
    it: {
        "label": "Etichetta",
        "description": "Descrizione",
        "type": "Tipo",
        "company-name": "Nome company",
        "vat-number": "Codice fiscale / Partita IVA",
        "personal-data": "Dati personali",
        "fiscal_code": "Fiscal code",
        "birth-date": "Data di nascita",
        "birth-place": "Luogo di nascita",
        "nationality": "Nazionalità",
        "contacts": "Contatti",
        "document-information": {
            "title": "Informazioni del documento",
            "type": "Tipo",
            "number": "Numero",
            "issued-by": "Rilasciato da",
            "issued-date": "Rilasciato il"
        },
        "attached-documents": "Documenti allegati",
        "empty": "Non sono presenti dati di verifica da utilizzare, per favore creane uno.",
        "creation-date": "Data di creazione",
        "last-update-date": "Data di ultima modifica"
    },
    en: {
        "label": "Label",
        "description": "Description",
        "type": "Type",
        "company-name": "Company name",
        "vat-number": "Tax / VAT number",
        "fiscal_code": "Fiscal code",
        "personal-data": "Personal data",
        "birth-date": "Birth date",
        "birth-place": "Birth place",
        "nationality": "Nationality",
        "contacts": "Contacts",
        "document-information": {
            "title": "Document information",
            "type": "Type",
            "number": "Number",
            "issued-by": "Issued by",
            "issued-date": "Issued date"
        },
        "attached-documents": "Attached documents",
        "empty": "There is no verification data to use, please create one first.",
        "creation-date": "Creation date",
        "last-update-date": "Last update date"
    }
};

function VerificationDataTableReadonlyComponent_div_0_table_1_tr_2_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(2, 1, ctx_r24.data.creation_date, "longDate", undefined, ctx_r24._language));
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_2_span_5_Template, 3, 6, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.translations[ctx_r4._language]["creation-date"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.data.creation_date);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(2, 1, ctx_r25.data.updated_date, "longDate", undefined, ctx_r25._language));
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_3_span_5_Template, 3, 6, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.translations[ctx_r5._language]["last-update-date"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.data.updated_date);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r6.data.type));
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_11_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r26.data.company_name);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_11_span_5_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r8.translations[ctx_r8._language]["company-name"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.data.company_name);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_12_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r27.data.tax_number);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_12_span_5_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r9.translations[ctx_r9._language]["vat-number"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.data.tax_number);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.data.fiscal_code);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_25_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r28.data.salutation, " ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, VerificationDataTableReadonlyComponent_div_0_table_1_span_25_span_1_Template, 2, 1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.data.salutation);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r12.data.first_name, " ", ctx_r12.data.last_name, " ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_27_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, ctx_r29.data.birth_date, "shortDate", undefined, ctx_r29._language), " ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_27_span_5_Template, 3, 6, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.translations[ctx_r14._language]["birth-date"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r14.data.birth_date);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_28_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.data.birth_place, " ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_28_span_5_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r15.translations[ctx_r15._language]["birth-place"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r15.data.birth_place);
} }
const _c0$7 = function (a1) { return ["flag flag-icon", a1]; };
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_29_i_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$7, "flag-icon-" + ctx_r31.data.nationality.toLowerCase()))("title", ctx_r31.data.nationality);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, VerificationDataTableReadonlyComponent_div_0_table_1_tr_29_i_5_Template, 1, 4, "i", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r16.translations[ctx_r16._language]["nationality"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r16.data.nationality);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r17.data.email, ", ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_37_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, VerificationDataTableReadonlyComponent_div_0_table_1_span_37_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r18.data.phone_number);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.data.address);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$7, "flag-icon-" + ctx_r19.data.address.country_code.toLowerCase()))("title", ctx_r19.data.address.country_code.toLowerCase());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3(" ", ctx_r19.data.address.street_name, " ", ctx_r19.data.address.street_number, " ", ctx_r19.data.address.city, " ");
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(2, 1, ctx_r33.documentData.issuing_date, "longDate", undefined, ctx_r33._language));
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "-");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelementStart(7, "span", 17);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 18);
    i0.ɵɵelementStart(12, "span", 17);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 19);
    i0.ɵɵelementStart(17, "span", 17);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 20);
    i0.ɵɵelementStart(22, "span", 17);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_span_24_Template, 3, 6, "span", 3);
    i0.ɵɵtemplate(25, VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_span_25_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r21.translations[ctx_r21._language]["document-information"]["title"]);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", ctx_r21.translations[ctx_r21._language]["document-information"]["type"], ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r21.documentData.type ? ctx_r21.documentData.type : "-");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r21.translations[ctx_r21._language]["document-information"]["number"], ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r21.documentData.number ? ctx_r21.documentData.number : "-");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r21.translations[ctx_r21._language]["document-information"]["issued-by"], ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r21.documentData.issuing_authority ? ctx_r21.documentData.issuing_authority : "-");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r21.translations[ctx_r21._language]["document-information"]["issued-date"], ":");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.documentData.issuing_date);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r21.documentData.issuing_date);
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_span_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " - ");
    i0.ɵɵelementEnd();
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_li_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const document_r35 = ctx.$implicit;
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", document_r35.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.getDocName(document_r35));
} }
function VerificationDataTableReadonlyComponent_div_0_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵelementStart(1, "tbody");
    i0.ɵɵtemplate(2, VerificationDataTableReadonlyComponent_div_0_table_1_tr_2_Template, 6, 2, "tr", 3);
    i0.ɵɵtemplate(3, VerificationDataTableReadonlyComponent_div_0_table_1_tr_3_Template, 6, 2, "tr", 3);
    i0.ɵɵelementStart(4, "tr");
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtemplate(9, VerificationDataTableReadonlyComponent_div_0_table_1_span_9_Template, 3, 3, "span", 3);
    i0.ɵɵtemplate(10, VerificationDataTableReadonlyComponent_div_0_table_1_span_10_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, VerificationDataTableReadonlyComponent_div_0_table_1_tr_11_Template, 6, 2, "tr", 3);
    i0.ɵɵtemplate(12, VerificationDataTableReadonlyComponent_div_0_table_1_tr_12_Template, 6, 2, "tr", 3);
    i0.ɵɵelementStart(13, "tr");
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td");
    i0.ɵɵtemplate(18, VerificationDataTableReadonlyComponent_div_0_table_1_span_18_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(19, VerificationDataTableReadonlyComponent_div_0_table_1_span_19_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tr");
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵelementStart(22, "span");
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td");
    i0.ɵɵtemplate(25, VerificationDataTableReadonlyComponent_div_0_table_1_span_25_Template, 3, 3, "span", 3);
    i0.ɵɵtemplate(26, VerificationDataTableReadonlyComponent_div_0_table_1_span_26_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, VerificationDataTableReadonlyComponent_div_0_table_1_tr_27_Template, 6, 2, "tr", 3);
    i0.ɵɵtemplate(28, VerificationDataTableReadonlyComponent_div_0_table_1_tr_28_Template, 6, 2, "tr", 3);
    i0.ɵɵtemplate(29, VerificationDataTableReadonlyComponent_div_0_table_1_tr_29_Template, 6, 2, "tr", 3);
    i0.ɵɵelementStart(30, "tr");
    i0.ɵɵelementStart(31, "td");
    i0.ɵɵelementStart(32, "span");
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "td");
    i0.ɵɵelementStart(35, "div", 5);
    i0.ɵɵtemplate(36, VerificationDataTableReadonlyComponent_div_0_table_1_span_36_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(37, VerificationDataTableReadonlyComponent_div_0_table_1_span_37_Template, 4, 2, "span", 6);
    i0.ɵɵtemplate(38, VerificationDataTableReadonlyComponent_div_0_table_1_span_38_Template, 3, 7, "span", 7);
    i0.ɵɵtemplate(39, VerificationDataTableReadonlyComponent_div_0_table_1_span_39_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(40, VerificationDataTableReadonlyComponent_div_0_table_1_tr_40_Template, 26, 10, "tr", 3);
    i0.ɵɵelementStart(41, "tr");
    i0.ɵɵelementStart(42, "td");
    i0.ɵɵelementStart(43, "span");
    i0.ɵɵtext(44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "td");
    i0.ɵɵtemplate(46, VerificationDataTableReadonlyComponent_div_0_table_1_span_46_Template, 2, 0, "span", 3);
    i0.ɵɵelementStart(47, "ol");
    i0.ɵɵtemplate(48, VerificationDataTableReadonlyComponent_div_0_table_1_li_48_Template, 3, 2, "li", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.data.creation_date);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.updated_date);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["type"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.data.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.data.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.company_name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.tax_number);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["fiscal_code"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.data.fiscal_code);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.data.fiscal_code);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["personal-data"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.data.first_name && ctx_r2.data.last_name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.data.first_name && !ctx_r2.data.last_name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.birth_date);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.birth_place);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.nationality);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["contacts"]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.data.email);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.phone_number);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.address);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.data.email && !ctx_r2.data.phone_number && !ctx_r2.data.address);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.documents.length && ctx_r2.data.type);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["attached-documents"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.data.documents && ctx_r2.data.documents.length === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.data.documents);
} }
function VerificationDataTableReadonlyComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.translations[ctx_r3._language]["empty"]);
} }
const _c1$6 = function (a0) { return { "verification-data-table--vertical": a0 }; };
function VerificationDataTableReadonlyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, VerificationDataTableReadonlyComponent_div_0_table_1_Template, 49, 25, "table", 3);
    i0.ɵɵtemplate(2, VerificationDataTableReadonlyComponent_div_0_div_2_Template, 5, 1, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$6, ctx_r0.vertical));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isEmpty());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isEmpty());
} }
const _c2$6 = function () { return { "height": "670px", "margin-bottom": "0px" }; };
function VerificationDataTableReadonlyComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2$6));
} }
class VerificationDataTableReadonlyComponent {
    constructor() {
        this.translations = TRANSLATIONS$4;
        this._language = 'en';
    }
    set language(v) {
        if (v && v !== this._language) {
            this._language = v.toLowerCase();
        }
    }
    ;
    getDocName(doc) {
        const url = doc.url;
        const index = url.lastIndexOf('/');
        return url.substring(index + 1);
    }
    isEmpty() {
        return !this.data;
    }
    get documentData() {
        let docType = this.data.type === 'BUSINESS' ? 'COMPANY_REGISTRATION' : 'PASSPORT';
        const DOCUMENT = this.data.documents.find(doc => doc.type === docType);
        return DOCUMENT ? Object.assign(Object.assign({}, DOCUMENT), { type: DOCUMENT.type[0].toUpperCase() + DOCUMENT.type.slice(1).toLowerCase().replace('_', ' ') }) : {};
    }
}
VerificationDataTableReadonlyComponent.ɵfac = function VerificationDataTableReadonlyComponent_Factory(t) { return new (t || VerificationDataTableReadonlyComponent)(); };
VerificationDataTableReadonlyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VerificationDataTableReadonlyComponent, selectors: [["vox-vd-table-readonly"]], inputs: { loading: "loading", data: "data", vertical: "vertical", language: "language" }, decls: 2, vars: 2, consts: [["class", "verification-data-table", 3, "ngClass", 4, "ngIf"], ["class", "verification-data-table", 4, "ngIf"], [1, "verification-data-table", 3, "ngClass"], [4, "ngIf"], ["class", "vox-inline-message vox-inline-message_light-grey", 4, "ngIf"], [1, "contacts"], ["class", "info-phone-number", 4, "ngIf"], ["class", "address", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "salutation", 4, "ngIf"], [1, "salutation"], [3, "ngClass", "title", 4, "ngIf"], [3, "ngClass", "title"], [1, "info-phone-number"], [1, "address"], [1, "documents-info"], [1, "documents-info__type"], [1, "documents-info__label"], [1, "documents-info__number"], [1, "documents-info__issued-by"], [1, "documents-info__issued-date"], ["target", "_blank", "download", "", 3, "href"], [1, "vox-inline-message", "vox-inline-message_light-grey"], [1, "icon-small-info"], [1, "verification-data-table"], [3, "theme"]], template: function VerificationDataTableReadonlyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VerificationDataTableReadonlyComponent_div_0_Template, 3, 5, "div", 0);
        i0.ɵɵtemplate(1, VerificationDataTableReadonlyComponent_div_1_Template, 2, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [i1.NgIf, i1.NgClass, i1.NgForOf, i2$1.NgxSkeletonLoaderComponent], pipes: [i1.DatePipe, i1.TitleCasePipe], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.verification-data-table[_ngcontent-%COMP%]{overflow-x:auto}.verification-data-table[_ngcontent-%COMP%]   .salutation[_ngcontent-%COMP%]{text-transform:capitalize}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%;border:2px solid #e5e9f0}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(:last-child){border-bottom:2px solid #e5e9f0}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{min-width:200px;height:56px;font-size:16px;font-weight:300;color:#000;line-height:1;vertical-align:middle;white-space:nowrap;padding:10px 15px}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:last-child){border-right:2px solid #e5e9f0}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-of-type(1){font-weight:700}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-last-of-type(1){min-width:300px}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]{padding-left:15px;margin:0}.verification-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__label[_ngcontent-%COMP%]{font-weight:500;margin-right:5px}.verification-data-table[_ngcontent-%COMP%]   .vox-inline-message.vox-inline-message_light-grey[_ngcontent-%COMP%]{margin-bottom:10px}.verification-data-table--vertical[_ngcontent-%COMP%]{overflow:hidden}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{display:block}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{display:flex;flex-direction:column;border-bottom:none}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:10px 7px;min-width:unset!important;height:auto;width:100%}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .contacts[_ngcontent-%COMP%]{display:flex;flex-direction:column}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .contacts[_ngcontent-%COMP%]   .info-phone-number[_ngcontent-%COMP%]{display:block}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .contacts[_ngcontent-%COMP%]   .info-phone-number[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:auto}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .contacts[_ngcontent-%COMP%]   .address[_ngcontent-%COMP%]   .flag-icon[_ngcontent-%COMP%]{margin-right:7px;margin-bottom:-2px}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .contacts[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__type[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__number[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__issued-by[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__issued-date[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__type[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__number[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__issued-by[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .documents-info__issued-date[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:last-child){border-right:none}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-last-of-type(1){width:100%}.verification-data-table--vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-last-of-type(1)   ol[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationDataTableReadonlyComponent, [{
        type: Component,
        args: [{
                selector: "vox-vd-table-readonly",
                templateUrl: "./vd-table-readonly.component.html",
                styleUrls: ["./vd-table-readonly.component.scss"]
            }]
    }], null, { loading: [{
            type: Input
        }], data: [{
            type: Input
        }], vertical: [{
            type: Input
        }], language: [{
            type: Input
        }] }); })();

class VoxVDTableReadonlyModule {
}
VoxVDTableReadonlyModule.ɵfac = function VoxVDTableReadonlyModule_Factory(t) { return new (t || VoxVDTableReadonlyModule)(); };
VoxVDTableReadonlyModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxVDTableReadonlyModule });
VoxVDTableReadonlyModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, NgxSkeletonLoaderModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxVDTableReadonlyModule, [{
        type: NgModule,
        args: [{
                declarations: [VerificationDataTableReadonlyComponent],
                imports: [CommonModule, NgxSkeletonLoaderModule],
                exports: [VerificationDataTableReadonlyComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxVDTableReadonlyModule, { declarations: [VerificationDataTableReadonlyComponent], imports: [CommonModule, NgxSkeletonLoaderModule], exports: [VerificationDataTableReadonlyComponent] }); })();

var DOCUMENT_TYPES;
(function (DOCUMENT_TYPES) {
    DOCUMENT_TYPES["PASSPORT"] = "PASSPORT";
    DOCUMENT_TYPES["ID"] = "ID";
    DOCUMENT_TYPES["DRIVER_LICENSE"] = "DRIVER_LICENSE";
    DOCUMENT_TYPES["COMPANY_REGISTRATION"] = "COMPANY_REGISTRATION";
    DOCUMENT_TYPES["UTILITY_BILL"] = "UTILITY_BILL";
})(DOCUMENT_TYPES || (DOCUMENT_TYPES = {}));
var FIELD_TYPES;
(function (FIELD_TYPES) {
    FIELD_TYPES["DOCUMENT"] = "DOCUMENT";
    FIELD_TYPES["LIST"] = "LIST";
    FIELD_TYPES["TEXT"] = "TEXT";
    FIELD_TYPES["PHONE"] = "PHONE";
    FIELD_TYPES["VAT"] = "VAT";
    FIELD_TYPES["DATE"] = "DATE";
    FIELD_TYPES["FULL_ADDRESS"] = "FULL_ADDRESS";
    FIELD_TYPES["COUNTRY"] = "COUNTRY";
})(FIELD_TYPES || (FIELD_TYPES = {}));
const ACCEPTED_FILE_FORMAT = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/jpeg',
    'image/png',
    'text/plain',
    'image/tiff',
    'image/tiff'
];
const MAX_FILE_SIZE = 5242880; // 5 megabytes in bytes

const TRANSLATIONS$3 = {
    it: {
        file_disclaimer: "Carica tutti i file necessari.<br>Il nome del file deve essere composto dal nome e dall'estensione (es. esempio.pdf).<br>I formati accettati sono: .doc, .docx, .pdf, .xls, .xlsx, .jpg, .jpeg, .png, .txt, .tiff, .tif<br>Puoi caricare file grandi al massimo 5Mb per file.",
        errors: {
            required: "Campo obbligatorio",
            max_size_exceeded: "File troppo grande",
            file_size_invalid: "File non valido",
            format_not_allowed: "Formato file non corretto",
            invalid_address: "Indirizzo non corretto",
            invalid_phone_number: "Numero telefonico non corretto",
            invalid_vat: "Partita IVA non valida"
        }
    },
    en: {
        file_disclaimer: "Upload all needed files.<br>Filename must be consist of name and extension of the file (e.g. example.pdf).<br>Accepted formats: .doc, .docx, .pdf, .xls, .xlsx, .jpg, .jpeg, .png, .txt, .tiff, .tif<br>You can upload files up to 5Mb per file.",
        errors: {
            required: "Field required",
            max_size_exceeded: "File too big",
            file_size_invalid: "Invalid file",
            format_not_allowed: "Invalid file format",
            invalid_address: "Invalid address",
            invalid_phone_number: "Invalid phone number",
            invalid_vat: "Invalid VAT"
        }
    }
};

const translation$1 = {
    it: {
        placeholder: "Cerca",
        no_result: "Nessun risultato trovato. Migliora i termini della ricerca."
    },
    en: {
        placeholder: "Search",
        no_result: "No result found. Please change the search value."
    }
};

const _c0$6 = ["searchInput"];
const _c1$5 = function (a0) { return { "height": a0, "margin-bottom": "0px" }; };
function CountrySelectorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction1(1, _c1$5, ctx_r0.dense ? "40px" : "56px"));
} }
function CountrySelectorComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementStart(2, "input", 14, 15);
    i0.ɵɵlistener("input", function CountrySelectorComponent_div_2_div_5_Template_input_input_2_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.onFilterInput($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", ctx_r2.TRANSLATIONS[ctx_r2._language]["placeholder"]);
} }
function CountrySelectorComponent_div_2_div_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function CountrySelectorComponent_div_2_div_6_button_1_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const country_r9 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(3); return ctx_r10.selectCountry(country_r9); });
    i0.ɵɵelementStart(1, "span", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r9 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("title", country_r9.searchTerm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(country_r9.searchTerm);
} }
function CountrySelectorComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, CountrySelectorComponent_div_2_div_6_button_1_Template, 3, 2, "button", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.filteredCountryList);
} }
function CountrySelectorComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r4.TRANSLATIONS[ctx_r4._language]["no_result"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.TRANSLATIONS[ctx_r4._language]["no_result"], " ");
} }
const _c2$5 = function (a0) { return { "country-selector__dropdown-toggle-dense": a0 }; };
function CountrySelectorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "button", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtemplate(5, CountrySelectorComponent_div_2_div_5_Template, 4, 1, "div", 9);
    i0.ɵɵtemplate(6, CountrySelectorComponent_div_2_div_6_Template, 2, 1, "div", 10);
    i0.ɵɵtemplate(7, CountrySelectorComponent_div_2_div_7_Template, 3, 2, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.selectedItem.searchTerm);
    i0.ɵɵproperty("disabled", ctx_r1.locked || ctx_r1.isDisabled)("ngClass", i0.ɵɵpureFunction1(7, _c2$5, ctx_r1.dense));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.selectedItem.searchTerm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._searchEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.filteredCountryList.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.filteredCountryList.length === 0);
} }
const _c3$4 = function (a0) { return { "country-selector__container-dense": a0 }; };
class CountrySelectorComponent {
    constructor() {
        //control value accessor stuff
        this.onChange = (_) => { };
        this.onTouch = (_) => { };
        //
        this._language = 'it';
        this.TRANSLATIONS = translation$1;
        this._searchEnabled = true;
        this.isDefaultList = false;
        this.languagesLoaded = [];
        this.dense = false;
        this.locked = false;
        this.loading = false;
        // callback for array.find; preserve the "this"
        this.findValueByKey = (value) => {
            return value.iso2.toLowerCase() === this.selectedItem.iso2.toLowerCase();
        };
        // map function
        this.mapSearchTermToIso2 = (value) => {
            return {
                iso2: value.iso2,
                searchTerm: getName(value.iso2, this._language),
                outputValue: value
            };
        };
        this.mapSearchTermToIso2Internal = (value) => {
            return {
                iso2: value.iso2,
                searchTerm: getName(value.iso2, this._language),
                outputValue: value.outputValue
            };
        };
    }
    set language(v) {
        if (v) {
            this._language = v;
            if (!this.languagesLoaded.includes(this._language)) {
                registerLocale(require(`i18n-iso-countries/langs/${this._language}.json`));
                this.languagesLoaded.push(this._language);
            }
            if (!this._countryList || this.isDefaultList) {
                this.useDefaultFullList();
            }
            else {
                // recreate the list with searchTerms in the correct language
                this._countryList = this._countryList.map(this.mapSearchTermToIso2Internal);
                this.selectedItem = this._countryList.find(this.findValueByKey) || this._countryList[0];
                this.filteredCountryList = this._countryList;
                this.onChange(this.selectedItem.outputValue);
            }
            this.resetSearchTerm();
        }
    }
    set countryList(v) {
        if (v && v.length > 0) {
            this._countryList = v.map(this.mapSearchTermToIso2);
            if (this.selectedItem) {
                // usefull if we change language.
                this.selectedItem = this._countryList.find(this.findValueByKey) || this._countryList[0];
            }
            else {
                this.selectedItem = this._countryList[0];
            }
            this.filteredCountryList = this._countryList;
            this.onChange(this.selectedItem.outputValue);
            this.isDefaultList = false;
            this.resetSearchTerm();
        }
        else {
            this.useDefaultFullList();
            this.resetSearchTerm();
        }
    }
    set searchEnabled(v) {
        this._searchEnabled = v;
        this.filteredCountryList = this._countryList;
    }
    ngOnInit() {
        if (!this.languagesLoaded.includes(this._language)) {
            registerLocale(require(`i18n-iso-countries/langs/${this._language}.json`));
            this.languagesLoaded.push(this._language);
        }
        if (!this._countryList) {
            this.useDefaultFullList();
        }
    }
    selectCountry(country) {
        if (country) {
            this.selectedItem = country;
            this.onChange(this.selectedItem.outputValue);
        }
    }
    onFilterInput(event) {
        this.filteredCountryList = this._countryList.filter(c => {
            return c.searchTerm.toLowerCase().includes(event.target.value.toLowerCase());
        });
    }
    useDefaultFullList() {
        this._countryList = this.extractCountryListFromLanguage();
        this.filteredCountryList = this._countryList;
        this.isDefaultList = true;
        if (this.selectedItem) {
            // usefull if we change language.
            this.selectedItem = this._countryList.find(this.findValueByKey) || this._countryList[0];
        }
        else {
            this.selectedItem = this._countryList[0];
        }
        this.onChange(this.selectedItem.outputValue);
    }
    extractCountryListFromLanguage() {
        const names = getNames(this._language);
        const countries = [];
        Object.keys(names).forEach((iso2) => {
            countries.push({
                iso2: iso2,
                searchTerm: names[iso2],
                outputValue: iso2
            });
        });
        return countries;
    }
    resetSearchTerm() {
        if (this.searchInput)
            this.searchInput.nativeElement.value = '';
    }
    writeValue(obj) {
        if (!obj)
            return;
        if (typeof obj === 'string') {
            this.selectedItem = this.selectedItem ?
                this._countryList.find(c => c.iso2.toLowerCase() === obj.toLowerCase()) || this._countryList[0] :
                this._countryList.find(c => c.iso2.toLowerCase() === obj.toLowerCase()) || this._countryList[0];
        }
        else if ('iso2' in obj) {
            this.selectedItem = this.selectedItem ?
                this._countryList.find(c => c.iso2.toLowerCase() === obj.iso2.toLowerCase()) || this._countryList[0] :
                this._countryList.find(c => c.iso2.toLowerCase() === obj.iso2.toLowerCase()) || this._countryList[0];
        }
        else {
            return;
        }
        this.onChange(this.selectedItem.outputValue);
    }
    registerOnChange(fn) {
        this.onChange = fn;
        if (this.selectedItem)
            this.onChange(this.selectedItem.outputValue);
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
}
CountrySelectorComponent.ɵfac = function CountrySelectorComponent_Factory(t) { return new (t || CountrySelectorComponent)(); };
CountrySelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CountrySelectorComponent, selectors: [["vox-select-country"]], viewQuery: function CountrySelectorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$6, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, inputs: { language: "language", countryList: "countryList", searchEnabled: "searchEnabled", dense: "dense", locked: "locked", loading: "loading" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CountrySelectorComponent),
                multi: true
            },
        ])], decls: 3, vars: 5, consts: [[1, "country-selector__container", 3, "ngClass"], ["class", "country-selector__dropdown-loading", 4, "ngIf"], ["class", "country-selector__dropdown dropdown vox-dropdown-input", 4, "ngIf"], [1, "country-selector__dropdown-loading"], [3, "theme"], [1, "country-selector__dropdown", "dropdown", "vox-dropdown-input"], ["data-toggle", "dropdown", "type", "button", 1, "country-selector__dropdown-toggle", "dropdown-toggle", 3, "disabled", "ngClass", "title"], [1, "country-selector__dropdown-toggle--label", "overflow"], [1, "country-selector__dropdown-menu", "dropdown-menu"], ["class", "country-selector__dropdown-search", 4, "ngIf"], ["class", "country-selector__dropdown-scrolling-list", 4, "ngIf"], ["class", "country-selector__dropdown-scrolling-list", 3, "title", 4, "ngIf"], [1, "country-selector__dropdown-search"], [1, "icon-small-search"], ["type", "text", 1, "country-selector__dropdown-search-field", 3, "placeholder", "input"], ["searchInput", ""], [1, "country-selector__dropdown-scrolling-list"], ["class", "country-selector__dropdown-item dropdown-item", "type", "button", 3, "title", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "country-selector__dropdown-item", "dropdown-item", 3, "title", "click"], [1, "overflow"], [1, "country-selector__dropdown-scrolling-list", 3, "title"], ["disabled", "", "type", "button", 1, "country-selector__dropdown-item", "dropdown-item", "overflow"]], template: function CountrySelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CountrySelectorComponent_div_1_Template, 2, 3, "div", 1);
        i0.ɵɵtemplate(2, CountrySelectorComponent_div_2_Template, 8, 9, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$4, ctx.dense));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: [i1.NgClass, i1.NgIf, i2$1.NgxSkeletonLoaderComponent, i1.NgForOf], styles: [".country-selector__container[_ngcontent-%COMP%]{height:56px}.country-selector__container-dense[_ngcontent-%COMP%]{height:40px}.country-selector__dropdown-toggle[_ngcontent-%COMP%]{height:56px}.country-selector__dropdown-toggle-dense[_ngcontent-%COMP%]{height:40px}.country-selector__dropdown-toggle--label[_ngcontent-%COMP%]{text-align:start}.country-selector__dropdown-menu[_ngcontent-%COMP%]{padding:0}.country-selector__dropdown-search[_ngcontent-%COMP%]{display:flex;padding:.3em .5em 5px;font-family:\"GT-Eesti-Pro\";font-size:20px;border-bottom:1px solid #e5e9f0}.country-selector__dropdown-search[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{margin-right:5px;padding-top:2px;color:#636c72;display:flex;align-items:center;margin-bottom:5px}.country-selector__dropdown-search[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;width:100%;outline:none}.country-selector__dropdown-scrolling-list[_ngcontent-%COMP%]{max-height:196px;overflow-y:auto;overflow-x:hidden}.country-selector__dropdown-item[_ngcontent-%COMP%]:active, .country-selector__dropdown-item[_ngcontent-%COMP%]:focus{background-color:#636c72;color:#fff;border:none;outline:none}.country-selector__dropdown[_ngcontent-%COMP%]   .overflow[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountrySelectorComponent, [{
        type: Component,
        args: [{
                selector: 'vox-select-country',
                templateUrl: './country-selector.component.html',
                styleUrls: ['./country-selector.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CountrySelectorComponent),
                        multi: true
                    },
                ],
            }]
    }], function () { return []; }, { searchInput: [{
            type: ViewChild,
            args: ['searchInput']
        }], language: [{
            type: Input
        }], countryList: [{
            type: Input
        }], searchEnabled: [{
            type: Input
        }], dense: [{
            type: Input
        }], locked: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();

const _c0$5 = function (a0) { return { "vox-input-group_dense": a0 }; };
const _c1$4 = function (a0) { return { "verification-data-form__error-border": a0 }; };
function VerificationDataFormComponent_div_0_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "input", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$5, ctx_r6._dense));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$4, ((tmp_1_0 = ctx_r6.form.get(vdr_r5.name)) == null ? null : tmp_1_0.invalid) && (((tmp_1_0 = ctx_r6.form.get(vdr_r5.name)) == null ? null : tmp_1_0.touched) || ((tmp_1_0 = ctx_r6.form.get(vdr_r5.name)) == null ? null : tmp_1_0.dirty))))("formControlName", vdr_r5.name);
} }
function VerificationDataFormComponent_div_0_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "input", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$5, ctx_r7._dense));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$4, ((tmp_1_0 = ctx_r7.form.get(vdr_r5.name)) == null ? null : tmp_1_0.invalid) && (((tmp_1_0 = ctx_r7.form.get(vdr_r5.name)) == null ? null : tmp_1_0.touched) || ((tmp_1_0 = ctx_r7.form.get(vdr_r5.name)) == null ? null : tmp_1_0.dirty))))("formControlName", vdr_r5.name);
} }
const _c2$4 = function (a0) { return { "was-validated": a0 }; };
function VerificationDataFormComponent_div_0_ng_container_2_vox_phone_text_field_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vox-phone-text-field", 19);
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    let tmp_3_0;
    i0.ɵɵproperty("formControlName", vdr_r5.name)("dense", ctx_r8._dense)("state", ctx_r8._country)("ngClass", i0.ɵɵpureFunction1(4, _c2$4, (((tmp_3_0 = ctx_r8.form.get(vdr_r5.name)) == null ? null : tmp_3_0.touched) || ((tmp_3_0 = ctx_r8.form.get(vdr_r5.name)) == null ? null : tmp_3_0.dirty)) && ctx_r8.form.get(vdr_r5.name).errors));
} }
const _c3$3 = function (a0) { return { "invalid": a0 }; };
function VerificationDataFormComponent_div_0_ng_container_2_vox_vat_field_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vox-vat-field", 20, 21);
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(1);
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    let tmp_3_0;
    i0.ɵɵproperty("formControlName", vdr_r5.name)("dense", ctx_r9._dense)("language", ctx_r9._language)("ngClass", i0.ɵɵpureFunction1(4, _c3$3, !_r20.focus && ((tmp_3_0 = ctx_r9.form.get(vdr_r5.name)) == null ? null : tmp_3_0.invalid) && (((tmp_3_0 = ctx_r9.form.get(vdr_r5.name)) == null ? null : tmp_3_0.touched) || ((tmp_3_0 = ctx_r9.form.get(vdr_r5.name)) == null ? null : tmp_3_0.dirty))));
} }
function VerificationDataFormComponent_div_0_ng_container_2_vox_address_search_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vox-address-search", 22);
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("googleKey", ctx_r10._googlePlaceAPIKey)("formControlName", vdr_r5.name)("placeholder", "")("country", ctx_r10._country)("dense", ctx_r10._dense);
} }
function VerificationDataFormComponent_div_0_ng_container_2_div_10_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function VerificationDataFormComponent_div_0_ng_container_2_div_10_button_4_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const item_r24 = restoredCtx.$implicit; const vdr_r5 = i0.ɵɵnextContext(2).$implicit; const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.setListValue(vdr_r5.name, item_r24); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r24.value);
} }
function VerificationDataFormComponent_div_0_ng_container_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "span", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵtemplate(4, VerificationDataFormComponent_div_0_ng_container_2_div_10_button_4_Template, 2, 1, "button", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.formattedLists.lists[vdr_r5.name].currentValue.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r11.formattedLists.lists[vdr_r5.name].items);
} }
function VerificationDataFormComponent_div_0_ng_container_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "vox-select-country", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const vdr_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("language", ctx_r12._language)("searchEnabled", true)("dense", ctx_r12._dense)("formControlName", vdr_r5.name);
} }
function VerificationDataFormComponent_div_0_ng_container_2_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.TRANSLATIONS[ctx_r13._language]["errors"]["required"], " ");
} }
function VerificationDataFormComponent_div_0_ng_container_2_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.TRANSLATIONS[ctx_r14._language]["errors"]["invalid_address"], " ");
} }
function VerificationDataFormComponent_div_0_ng_container_2_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.TRANSLATIONS[ctx_r15._language]["errors"]["invalid_phone_number"], " ");
} }
function VerificationDataFormComponent_div_0_ng_container_2_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.TRANSLATIONS[ctx_r16._language]["errors"]["invalid_vat"], " ");
} }
const _c4$2 = function (a0) { return { "vox-input-group_invalid": a0 }; };
function VerificationDataFormComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, VerificationDataFormComponent_div_0_ng_container_2_div_4_Template, 2, 7, "div", 8);
    i0.ɵɵtemplate(5, VerificationDataFormComponent_div_0_ng_container_2_div_5_Template, 2, 7, "div", 8);
    i0.ɵɵtemplate(6, VerificationDataFormComponent_div_0_ng_container_2_vox_phone_text_field_6_Template, 1, 6, "vox-phone-text-field", 9);
    i0.ɵɵtemplate(7, VerificationDataFormComponent_div_0_ng_container_2_vox_vat_field_7_Template, 2, 6, "vox-vat-field", 10);
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵtemplate(9, VerificationDataFormComponent_div_0_ng_container_2_vox_address_search_9_Template, 1, 5, "vox-address-search", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, VerificationDataFormComponent_div_0_ng_container_2_div_10_Template, 5, 2, "div", 13);
    i0.ɵɵtemplate(11, VerificationDataFormComponent_div_0_ng_container_2_div_11_Template, 2, 4, "div", 13);
    i0.ɵɵelementStart(12, "div", 14);
    i0.ɵɵtemplate(13, VerificationDataFormComponent_div_0_ng_container_2_span_13_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(14, VerificationDataFormComponent_div_0_ng_container_2_span_14_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(15, VerificationDataFormComponent_div_0_ng_container_2_span_15_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(16, VerificationDataFormComponent_div_0_ng_container_2_span_16_Template, 2, 1, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const vdr_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    let tmp_6_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_12_0;
    let tmp_13_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", vdr_r5.field_type);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(vdr_r5.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.TEXT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.DATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.PHONE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.VAT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c4$2, (((tmp_6_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_6_0.touched) || ((tmp_6_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_6_0.dirty)) && !!ctx_r2.form.get(vdr_r5.name).errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.FULL_ADDRESS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.LIST);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.FIELD_TYPES.COUNTRY);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (((tmp_10_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_10_0.touched) || ((tmp_10_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_10_0.dirty)) && (ctx_r2.form.get(vdr_r5.name).errors == null ? null : ctx_r2.form.get(vdr_r5.name).errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (((tmp_11_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_11_0.touched) || ((tmp_11_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_11_0.dirty)) && ((ctx_r2.form.get(vdr_r5.name).errors == null ? null : ctx_r2.form.get(vdr_r5.name).errors.place_missing) || (ctx_r2.form.get(vdr_r5.name).errors == null ? null : ctx_r2.form.get(vdr_r5.name).errors.select_from_list)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (((tmp_12_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_12_0.touched) || ((tmp_12_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_12_0.dirty)) && (ctx_r2.form.get(vdr_r5.name).errors == null ? null : ctx_r2.form.get(vdr_r5.name).errors.error) === "Invalid number");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (((tmp_13_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_13_0.touched) || ((tmp_13_0 = ctx_r2.form.get(vdr_r5.name)) == null ? null : tmp_13_0.dirty)) && (ctx_r2.form.get(vdr_r5.name).errors == null ? null : ctx_r2.form.get(vdr_r5.name).errors.invalidVat));
} }
function VerificationDataFormComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelement(3, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", ctx_r3.TRANSLATIONS[ctx_r3._language]["file_disclaimer"], i0.ɵɵsanitizeHtml);
} }
function VerificationDataFormComponent_div_0_ng_container_5_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.TRANSLATIONS[ctx_r34._language]["errors"]["max_size_exceeded"], " ");
} }
function VerificationDataFormComponent_div_0_ng_container_5_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.TRANSLATIONS[ctx_r35._language]["errors"]["file_size_invalid"], " ");
} }
function VerificationDataFormComponent_div_0_ng_container_5_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.TRANSLATIONS[ctx_r36._language]["errors"]["format_not_allowed"], " ");
} }
const _c5$2 = function (a0) { return { "mb-3": a0 }; };
const _c6$2 = function (a0) { return { "verification-data-form__document-name-dense": a0 }; };
const _c7$1 = function (a0) { return { "verification-data-form__document-action--dense": a0 }; };
function VerificationDataFormComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelementStart(2, "label", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵelementStart(5, "div", 35);
    i0.ɵɵelement(6, "b", 36, 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 38);
    i0.ɵɵlistener("click", function VerificationDataFormComponent_div_0_ng_container_5_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r38); const _r33 = i0.ɵɵreference(11); return _r33.click(); });
    i0.ɵɵelement(9, "i", 39);
    i0.ɵɵelementStart(10, "input", 40, 41);
    i0.ɵɵlistener("change", function VerificationDataFormComponent_div_0_ng_container_5_Template_input_change_10_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r38); const vdr_r30 = restoredCtx.$implicit; const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.onDocumentChange(vdr_r30.name, $event); })("change", function VerificationDataFormComponent_div_0_ng_container_5_Template_input_change_10_listener() { i0.ɵɵrestoreView(_r38); const _r32 = i0.ɵɵreference(7); const _r33 = i0.ɵɵreference(11); return _r32.innerHTML = _r33.files[0].name; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 14);
    i0.ɵɵtemplate(13, VerificationDataFormComponent_div_0_ng_container_5_span_13_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(14, VerificationDataFormComponent_div_0_ng_container_5_span_14_Template, 2, 1, "span", 15);
    i0.ɵɵtemplate(15, VerificationDataFormComponent_div_0_ng_container_5_span_15_Template, 2, 1, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const vdr_r30 = ctx.$implicit;
    const last_r31 = ctx.last;
    const ctx_r4 = i0.ɵɵnextContext(2);
    let tmp_3_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c5$2, !last_r31));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(vdr_r30.description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c6$2, ctx_r4._dense));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1$4, (((tmp_3_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_3_0.touched) || ((tmp_3_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_3_0.dirty)) && ctx_r4.documentForm.get(vdr_r30.name).errors));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c7$1, ctx_r4._dense));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", vdr_r30.name)("accept", ctx_r4.ACCEPTED_FILE_FORMAT);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (((tmp_7_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_7_0.touched) || ((tmp_7_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_7_0.dirty)) && (ctx_r4.documentForm.get(vdr_r30.name).errors == null ? null : ctx_r4.documentForm.get(vdr_r30.name).errors.max_file_size_exceeded));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (((tmp_8_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_8_0.touched) || ((tmp_8_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_8_0.dirty)) && (ctx_r4.documentForm.get(vdr_r30.name).errors == null ? null : ctx_r4.documentForm.get(vdr_r30.name).errors.file_size_invalid));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (((tmp_9_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_9_0.touched) || ((tmp_9_0 = ctx_r4.documentForm.get(vdr_r30.name)) == null ? null : tmp_9_0.dirty)) && (ctx_r4.documentForm.get(vdr_r30.name).errors == null ? null : ctx_r4.documentForm.get(vdr_r30.name).errors.file_format_invalid));
} }
function VerificationDataFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "form", 2);
    i0.ɵɵtemplate(2, VerificationDataFormComponent_div_0_ng_container_2_Template, 17, 16, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VerificationDataFormComponent_div_0_div_3_Template, 4, 1, "div", 4);
    i0.ɵɵelementStart(4, "form", 5);
    i0.ɵɵtemplate(5, VerificationDataFormComponent_div_0_ng_container_5_Template, 16, 18, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.normalFields);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.documentFields == null ? null : ctx_r0.documentFields.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.documentForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.documentFields);
} }
const _c8$1 = function () { return { "height": "16px", "margin-bottom": "5px" }; };
const _c9 = function (a0) { return { "height": a0, "margin-bottom": "0px" }; };
function VerificationDataFormComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "ngx-skeleton-loader", 43);
    i0.ɵɵelement(2, "ngx-skeleton-loader", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(2, _c8$1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction1(3, _c9, ctx_r41._dense ? "40px" : "56px"));
} }
function VerificationDataFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵtemplate(2, VerificationDataFormComponent_div_1_div_2_Template, 3, 5, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.loaderLength);
} }
class VerificationDataFormComponent {
    constructor() {
        // I/O
        this._language = 'en';
        this._loading = false;
        this._dense = false;
        this._country = 'it';
        this.onValueChange = new EventEmitter(true);
        this.TRANSLATIONS = TRANSLATIONS$3;
        // misc
        this.loadedLocales = [this._language];
        this.FIELD_TYPES = FIELD_TYPES;
        this.MAX_FILE_SIZE = MAX_FILE_SIZE;
        this.ACCEPTED_FILE_FORMAT = ACCEPTED_FILE_FORMAT;
        this.formattedLists = {
            lists: {}
        };
        this.documents = {};
    }
    set language(v) {
        if (v && v.toLocaleLowerCase() !== this._language) {
            this._language = v.toLowerCase();
        }
    }
    set country(v) {
        if (v && v !== this._country) {
            this._country = v.toLowerCase();
        }
    }
    set loading(v) {
        if ((v === true || v === false) && v !== this._loading) {
            this._loading = v;
            if (v === false) {
                this.clearAddresses();
            }
        }
    }
    set googlePlaceAPIKey(v) {
        if (v && v !== this._googlePlaceAPIKey) {
            this._googlePlaceAPIKey = v;
        }
    }
    set verificationDataRequirements(v) {
        if (v && !this._verificationDataRequirements) {
            this._verificationDataRequirements = v;
            if (!this.form || !this.documentForm) {
                this.initForm();
            }
        }
        if (v && this._verificationDataRequirements) {
            //check length
            if (v.length !== this._verificationDataRequirements.length)
                return;
            //if length match check consistency
            for (let i = 0; i < v.length; i++) {
                if (v[i].field_type !== this._verificationDataRequirements[i].field_type
                    || v[i].name !== this._verificationDataRequirements[i].name)
                    return;
            }
            for (let i = 0; i < v.length; i++) {
                this._verificationDataRequirements[i].description = v[i].description;
            }
        }
    }
    set dense(v) {
        if (typeof v === 'boolean' && v !== this._dense) {
            this._dense = v;
        }
    }
    set startingValues(v) {
        if (v && !this._startingValues) {
            this._startingValues = v;
        }
    }
    ngOnInit() {
        if (this._verificationDataRequirements)
            this.initForm();
    }
    formatLists() {
        this.formattedLists = {
            lists: {}
        };
        this._verificationDataRequirements.forEach((vdi) => {
            switch (vdi.field_type) {
                case FIELD_TYPES.LIST:
                    const keyValues = this.extrackKeyValueFromItems(vdi.items);
                    this.formattedLists.lists[vdi.name] = {
                        items: keyValues,
                        currentValue: keyValues[0] || undefined,
                        type: vdi.field_type
                    };
                    break;
            }
        });
    }
    initForm() {
        this.formatLists();
        this.separateDocuments();
        this.buildDocumentsList();
        this.buildFormGroups();
        // stabilize the model avoiding expression changes between checks
        setTimeout(() => {
            this.setStartingValues();
            this.validateAndEmit();
        });
    }
    setStartingValues() {
        if (this._startingValues) {
            Object.keys(this._startingValues).forEach(key => {
                if (this.form.controls[key]) {
                    if (this.isAddress(key) && !(typeof this._startingValues[key] === 'string')) {
                        const v = this._startingValues[key].find(field => field.types && field.types.includes('formatted_address'));
                        this.form.controls[key].setValue(v.long_name);
                    }
                    else {
                        this.form.controls[key].setValue(this._startingValues[key]);
                    }
                    return;
                }
                if (this.formattedLists.lists[key]) {
                    const tmp = this.formattedLists.lists[key].items.find(item => item.key === this._startingValues[key]);
                    if (tmp)
                        this.formattedLists.lists[key].currentValue = tmp;
                    return;
                }
            });
        }
    }
    isAddress(key) {
        return this._verificationDataRequirements.find(vd => vd.name === key).field_type === FIELD_TYPES.FULL_ADDRESS;
    }
    clearAddresses() {
        if (!this._verificationDataRequirements)
            return;
        this._verificationDataRequirements.forEach(vd => {
            if (vd.field_type === FIELD_TYPES.FULL_ADDRESS && this.form.controls[vd.name]) {
                this.form.controls[vd.name].setValue('');
                this.form.controls[vd.name].markAsPristine();
                this.form.controls[vd.name].markAsUntouched();
            }
        });
    }
    get loaderLength() {
        // return verification data length or 5 (if vd is not set)
        return [...Array(this._verificationDataRequirements ? this._verificationDataRequirements.length : 5).keys()];
    }
    separateDocuments() {
        this.normalFields = this._verificationDataRequirements.filter(vdi => vdi.field_type !== FIELD_TYPES.DOCUMENT);
        this.documentFields = this._verificationDataRequirements.filter(vdi => vdi.field_type === FIELD_TYPES.DOCUMENT);
    }
    buildDocumentsList() {
        this._verificationDataRequirements.forEach((vd) => {
            if (vd.field_type === FIELD_TYPES.DOCUMENT) {
                if (this.documents[vd.name])
                    return;
                this.documents[vd.name] = {
                    type: vd.document_type,
                    file: null
                };
            }
        });
    }
    extrackKeyValueFromItems(items) {
        return Object.keys(items).map(key => {
            return {
                key: key,
                value: items[key]
            };
        });
    }
    getListsValues() {
        const result = {};
        Object.keys(this.formattedLists.lists).forEach(k => {
            result[k] = this.formattedLists.lists[k].currentValue.key;
        });
        return result;
    }
    setListValue(listItem, value) {
        if (this.formattedLists.lists[listItem]) {
            this.formattedLists.lists[listItem].currentValue = value;
        }
        this.validateAndEmit();
    }
    onDocumentChange(fieldName, event) {
        if (this.documents[fieldName]) {
            this.documents[fieldName].file = event.target.files[0];
            const errors = this.fileValidator(this.documents[fieldName].file);
            if (errors)
                this.documentForm.controls[fieldName].setErrors(errors);
            this.validateAndEmit();
        }
    }
    buildFormGroups() {
        this.form = new FormGroup({});
        this.documentForm = new FormGroup({});
        this._verificationDataRequirements.forEach((vdi) => {
            if (vdi.field_type === FIELD_TYPES.LIST)
                return;
            if (vdi.field_type === FIELD_TYPES.DOCUMENT) {
                this.documentForm.addControl(vdi.name, new FormControl(null, Validators.required));
            }
            else {
                this.form.addControl(vdi.name, new FormControl(null, Validators.required));
            }
        });
        this.formSubscription = this.form.valueChanges.subscribe(v => {
            this.validateAndEmit();
        });
    }
    fileValidator(file) {
        let errors = null;
        if (file.size > MAX_FILE_SIZE) {
            errors = Object.assign(Object.assign({}, errors), { max_file_size_exceeded: true });
        }
        if (file.size <= 0) {
            errors = Object.assign(Object.assign({}, errors), { file_size_invalid: true });
        }
        if (!ACCEPTED_FILE_FORMAT.includes(file.type)) {
            errors = Object.assign(Object.assign({}, errors), { file_format_invalid: true });
        }
        return errors;
    }
    validateAndEmit() {
        const vdResults = {
            value: Object.assign(Object.assign(Object.assign({}, this.form.value), this.getListsValues()), this.documents),
            isValid: this.form.valid && this.documentForm.valid
        };
        this.onValueChange.emit(vdResults);
    }
}
VerificationDataFormComponent.ɵfac = function VerificationDataFormComponent_Factory(t) { return new (t || VerificationDataFormComponent)(); };
VerificationDataFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VerificationDataFormComponent, selectors: [["vox-verification-data-form"]], inputs: { language: "language", country: "country", loading: "loading", googlePlaceAPIKey: "googlePlaceAPIKey", verificationDataRequirements: "verificationDataRequirements", dense: "dense", startingValues: "startingValues" }, outputs: { onValueChange: "onValueChange" }, decls: 2, vars: 2, consts: [["class", "verification-data-form__container", 4, "ngIf"], [1, "verification-data-form__container"], [1, "verification-data-form__form", 3, "formGroup"], [4, "ngFor", "ngForOf"], ["class", "vox-inline-message vox-inline-message_light-grey mt-2", "style", "margin-bottom: 15px;", 4, "ngIf"], [1, "verification-data-form__form", "mt-1", 3, "formGroup"], [1, "verification-data-form__input-container", "mb-3", 3, "ngSwitch"], ["for", ""], ["class", "vox-input-group", 3, "ngClass", 4, "ngSwitchCase"], [3, "formControlName", "dense", "state", "ngClass", 4, "ngSwitchCase"], [3, "formControlName", "dense", "language", "ngClass", 4, "ngSwitchCase"], [3, "ngClass"], [3, "googleKey", "formControlName", "placeholder", "country", "dense", 4, "ngSwitchCase"], ["class", "vox-dropdown-input dropdown", 4, "ngSwitchCase"], [1, "verification-data-form__error-container"], ["class", "verification-data-form__error-message", 4, "ngIf"], [1, "vox-input-group", 3, "ngClass"], ["type", "text", 1, "vox-text-field", 3, "ngClass", "formControlName"], ["type", "date", 1, "vox-text-field", 3, "ngClass", "formControlName"], [3, "formControlName", "dense", "state", "ngClass"], [3, "formControlName", "dense", "language", "ngClass"], ["t", ""], [3, "googleKey", "formControlName", "placeholder", "country", "dense"], [1, "vox-dropdown-input", "dropdown"], ["data-toggle", "dropdown", 1, "dropdown-toggle"], ["aria-labelledby", "dropdownInput", 1, "dropdown-menu"], ["type", "button", "class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "dropdown-item", 3, "click"], [3, "language", "searchEnabled", "dense", "formControlName"], [1, "verification-data-form__error-message"], [1, "vox-inline-message", "vox-inline-message_light-grey", "mt-2", 2, "margin-bottom", "15px"], [1, "icon-small-info"], [3, "innerHTML"], [1, "verification-data-form__input-container", 3, "ngClass"], [1, "verification-data-form__document-container"], [1, "vox-input-group", "verification-data-form__document-name", 3, "ngClass"], [1, "vox-text-field", 3, "ngClass"], ["text", ""], ["type", "button", 1, "verification-data-form__document-action", "verification-data-form__document-action-dialog", "vox-btn", 3, "ngClass", "click"], [1, "icon-small-folder"], ["type", "file", "hidden", "", 3, "formControlName", "accept", "change"], ["file", ""], [1, "verification-data-form__loading-container"], [3, "theme"]], template: function VerificationDataFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VerificationDataFormComponent_div_0_Template, 6, 5, "div", 0);
        i0.ɵɵtemplate(1, VerificationDataFormComponent_div_1_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx._loading && ctx.form);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx._loading);
    } }, directives: [i1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.FormGroupDirective, i1.NgForOf, i1.NgSwitch, i1.NgSwitchCase, i1.NgClass, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlName, PhoneTextFieldComponent, VatFieldComponent, AddressSearchComponent, CountrySelectorComponent, i2$1.NgxSkeletonLoaderComponent], styles: [".verification-data-form__document-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.verification-data-form__document-name[_ngcontent-%COMP%]{margin-right:10px;width:100%}.verification-data-form__document-name[_ngcontent-%COMP%] > b[_ngcontent-%COMP%]{height:56px;padding:12px 16px;font-size:20px;line-height:30px;background-color:#e5e9f0;border-radius:4px;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.verification-data-form__document-name-dense[_ngcontent-%COMP%] > b[_ngcontent-%COMP%]{height:38px;line-height:12px}.verification-data-form__document-action[_ngcontent-%COMP%]{height:56px}.verification-data-form__document-action--dense[_ngcontent-%COMP%]{height:40px}.verification-data-form__document-action-dialog[_ngcontent-%COMP%]{background-color:#f5f7f9}.verification-data-form__document-action-dialog[_ngcontent-%COMP%]:hover{background-color:#e5e9f0}.verification-data-form__loading-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:not(:last-child){margin-bottom:10px}.verification-data-form__error-message[_ngcontent-%COMP%]{color:#ff3465}.verification-data-form__error-border[_ngcontent-%COMP%]{border-color:#ff3465}.verification-data-form__error-container[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:not(:first-child){display:none}.dropdown-menu[_ngcontent-%COMP%]{max-height:150px;overflow-y:auto}input[type=date][_ngcontent-%COMP%]{padding-right:8px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationDataFormComponent, [{
        type: Component,
        args: [{
                selector: 'vox-verification-data-form',
                templateUrl: './verification-data-form.component.html',
                styleUrls: ['./verification-data-form.component.scss']
            }]
    }], function () { return []; }, { onValueChange: [{
            type: Output
        }], language: [{
            type: Input
        }], country: [{
            type: Input
        }], loading: [{
            type: Input
        }], googlePlaceAPIKey: [{
            type: Input
        }], verificationDataRequirements: [{
            type: Input
        }], dense: [{
            type: Input
        }], startingValues: [{
            type: Input
        }] }); })();

const servedCountries = [
    {
        iso2: 'IT'
    },
    {
        iso2: 'GB'
    },
    {
        iso2: 'US'
    }
];

class LocalizeCountryNamePipe {
    transform(value, language) {
        return getName(value.toUpperCase(), language.toLowerCase());
    }
}
LocalizeCountryNamePipe.ɵfac = function LocalizeCountryNamePipe_Factory(t) { return new (t || LocalizeCountryNamePipe)(); };
LocalizeCountryNamePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "localizeCountryName", type: LocalizeCountryNamePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalizeCountryNamePipe, [{
        type: Pipe,
        args: [{
                name: 'localizeCountryName',
                pure: true
            }]
    }], null, null); })();

class VoxCountrySelectorModule {
}
VoxCountrySelectorModule.ɵfac = function VoxCountrySelectorModule_Factory(t) { return new (t || VoxCountrySelectorModule)(); };
VoxCountrySelectorModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxCountrySelectorModule });
VoxCountrySelectorModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgxSkeletonLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxCountrySelectorModule, [{
        type: NgModule,
        args: [{
                declarations: [CountrySelectorComponent, LocalizeCountryNamePipe],
                imports: [
                    CommonModule,
                    NgxSkeletonLoaderModule
                ],
                exports: [CountrySelectorComponent, LocalizeCountryNamePipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxCountrySelectorModule, { declarations: [CountrySelectorComponent, LocalizeCountryNamePipe], imports: [CommonModule,
        NgxSkeletonLoaderModule], exports: [CountrySelectorComponent, LocalizeCountryNamePipe] }); })();

class VoxVerificationDataFormModule {
}
VoxVerificationDataFormModule.ɵfac = function VoxVerificationDataFormModule_Factory(t) { return new (t || VoxVerificationDataFormModule)(); };
VoxVerificationDataFormModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxVerificationDataFormModule });
VoxVerificationDataFormModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            VoxPhoneTextFieldModule,
            VoxAddressSearchModule,
            VoxCountrySelectorModule,
            VoxVatFieldModule,
            NgxSkeletonLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxVerificationDataFormModule, [{
        type: NgModule,
        args: [{
                declarations: [VerificationDataFormComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                    VoxPhoneTextFieldModule,
                    VoxAddressSearchModule,
                    VoxCountrySelectorModule,
                    VoxVatFieldModule,
                    NgxSkeletonLoaderModule
                ],
                exports: [VerificationDataFormComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxVerificationDataFormModule, { declarations: [VerificationDataFormComponent], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        VoxPhoneTextFieldModule,
        VoxAddressSearchModule,
        VoxCountrySelectorModule,
        VoxVatFieldModule,
        NgxSkeletonLoaderModule], exports: [VerificationDataFormComponent] }); })();

const TRANSLATIONS$2 = {
    it: {
        groups_card: {
            title: "Gruppi",
            no_groups: "Non ci sono gruppi collegati"
        },
        equipments_card: {
            title: "Equipment",
            no_equipments: "nessun equipment trovato",
            smart: "Smart",
            control: "Control",
            air: "Air"
        },
        rules_card: {
            title: "Regole",
            no_rules: "Non ci sono regole da mostrare."
        }
    },
    en: {
        groups_card: {
            title: "Groups",
            no_groups: "no linked groups"
        },
        equipments_card: {
            title: "Equipment",
            no_equipments: "no equipments found",
            smart: "Smart",
            control: "Control",
            air: "Air"
        },
        rules_card: {
            title: "Rules",
            no_rules: "There is no rules to show."
        }
    }
};

var CallflowType;
(function (CallflowType) {
    CallflowType["usersgroups"] = "usersgroups";
    CallflowType["ivr"] = "ivr";
    CallflowType["voicemail"] = "voicemail";
    CallflowType["forward"] = "forward";
    CallflowType["play-media"] = "play-media";
})(CallflowType || (CallflowType = {}));
var EQUIPMENT_MODEL;
(function (EQUIPMENT_MODEL) {
    EQUIPMENT_MODEL["SMART"] = "SMART";
    EQUIPMENT_MODEL["CONTROL"] = "CONTROL";
    EQUIPMENT_MODEL["AIR"] = "AIR";
})(EQUIPMENT_MODEL || (EQUIPMENT_MODEL = {}));

const _c0$4 = function (a0) { return { "readonly": a0 }; };
function LinksSummaryComponent_div_0_div_1_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_1_ul_5_li_1_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const group_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(4); return ctx_r11.onClick(group_r10); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, group_r10.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", group_r10.name, "");
} }
function LinksSummaryComponent_div_0_div_1_ul_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_1_ul_5_li_2_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const cascade_r13 = restoredCtx.$implicit; const ctx_r14 = i0.ɵɵnextContext(4); return ctx_r14.onClick(cascade_r13); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cascade_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, cascade_r13.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", cascade_r13.name, "");
} }
function LinksSummaryComponent_div_0_div_1_ul_5_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_1_ul_5_li_3_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r18); const queue_r16 = restoredCtx.$implicit; const ctx_r17 = i0.ɵɵnextContext(4); return ctx_r17.onClick(queue_r16); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const queue_r16 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, queue_r16.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", queue_r16.name, "");
} }
function LinksSummaryComponent_div_0_div_1_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 11);
    i0.ɵɵtemplate(1, LinksSummaryComponent_div_0_div_1_ul_5_li_1_Template, 3, 4, "li", 12);
    i0.ɵɵtemplate(2, LinksSummaryComponent_div_0_div_1_ul_5_li_2_Template, 3, 4, "li", 12);
    i0.ɵɵtemplate(3, LinksSummaryComponent_div_0_div_1_ul_5_li_3_Template, 3, 4, "li", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5._linkedEntities.groups);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5._linkedEntities.cascades);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5._linkedEntities.queues);
} }
function LinksSummaryComponent_div_0_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.TRANSLATIONS[ctx_r6._language]["groups_card"]["no_groups"]);
} }
function LinksSummaryComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LinksSummaryComponent_div_0_div_1_ul_5_Template, 4, 3, "ul", 9);
    i0.ɵɵtemplate(6, LinksSummaryComponent_div_0_div_1_span_6_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.TRANSLATIONS[ctx_r2._language]["groups_card"]["title"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2._linkedEntities.groups.length !== 0 || ctx_r2._linkedEntities.cascades.length !== 0 || ctx_r2._linkedEntities.queues.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2._linkedEntities.groups.length === 0 && ctx_r2._linkedEntities.cascades.length === 0 && ctx_r2._linkedEntities.queues.length === 0);
} }
function LinksSummaryComponent_div_0_div_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_2_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const equipment_r19 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.onClick(equipment_r19); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const equipment_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, equipment_r19.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", equipment_r19.mac_address, "");
} }
function LinksSummaryComponent_div_0_div_2_ul_7_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_2_ul_7_li_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r30); const equipment_r19 = i0.ɵɵnextContext(2).$implicit; const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.onClick(equipment_r19); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const handset_r27 = ctx.$implicit;
    const equipment_r19 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, equipment_r19.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", handset_r27.ipui, "");
} }
function LinksSummaryComponent_div_0_div_2_ul_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 11);
    i0.ɵɵtemplate(1, LinksSummaryComponent_div_0_div_2_ul_7_li_1_Template, 3, 4, "li", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const equipment_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", equipment_r19.handsets);
} }
const _c1$3 = function (a0, a1, a2) { return { "icon-big-phone-smart-outline": a0, "icon-big-phone-control-outline": a1, "icon-big-phone-air-outline": a2 }; };
function LinksSummaryComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵtemplate(6, LinksSummaryComponent_div_0_div_2_button_6_Template, 2, 4, "button", 16);
    i0.ɵɵtemplate(7, LinksSummaryComponent_div_0_div_2_ul_7_Template, 2, 1, "ul", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const equipment_r19 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c1$3, equipment_r19.model.includes(ctx_r3.EQUIPMENT_MODEL.SMART), equipment_r19.model.includes(ctx_r3.EQUIPMENT_MODEL.CONTROL), equipment_r19.model.includes(ctx_r3.EQUIPMENT_MODEL.AIR)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.TRANSLATIONS[ctx_r3._language]["equipments_card"][ctx_r3.getEquipmentModel(equipment_r19)], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", equipment_r19.handsets.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", equipment_r19.handsets.length !== 0);
} }
function LinksSummaryComponent_div_0_div_3_ul_5_li_1_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function LinksSummaryComponent_div_0_div_3_ul_5_li_1_li_4_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r40); const rule_r38 = restoredCtx.$implicit; const ctx_r39 = i0.ɵɵnextContext(5); return ctx_r39.onClick(rule_r38); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rule_r38 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, rule_r38.readonly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rule_r38.name, " ");
} }
function LinksSummaryComponent_div_0_div_3_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "pre", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul");
    i0.ɵɵtemplate(4, LinksSummaryComponent_div_0_div_3_ul_5_li_1_li_4_Template, 3, 4, "li", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r36 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r36.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r36.value);
} }
function LinksSummaryComponent_div_0_div_3_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 11);
    i0.ɵɵtemplate(1, LinksSummaryComponent_div_0_div_3_ul_5_li_1_Template, 5, 2, "li", 12);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r33._linkedEntities.groupedCallFlows));
} }
function LinksSummaryComponent_div_0_div_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r34.TRANSLATIONS[ctx_r34._language]["rules_card"]["no_rules"]);
} }
function LinksSummaryComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LinksSummaryComponent_div_0_div_3_ul_5_Template, 3, 3, "ul", 9);
    i0.ɵɵtemplate(6, LinksSummaryComponent_div_0_div_3_span_6_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.TRANSLATIONS[ctx_r4._language]["rules_card"]["title"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4._linkedEntities.callFlows.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4._linkedEntities.callFlows.length === 0);
} }
function LinksSummaryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, LinksSummaryComponent_div_0_div_1_Template, 7, 3, "div", 2);
    i0.ɵɵtemplate(2, LinksSummaryComponent_div_0_div_2_Template, 8, 8, "div", 3);
    i0.ɵɵtemplate(3, LinksSummaryComponent_div_0_div_3_Template, 7, 3, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._linkedEntities.groups || ctx_r0._linkedEntities.cascades || ctx_r0._linkedEntities.queues);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0._linkedEntities.equipments);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._linkedEntities.groupedCallFlows);
} }
const _c2$3 = function () { return { "width": "150px", "height": "16px", "margin-bottom": "0px" }; };
function LinksSummaryComponent_div_1_li_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2$3));
} }
const _c3$2 = function () { return { "width": "48px", "height": "48px", "margin-bottom": "0px" }; };
const _c4$1 = function () { return { "width": "150px", "height": "18px", "margin-bottom": "0px" }; };
function LinksSummaryComponent_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 20);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 11);
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵelement(7, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(3, _c3$2));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c4$1));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c2$3));
} }
function LinksSummaryComponent_div_1_li_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2$3));
} }
const _c5$1 = function () { return { "width": "250px", "height": "16px", "margin-bottom": "0px" }; };
const _c6$1 = function () { return [1, 2]; };
function LinksSummaryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "ngx-skeleton-loader", 20);
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelement(5, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelement(7, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "ul", 11);
    i0.ɵɵtemplate(9, LinksSummaryComponent_div_1_li_9_Template, 2, 2, "li", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, LinksSummaryComponent_div_1_div_10_Template, 8, 6, "div", 3);
    i0.ɵɵelementStart(11, "div", 5);
    i0.ɵɵelement(12, "ngx-skeleton-loader", 20);
    i0.ɵɵelementStart(13, "div", 7);
    i0.ɵɵelementStart(14, "div", 8);
    i0.ɵɵelement(15, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 14);
    i0.ɵɵelement(17, "ngx-skeleton-loader", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "ul", 11);
    i0.ɵɵtemplate(19, LinksSummaryComponent_div_1_li_19_Template, 2, 2, "li", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(9, _c3$2));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(10, _c4$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(11, _c5$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(12, _c6$1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(13, _c6$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(14, _c3$2));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(15, _c4$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(16, _c5$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(17, _c6$1));
} }
class LinksSummaryComponent {
    constructor() {
        this.emitEvent = new EventEmitter();
        this._language = 'en';
        this.TRANSLATIONS = TRANSLATIONS$2;
        this.EQUIPMENT_MODEL = EQUIPMENT_MODEL;
    }
    set linkedEntities(l) {
        this._linkedEntities = Object.assign({}, l);
        if (l.callFlows) {
            let groupedCallflows = {};
            l.callFlows.forEach(c => {
                const KEY = `${c.label} [${c.number}]`;
                if (groupedCallflows[KEY]) {
                    groupedCallflows[KEY].push(c);
                }
                else {
                    groupedCallflows[KEY] = [c];
                }
            });
            this._linkedEntities.groupedCallFlows = groupedCallflows;
        }
    }
    set language(v) {
        if (v && v.toLocaleLowerCase() !== this._language) {
            this._language = v.toLowerCase();
        }
    }
    getEquipmentModel(value) {
        if (value.model === EQUIPMENT_MODEL.CONTROL) {
            return EQUIPMENT_MODEL.CONTROL.toLocaleLowerCase();
        }
        else if (value.model === EQUIPMENT_MODEL.AIR) {
            return EQUIPMENT_MODEL.AIR.toLocaleLowerCase();
        }
        else {
            return EQUIPMENT_MODEL.SMART.toLocaleLowerCase();
        }
    }
    onClick(value) {
        this.emitEvent.emit(value);
    }
}
LinksSummaryComponent.ɵfac = function LinksSummaryComponent_Factory(t) { return new (t || LinksSummaryComponent)(); };
LinksSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LinksSummaryComponent, selectors: [["vox-links-summary"]], inputs: { loading: "loading", linkedEntities: "linkedEntities", language: "language" }, outputs: { emitEvent: "emitEvent" }, decls: 2, vars: 2, consts: [["class", "usage-summary-card__container", 4, "ngIf"], [1, "usage-summary-card__container"], ["class", "vox-card", 4, "ngIf"], ["class", "vox-card", 4, "ngFor", "ngForOf"], ["class", "vox-card rules", 4, "ngIf"], [1, "vox-card"], [1, "icon-big-group"], [1, "vox-card__title"], [1, "vox-heading-6", "title"], ["class", "vox-card__list", 4, "ngIf"], ["class", "vox-paragraph", 4, "ngIf"], [1, "vox-card__list"], [4, "ngFor", "ngForOf"], [1, "vox-btn", 3, "ngClass", "click"], [1, "vox-paragraph"], [3, "ngClass"], ["class", "vox-btn", 3, "ngClass", "click", 4, "ngIf"], [1, "vox-card", "rules"], [1, "icon-big-porting"], [1, "vox-chip", "vox-chip_royal-blue-text"], [3, "theme"]], template: function LinksSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LinksSummaryComponent_div_0_Template, 4, 3, "div", 0);
        i0.ɵɵtemplate(1, LinksSummaryComponent_div_1_Template, 20, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [i1.NgIf, i1.NgForOf, i1.NgClass, i2$1.NgxSkeletonLoaderComponent], pipes: [i1.KeyValuePipe], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]:not(:last-child){border-bottom:none}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]{min-height:96px;max-width:unset;width:100%;padding:24px;border-color:#e5e9f0;flex-direction:row;align-items:center;justify-content:flex-start}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]:not(:first-child){border-top-right-radius:0;border-top-left-radius:0}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]:not(:last-child){border-bottom:none;border-bottom-right-radius:0;border-bottom-left-radius:0}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]:hover{border-color:#e5e9f0}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card.rules[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{display:flex;flex-direction:column}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card.rules[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   pre.vox-chip[_ngcontent-%COMP%]{align-self:flex-start;margin-bottom:0}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card.rules[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding-left:40px}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card.rules[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style:circle}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:48px;color:#000}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card__title[_ngcontent-%COMP%]{margin-left:35px;margin-right:35px}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card__title--toggle[_ngcontent-%COMP%]{padding-left:48px}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card__title[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{line-height:24px}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]   .vox-btn[_ngcontent-%COMP%]{padding:0;font-size:16px;font-weight:300;color:#000;text-decoration:underline;border:none;background-color:transparent}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card[_ngcontent-%COMP%]   .readonly[_ngcontent-%COMP%]{pointer-events:none;text-decoration:none}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%]{padding:0;margin-bottom:0}.usage-summary-card__container[_ngcontent-%COMP%]   .vox-card__list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{list-style:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinksSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'vox-links-summary',
                templateUrl: './links-summary.component.html',
                styleUrls: ['./links-summary.component.scss']
            }]
    }], function () { return []; }, { loading: [{
            type: Input
        }], linkedEntities: [{
            type: Input
        }], language: [{
            type: Input
        }], emitEvent: [{
            type: Output
        }] }); })();

class VoxLinksSummaryModule {
}
VoxLinksSummaryModule.ɵfac = function VoxLinksSummaryModule_Factory(t) { return new (t || VoxLinksSummaryModule)(); };
VoxLinksSummaryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxLinksSummaryModule });
VoxLinksSummaryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgxSkeletonLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxLinksSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [LinksSummaryComponent],
                imports: [
                    CommonModule,
                    NgxSkeletonLoaderModule
                ],
                exports: [LinksSummaryComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxLinksSummaryModule, { declarations: [LinksSummaryComponent], imports: [CommonModule,
        NgxSkeletonLoaderModule], exports: [LinksSummaryComponent] }); })();

const TRANSLATIONS$1 = {
    it: {
        placeholder: "Seleziona uno o più elementi",
        selectAllText: "Seleziona tutto",
        unSelectAllText: "Deseleziona tutto",
        searchPlaceholderText: "Cerca",
        noDataAvailablePlaceholderText: "Nessun elemento mostrato"
    },
    en: {
        placeholder: "Select one or more elements",
        selectAllText: "Select all",
        unSelectAllText: "Unselect all",
        searchPlaceholderText: "Search",
        noDataAvailablePlaceholderText: "No elements to display"
    }
};

var Layouts;
(function (Layouts) {
    Layouts["rows"] = "rows";
    Layouts["columns"] = "columns";
})(Layouts || (Layouts = {}));

const _c0$3 = ["container"];
const _c1$2 = ["item"];
function DropdownMultiselectComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 5);
    i0.ɵɵtext(1);
} if (rf & 2) {
    const option_r6 = ctx.option;
    const isSelected_r8 = ctx.isSelected;
    i0.ɵɵproperty("checked", isSelected_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r6, " ");
} }
function DropdownMultiselectComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r9 = ctx.option;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r9, " ");
} }
const _c2$2 = function (a1, a2, a3, a4, a5) { return { "multiselect-dropdown-component": true, "multiselect-dropdown-component--dense": a1, "multiselect-dropdown-component--dense-rows": a2, "multiselect-dropdown-component--dense-columns": a3, "multiselect-dropdown-component--rows": a4, "multiselect-dropdown-component--columns": a5 }; };
class DropdownMultiselectComponent {
    constructor() {
        this._layout = Layouts.columns;
        this.dense = false;
        this.selectedItems = [];
        this.dropdownSettings = {};
        this.TRANSLATIONS = TRANSLATIONS$1;
        this.selectedFullItems = [];
        this._language = 'en';
        this.dropdownList = [];
        this.onChange = (_) => { };
        this.onTouch = (_) => { };
    }
    set setDense(v) {
        if (typeof v === 'boolean' && v !== this.dense) {
            this.dense = v;
            setTimeout(() => { this.updateLayout(); }, 0);
        }
    }
    set language(v) {
        if (v && v.toLocaleLowerCase() !== this._language) {
            this._language = v.toLowerCase();
        }
    }
    set layout(l) {
        if (l && l !== this._layout) {
            this._layout = l;
            setTimeout(() => { this.updateLayout(); }, 0);
        }
    }
    ;
    ngOnInit() {
        this.dropdownSettings = Object.assign({ idField: 'item_id', textField: 'item_name', selectAllText: TRANSLATIONS$1[this._language]['selectAllText'], unSelectAllText: TRANSLATIONS$1[this._language]['unSelectAllText'], searchPlaceholderText: TRANSLATIONS$1[this._language]['searchPlaceholderText'], noDataAvailablePlaceholderText: TRANSLATIONS$1[this._language]['noDataAvailablePlaceholderText'], maxHeight: 185 }, this.settings);
        this.startingSettings = Object.assign(Object.assign({}, this.dropdownSettings), this.settings);
    }
    ngAfterViewInit() {
        this.containerWidth = this.container.nativeElement.offsetWidth;
        setTimeout(() => { this.updateLayout(); }, 0);
    }
    ngOnChanges(changes) {
        if (changes.placeholder && !changes.placeholder.currentValue)
            this.placeholder = TRANSLATIONS$1[this._language]['placeholder'];
        if (changes.language)
            this._language = changes.language.currentValue.toLowerCase();
        if (changes.dropdownList)
            this.dropdownList = changes.dropdownList.currentValue;
        this.updatedSettings();
    }
    updatedSettings() {
        this.dropdownSettings = Object.assign(Object.assign({}, this.settings), { selectAllText: TRANSLATIONS$1[this._language]['selectAllText'], unSelectAllText: TRANSLATIONS$1[this._language]['unSelectAllText'], searchPlaceholderText: TRANSLATIONS$1[this._language]['searchPlaceholderText'], noDataAvailablePlaceholderText: TRANSLATIONS$1[this._language]['noDataAvailablePlaceholderText'] });
    }
    updateLayout() {
        if (!this.items)
            return;
        this.container.nativeElement.style.height = ``;
        this._layout === Layouts.rows ? this.calculateRowLayout() : this.calculateColumnLayout();
    }
    calculateRowLayout() {
        let totalWidth = 0;
        let n = 0;
        this.items.some((e) => {
            totalWidth += e.nativeElement.offsetWidth + 30;
            if (totalWidth > this.containerWidth - 100) {
                if (n < 1) {
                    this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { itemsShowLimit: 1 });
                    return true;
                }
                this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { itemsShowLimit: n });
                return true;
            }
            n++;
            return false;
        });
    }
    calculateColumnLayout() {
        let rows = 1;
        let totalWidth = 0;
        let n = 0;
        this.items.forEach((e, idx) => {
            totalWidth += e.nativeElement.offsetWidth + 30;
            e.nativeElement.parentNode.style.marginBottom = '5px';
            if (totalWidth > this.containerWidth - 50) {
                rows++;
                totalWidth = e.nativeElement.offsetWidth + 30;
                n = this.items.length - idx;
            }
        });
        this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { itemsShowLimit: undefined });
        if (n === 0)
            n = this.items.length;
        if (this.items.length > 0) {
            this.container.nativeElement.style.height = `${rows * (this.items.first.nativeElement.offsetHeight + 5) - 5}px`;
            let arr = this.items.toArray();
            for (let i = this.items.length - 1; i >= this.items.length - n; i--) {
                arr[i].nativeElement.parentNode.style.marginBottom = '';
            }
        }
    }
    onResize(event) {
        const newWidth = this.container.nativeElement.offsetWidth;
        this.containerWidth = newWidth;
        setTimeout(() => { this.updateLayout(); }, 0);
    }
    onItemSelect(item) {
        // Whenever we select something, we have to update the layout
        // after the view is updated, so in the next tick.
        setTimeout(() => { this.updateLayout(); }, 0);
        this.onChange(this.getFullItems());
    }
    onSelectAll(items) {
        // Whenever we select something, we have to update the layout
        // after the view is updated, so in the next tick.
        setTimeout(() => { this.updateLayout(); }, 0);
        this.selectedItems = this.dropdownList;
        this.onChange(this.getFullItems());
    }
    onItemDeSelect(item) {
        // Whenever we select something, we have to update the layout
        // after the view is updated, so in the next tick.
        setTimeout(() => { this.updateLayout(); }, 0);
        this.onChange(this.getFullItems());
    }
    onDeSelectAll(items) {
        // Whenever we select something, we have to update the layout
        // after the view is updated, so in the next tick.
        setTimeout(() => { this.updateLayout(); }, 0);
        this.selectedItems = [];
        this.onChange(this.getFullItems());
    }
    onFilterChange(i) {
        let filtered = [];
        filtered = this.dropdownList.filter(el => el.item_name.includes(i));
        if (filtered && i !== '') {
            this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { singleSelection: true });
        }
        else {
            this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { singleSelection: false });
        }
    }
    onDropDownClose() {
        this.dropdownSettings = Object.assign(Object.assign({}, this.dropdownSettings), { singleSelection: this.startingSettings.singleSelection });
    }
    getFullItems() {
        let result = [];
        this.selectedItems.forEach(el => {
            let fullItem = this.dropdownList.find(selected => el.item_id === selected.item_id);
            result.push(fullItem);
        });
        return result.length > 0 ? result : null;
    }
    writeValue(obj) {
        if (obj && obj.length > 0) {
            this.selectedItems = obj;
            this.onChange(this.getFullItems());
            setTimeout(() => { this.updateLayout(); }, 0);
        }
        else {
            this.selectedItems = [];
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
        this.onChange(this.getFullItems());
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
}
DropdownMultiselectComponent.ɵfac = function DropdownMultiselectComponent_Factory(t) { return new (t || DropdownMultiselectComponent)(); };
DropdownMultiselectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownMultiselectComponent, selectors: [["vox-dropdown-multiselect"]], viewQuery: function DropdownMultiselectComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3, 5);
        i0.ɵɵviewQuery(_c1$2, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostBindings: function DropdownMultiselectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function DropdownMultiselectComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { isDisabled: "isDisabled", dropdownList: "dropdownList", setDense: "setDense", language: "language", layout: "layout", settings: "settings", placeholder: "placeholder" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropdownMultiselectComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 7, vars: 12, consts: [[1, "dropdown-multiselect"], ["container", ""], [3, "ngClass", "placeholder", "disabled", "settings", "data", "ngModel", "ngModelChange", "onSelect", "onSelectAll", "onDeSelect", "onDeSelectAll", "onFilterChange", "onDropDownClose"], ["optionsTemplate", ""], ["optionSelectedTemplate", ""], ["type", "checkbox", 1, "vox-checkbox", 3, "checked"], ["item", ""]], template: function DropdownMultiselectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵelementStart(2, "ng-multiselect-dropdown", 2);
        i0.ɵɵlistener("ngModelChange", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_ngModelChange_2_listener($event) { return ctx.selectedItems = $event; })("onSelect", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onSelect_2_listener($event) { return ctx.onItemSelect($event); })("onSelectAll", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onSelectAll_2_listener($event) { return ctx.onSelectAll($event); })("onDeSelect", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onDeSelect_2_listener($event) { return ctx.onItemDeSelect($event); })("onDeSelectAll", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onDeSelectAll_2_listener($event) { return ctx.onDeSelectAll($event); })("onFilterChange", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onFilterChange_2_listener($event) { return ctx.onFilterChange($event); })("onDropDownClose", function DropdownMultiselectComponent_Template_ng_multiselect_dropdown_onDropDownClose_2_listener() { return ctx.onDropDownClose(); });
        i0.ɵɵtemplate(3, DropdownMultiselectComponent_ng_template_3_Template, 2, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, DropdownMultiselectComponent_ng_template_5_Template, 3, 1, "ng-template", 4, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(6, _c2$2, ctx.dense, ctx.dense && ctx._layout === "rows", ctx.dense && ctx._layout === "columns", !ctx.dense && ctx._layout === "rows", !ctx.dense && ctx._layout === "columns"))("placeholder", ctx.placeholder)("disabled", ctx.isDisabled)("settings", ctx.dropdownSettings)("data", ctx.dropdownList)("ngModel", ctx.selectedItems);
    } }, directives: [i1$2.MultiSelectComponent, i1.NgClass, i2.NgControlStatus, i2.NgModel], styles: ["body{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}::-webkit-scrollbar{width:.5em;height:.5em}::-webkit-scrollbar-thumb{background-color:#868990}::-webkit-scrollbar-track{background-color:#b5bac2}::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown{display:block}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn{padding-left:16px!important;padding-right:25px!important;padding-top:5px;padding-bottom:5px;color:#000;font-size:20px;border:2px solid #b5bac2!important;line-height:38px!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn:hover{border-color:#868990!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn:active,.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn:focus{border-color:#000!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn .selected-item{max-width:unset!important;background:#0066ff!important;border:1px solid #0066ff!important;height:100%;align-items:center}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn .selected-item[hidden]{display:inline-block!important;visibility:hidden}@media only screen and (max-width: 400px){.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn .selected-item div{height:25%;width:120px!important;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:inline-block;margin-right:5px;vertical-align:middle}}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn>span:first-child{vertical-align:middle}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn>span:last-child{float:right!important;padding-right:4px;position:absolute;right:0;display:flex;align-items:center;height:100%;top:0px}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn>span:last-child>span{padding-right:7px!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn .dropdown-multiselect__caret{position:relative;display:flex;align-items:center;width:unset;height:unset}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown div .dropdown-btn .dropdown-multiselect__caret:before{border-width:6px 6px 0!important;color:#000!important;border-top-color:#000!important;position:relative!important;top:50%!important;margin-top:0}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list{font-size:20px;padding-top:0}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox{display:flex;align-items:center;padding:8px 16px!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox input:first-child{display:none}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox .vox-checkbox{margin-right:7px;border:2px solid #b5bac2;clip:unset;height:24px;width:24px;position:relative}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox .vox-checkbox:after{top:-6px;left:-1px;font-size:25px}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox .vox-checkbox:checked{border:none!important;animation:borderscaleBC .2s ease-in;-webkit-animation:borderscaleBC .2s ease-in}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox div{display:flex;align-items:center}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox div:before{top:42%!important;width:20px!important;height:20px!important;border-radius:3px;border:2px solid #b5bac2!important;color:#b5bac2!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox input:checked+div:before{animation:borderscaleBC .2s ease-in;-webkit-animation:borderscaleBC .2s ease-in;background:#ff3465!important;border-color:#ff3465!important}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox input:checked+div:after{top:45%;width:12px;height:5px;transition:none}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox input+div:before{transition:none}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .multiselect-item-checkbox input+div:after{transition:none}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .filter-textbox{height:47px;padding-left:16px;padding-right:16px}.dropdown-multiselect .multiselect-dropdown-component .multiselect-dropdown .dropdown-list .filter-textbox input{padding:0!important}.dropdown-multiselect .multiselect-dropdown-component--dense .multiselect-dropdown div .dropdown-btn{height:40px!important;line-height:26px!important}.dropdown-multiselect .multiselect-dropdown-component--dense .multiselect-dropdown div .dropdown-btn>span:first-child{vertical-align:unset}.dropdown-multiselect .multiselect-dropdown-component--dense .multiselect-dropdown div .dropdown-btn .selected-item{align-items:center;line-height:23px}.dropdown-multiselect .multiselect-dropdown-component--dense .multiselect-dropdown div .dropdown-btn .dropdown-multiselect--active .dropdown-multiselect__caret{top:-2px!important}.dropdown-multiselect .multiselect-dropdown-component--dense-rows .multiselect-dropdown div .dropdown-btn{height:40px}.dropdown-multiselect .multiselect-dropdown-component--dense-columns .multiselect-dropdown div .dropdown-btn{height:100%!important}.dropdown-multiselect .multiselect-dropdown-component--rows .multiselect-dropdown div .dropdown-btn{height:56px}.dropdown-multiselect .multiselect-dropdown-component--columns .multiselect-dropdown div .dropdown-btn{height:100%!important;min-height:56px}@-webkit-keyframes borderscaleBC{50%{box-shadow:0 0 0 2px #ff3465}}@keyframes borderscaleBC{50%{box-shadow:0 0 0 2px #ff3465}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownMultiselectComponent, [{
        type: Component,
        args: [{
                selector: 'vox-dropdown-multiselect',
                templateUrl: './dropdown-multiselect.component.html',
                styleUrls: ['./dropdown-multiselect.component.scss'],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DropdownMultiselectComponent),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { isDisabled: [{
            type: Input
        }], dropdownList: [{
            type: Input
        }], setDense: [{
            type: Input
        }], language: [{
            type: Input
        }], layout: [{
            type: Input
        }], settings: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], items: [{
            type: ViewChildren,
            args: ['item', { read: ElementRef }]
        }], container: [{
            type: ViewChild,
            args: ['container']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class VoxDropdownMultiselectModule {
}
VoxDropdownMultiselectModule.ɵfac = function VoxDropdownMultiselectModule_Factory(t) { return new (t || VoxDropdownMultiselectModule)(); };
VoxDropdownMultiselectModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxDropdownMultiselectModule });
VoxDropdownMultiselectModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            NgMultiSelectDropDownModule.forRoot()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxDropdownMultiselectModule, [{
        type: NgModule,
        args: [{
                declarations: [DropdownMultiselectComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    NgMultiSelectDropDownModule.forRoot()
                ],
                exports: [DropdownMultiselectComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxDropdownMultiselectModule, { declarations: [DropdownMultiselectComponent], imports: [CommonModule,
        FormsModule, i1$2.NgMultiSelectDropDownModule], exports: [DropdownMultiselectComponent] }); })();

const translation = {
    it: {
        asymm: "Ultra",
        symm: "Top",
        asymm_best: "Iper",
        title: {
            ftth: "Voxloud Wi-Fi 100% Fibra (FTTH)",
            fttc: "Voxloud Wi-Fi Super Internet (FTTC)",
            empty: "Voxloud Wi-Fi",
        },
        estimations: {
            title_symm: "Velocità di connessione simmetrica stimata",
            title_asymm: "Velocità di connessione asimmetrica stimata",
            download: "Velocità in download",
            upload: "Velocità in upload"
        }
    },
    en: {
        asymm: "Ultra",
        symm: "Top",
        asymm_best: "Hyper",
        title: {
            empty: "Voxloud Wi-Fi",
            ftth: "Voxloud Wi-Fi 100% Fiber (FTTH)",
            fttc: "Voxloud Wi-Fi Super Internet (FTTC)"
        },
        estimations: {
            title_symm: "Estimated symmetric connectivity speeds",
            title_asymm: "Estimated asymmetric connectivity speeds",
            download: "Download speed",
            upload: "Upload speed"
        }
    }
};

var CONNECTION_TYPE;
(function (CONNECTION_TYPE) {
    CONNECTION_TYPE["NOT_SPECIFIED"] = "NOT_SPECIFIED";
    CONNECTION_TYPE["CABINET"] = "CABINET";
    CONNECTION_TYPE["CENTRAL_OFFICE"] = "CENTRAL_OFFICE";
    CONNECTION_TYPE["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(CONNECTION_TYPE || (CONNECTION_TYPE = {}));
var FIBER_PRODUCT_TYPE;
(function (FIBER_PRODUCT_TYPE) {
    FIBER_PRODUCT_TYPE["ASYMMETRIC_BEST"] = "ASYMMETRIC_BEST";
    FIBER_PRODUCT_TYPE["ASYMMETRIC"] = "ASYMMETRIC";
    FIBER_PRODUCT_TYPE["SYMMETRIC"] = "SYMMETRIC";
})(FIBER_PRODUCT_TYPE || (FIBER_PRODUCT_TYPE = {}));
var PRODUCT_TYPE;
(function (PRODUCT_TYPE) {
    PRODUCT_TYPE["NONE"] = "NONE";
    PRODUCT_TYPE["ATM"] = "ATM";
    PRODUCT_TYPE["ETH"] = "ETH";
    PRODUCT_TYPE["FTTH"] = "FTTH";
    PRODUCT_TYPE["FTTCAB"] = "FTTCAB";
    PRODUCT_TYPE["DEDICATED_FIBER"] = "DEDICATED_FIBER";
})(PRODUCT_TYPE || (PRODUCT_TYPE = {}));

function CoverageResultComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.TRANSLATIONS[ctx_r2._language]["title"]["ftth"], " ");
} }
function CoverageResultComponent_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.TRANSLATIONS[ctx_r3._language]["title"]["fttc"], " ");
} }
function CoverageResultComponent_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.TRANSLATIONS[ctx_r4._language]["title"]["empty"], " ");
} }
function CoverageResultComponent_div_0_span_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "N.A.");
    i0.ɵɵelementEnd();
} }
const _c0$2 = function (a1, a2, a3) { return { "speed__value--number": true, "vox-text-royal-blue": a1, "vox-text-purple": a2, "vox-text-bright-crimson": a3 }; };
function CoverageResultComponent_div_0_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Mbit/s");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$2, ctx_r6._data.fiber_product_type === ctx_r6.FIBER_PRODUCT_TYPE.ASYMMETRIC, ctx_r6._data.fiber_product_type === ctx_r6.FIBER_PRODUCT_TYPE.SYMMETRIC, ctx_r6._data.fiber_product_type === ctx_r6.FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6._data.download_speed_value);
} }
function CoverageResultComponent_div_0_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "N.A.");
    i0.ɵɵelementEnd();
} }
function CoverageResultComponent_div_0_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Mbit/s");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$2, ctx_r8._data.fiber_product_type === ctx_r8.FIBER_PRODUCT_TYPE.ASYMMETRIC, ctx_r8._data.fiber_product_type === ctx_r8.FIBER_PRODUCT_TYPE.SYMMETRIC, ctx_r8._data.fiber_product_type === ctx_r8.FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8._data.upload_speed_value);
} }
const _c1$1 = function (a1, a2, a3) { return { "text-uppercase": true, "vox-text-royal-blue": a1, "vox-text-purple": a2, "vox-text-bright-crimson": a3 }; };
const _c2$1 = function (a1, a2, a3) { return { "estimations__title": true, "vox-text-royal-blue": a1, "vox-text-purple": a2, "vox-text-bright-crimson": a3 }; };
function CoverageResultComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CoverageResultComponent_div_0_span_5_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(6, CoverageResultComponent_div_0_span_6_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(7, CoverageResultComponent_div_0_span_7_Template, 2, 1, "span", 5);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵelement(11, "ngx-gauge", 7);
    i0.ɵɵelementStart(12, "div", 8);
    i0.ɵɵelementStart(13, "div", 9);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵelementStart(16, "div", 11);
    i0.ɵɵelement(17, "i", 12);
    i0.ɵɵelementStart(18, "div", 13);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 14);
    i0.ɵɵtemplate(21, CoverageResultComponent_div_0_span_21_Template, 2, 0, "span", 5);
    i0.ɵɵtemplate(22, CoverageResultComponent_div_0_span_22_Template, 5, 6, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 11);
    i0.ɵɵelement(24, "i", 15);
    i0.ɵɵelementStart(25, "div", 13);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 14);
    i0.ɵɵtemplate(28, CoverageResultComponent_div_0_span_28_Template, 2, 0, "span", 5);
    i0.ɵɵtemplate(29, CoverageResultComponent_div_0_span_29_Template, 5, 6, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(24, _c1$1, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.ASYMMETRIC, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.SYMMETRIC, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST))("title", ctx_r0._data.fiber_product_type);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getProductTypeToken(), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._data.product_type === ctx_r0.PRODUCT_TYPE.FTTH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._data.product_type === ctx_r0.PRODUCT_TYPE.FTTCAB);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._data.product_type !== ctx_r0.PRODUCT_TYPE.FTTH && ctx_r0._data.product_type !== ctx_r0.PRODUCT_TYPE.FTTCAB);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._data.max_speed_value, " Mbit/s");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r0.gaugeType)("value", ctx_r0.gaugeValue)("min", ctx_r0.gaugeMinValue)("max", ctx_r0.gaugeMaxValue)("label", ctx_r0.gaugeLabel)("cap", ctx_r0.gaugeCap)("thick", ctx_r0.gaugeThick)("foregroundColor", ctx_r0.gaugeColor)("size", ctx_r0.gaugeSize);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(28, _c2$1, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.ASYMMETRIC, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.SYMMETRIC, ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._data.fiber_product_type === ctx_r0.FIBER_PRODUCT_TYPE.SYMMETRIC ? ctx_r0.TRANSLATIONS[ctx_r0._language]["estimations"]["title_symm"] : ctx_r0.TRANSLATIONS[ctx_r0._language]["estimations"]["title_asymm"], " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.TRANSLATIONS[ctx_r0._language]["estimations"]["download"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0._data.download_speed_value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._data.download_speed_value);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.TRANSLATIONS[ctx_r0._language]["estimations"]["upload"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0._data.upload_speed_value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._data.upload_speed_value);
} }
const _c3$1 = function () { return { "width": "80%", "height": "30px", "margin-bottom": "6px" }; };
const _c4 = function (a0, a1) { return { "width": a0, "height": a1, "margin-bottom": "0px", "margin-top": "4px" }; };
const _c5 = function () { return { "display": "block", "width": "70%", "height": "21px", "margin": "2px auto" }; };
const _c6 = function () { return { "display": "block", "width": "25px", "height": "25px", "margin": "4px auto" }; };
const _c7 = function () { return { "display": "block", "width": "85px", "height": "16px", "margin": "4px auto" }; };
const _c8 = function () { return { "display": "block", "width": "65px", "height": "16px", "margin": "4px auto" }; };
function CoverageResultComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 16);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "ngx-skeleton-loader", 17);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "ngx-skeleton-loader", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelement(9, "ngx-skeleton-loader", 19);
    i0.ɵɵelement(10, "ngx-skeleton-loader", 18);
    i0.ɵɵelement(11, "ngx-skeleton-loader", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelement(13, "ngx-skeleton-loader", 19);
    i0.ɵɵelement(14, "ngx-skeleton-loader", 18);
    i0.ɵɵelement(15, "ngx-skeleton-loader", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(9, _c3$1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction2(10, _c4, ctx_r1.gaugeSize + "px", ctx_r1.gaugeSize + "px"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(13, _c5));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(14, _c6));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(15, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(16, _c8));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(17, _c6));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(18, _c7));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(19, _c8));
} }
const BRIGHT_CRIMSON = "#ff3465";
const ROYAL_BLUE = "#0066ff";
const PURPLE = '#6515dd';
class CoverageResultComponent {
    constructor() {
        this.FIBER_PRODUCT_TYPE = FIBER_PRODUCT_TYPE;
        this.PRODUCT_TYPE = PRODUCT_TYPE;
        this.TRANSLATIONS = translation;
        this._language = 'it';
        this.languagesLoaded = [];
        // Gauge config
        this.gaugeType = "arch";
        this.gaugeLabel = "Mbit/s";
        this.gaugeCap = "round";
        this.gaugeSize = 150;
        this.gaugeThick = 9;
        this.gaugeMinValue = 0;
        this.gaugeColor = BRIGHT_CRIMSON;
    }
    set data(v) {
        this._data = v;
        this.setCurrentValueSpeed(v);
        this.setGaugeColor(v);
    }
    set loading(v) {
        this._loading = v;
    }
    set language(v) {
        if (v) {
            this._language = v;
            if (!this.languagesLoaded.includes(this._language)) {
                registerLocale(require(`i18n-iso-countries/langs/${this._language}.json`));
                this.languagesLoaded.push(this._language);
            }
        }
    }
    onResize(event) {
        if (event.target.innerWidth <= 482) {
            this.gaugeSize = 120;
        }
        else {
            this.gaugeSize = 150;
        }
    }
    ngOnInit() {
        let innerWidth = window.innerWidth;
        if (innerWidth <= 482) {
            this.gaugeSize = 120;
        }
        else {
            this.gaugeSize = 150;
        }
        this.gaugeMaxValue = this._data.max_speed_value;
        this.setCurrentValueSpeed(this._data);
    }
    setGaugeColor(data) {
        switch (data.fiber_product_type) {
            case FIBER_PRODUCT_TYPE.ASYMMETRIC:
                this.gaugeColor = ROYAL_BLUE;
                break;
            case FIBER_PRODUCT_TYPE.SYMMETRIC:
                this.gaugeColor = PURPLE;
                break;
            case FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST:
                this.gaugeColor = BRIGHT_CRIMSON;
                break;
            default:
                this.gaugeColor = ROYAL_BLUE;
                break;
        }
        this.gaugeSize = this.gaugeSize;
    }
    setCurrentValueSpeed(data) {
        if (data.download_speed_value && data.upload_speed_value) {
            this.gaugeValue = Math.max(data.download_speed_value, data.upload_speed_value);
        }
        else if (!data.download_speed_value && data.upload_speed_value) {
            this.gaugeValue = data.upload_speed_value;
        }
        else if (data.download_speed_value && !data.upload_speed_value) {
            this.gaugeValue = data.download_speed_value;
        }
        else {
            this.gaugeValue = data.max_speed_value;
        }
    }
    getProductTypeToken() {
        let token;
        switch (this._data.fiber_product_type) {
            case FIBER_PRODUCT_TYPE.ASYMMETRIC:
                token = this.TRANSLATIONS[this._language]['asymm'];
                break;
            case FIBER_PRODUCT_TYPE.SYMMETRIC:
                token = this.TRANSLATIONS[this._language]['symm'];
                break;
            case FIBER_PRODUCT_TYPE.ASYMMETRIC_BEST:
                token = this.TRANSLATIONS[this._language]['asymm_best'];
                break;
            default:
                token = this.TRANSLATIONS[this._language]['asymm'];
                break;
        }
        return token;
    }
}
CoverageResultComponent.ɵfac = function CoverageResultComponent_Factory(t) { return new (t || CoverageResultComponent)(); };
CoverageResultComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoverageResultComponent, selectors: [["vox-coverage-result"]], hostBindings: function CoverageResultComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function CoverageResultComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { data: "data", loading: "loading", language: "language" }, decls: 2, vars: 2, consts: [["class", "coverage-result", 4, "ngIf"], [1, "coverage-result"], [1, "coverage-result__title"], [1, "vox-heading-4"], [3, "ngClass", "title"], [4, "ngIf"], [1, "coverage-result__container"], [1, "coverage-result__container_chart", 3, "type", "value", "min", "max", "label", "cap", "thick", "foregroundColor", "size"], [1, "coverage-result__container_estimations"], [3, "ngClass"], [1, "estimations__container"], [1, "estimations__container--speed"], [1, "icon-small-back", "speed__icon", "speed__icon--download"], [1, "vox-paragraph", "speed__title"], [1, "vox-paragraph", "speed__value"], [1, "icon-small-back", "speed__icon", "speed__icon--upload"], [1, "coverage-result__title", 3, "theme"], ["appearance", "circle", 1, "coverage-result__container_chart", 3, "theme"], [3, "theme"], ["appearance", "circle", 3, "theme"]], template: function CoverageResultComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CoverageResultComponent_div_0_Template, 30, 32, "div", 0);
        i0.ɵɵtemplate(1, CoverageResultComponent_div_1_Template, 16, 20, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx._loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx._loading);
    } }, directives: [i1.NgIf, i1.NgClass, i2$2.NgxGauge, i2$1.NgxSkeletonLoaderComponent], styles: ["body{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}::-webkit-scrollbar{width:.5em;height:.5em}::-webkit-scrollbar-thumb{background-color:#868990}::-webkit-scrollbar-track{background-color:#b5bac2}::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.coverage-result{width:100%}.coverage-result__title{width:100%;display:flex;align-items:center;justify-content:flex-start;margin-bottom:5px}.coverage-result__title .vox-chip{margin-right:7px}.coverage-result__title .vox-heading-4{font-size:20px}.coverage-result__container{width:100%;display:flex;align-items:center;justify-content:space-between}.coverage-result__container_chart{margin-right:5px}.coverage-result__container_chart .reading-label{height:100%}.coverage-result__container_estimations{width:100%}.coverage-result__container_estimations .estimations__title{text-align:center;border-bottom:1px solid #b5bac2;font-weight:bold}.coverage-result__container_estimations .estimations__container{display:flex;align-items:flex-start;justify-content:space-around;padding-top:10px}.coverage-result__container_estimations .estimations__container--speed{display:flex;flex-direction:column;align-items:center}.coverage-result__container_estimations .estimations__container--speed:first-child{margin-right:5px}.coverage-result__container_estimations .estimations__container--speed .speed__icon{width:22px;height:22px;font-size:20px;border-radius:50px;color:#fff;background-color:#868990;display:flex;align-items:center;justify-content:center}.coverage-result__container_estimations .estimations__container--speed .speed__icon:before{margin-top:1px}.coverage-result__container_estimations .estimations__container--speed .speed__icon--download{transform:rotate(270deg)}.coverage-result__container_estimations .estimations__container--speed .speed__icon--upload{transform:rotate(90deg)}.coverage-result__container_estimations .estimations__container--speed .speed__title{display:none}.coverage-result__container_estimations .estimations__container--speed .speed__value{margin-top:5px;line-height:18px}.coverage-result__container_estimations .estimations__container--speed .speed__value span{display:flex;flex-direction:column;align-items:center}.coverage-result__container_estimations .estimations__container--speed .speed__value--number{font-size:25px;font-weight:700;margin-right:0}@media screen and (min-width: 480px){.coverage-result__title .vox-heading-4{font-size:24px}.coverage-result__container_chart{margin-right:25px}.coverage-result__container_estimations .estimations__container .speed__title{display:inline-block;text-align:center;margin-top:5px}.coverage-result__container_estimations .estimations__container .speed__value{flex-direction:row;margin-top:0;line-height:24px}.coverage-result__container_estimations .estimations__container .speed__value span{flex-direction:row}.coverage-result__container_estimations .estimations__container .speed__value--number{margin-right:5px}}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoverageResultComponent, [{
        type: Component,
        args: [{
                selector: 'vox-coverage-result',
                templateUrl: './coverage-result.component.html',
                styleUrls: ['./coverage-result.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], loading: [{
            type: Input
        }], language: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class VoxCoverageResultModule {
}
VoxCoverageResultModule.ɵfac = function VoxCoverageResultModule_Factory(t) { return new (t || VoxCoverageResultModule)(); };
VoxCoverageResultModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxCoverageResultModule });
VoxCoverageResultModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgxGaugeModule,
            NgxSkeletonLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxCoverageResultModule, [{
        type: NgModule,
        args: [{
                declarations: [CoverageResultComponent],
                imports: [
                    CommonModule,
                    NgxGaugeModule,
                    NgxSkeletonLoaderModule
                ],
                exports: [CoverageResultComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxCoverageResultModule, { declarations: [CoverageResultComponent], imports: [CommonModule,
        NgxGaugeModule,
        NgxSkeletonLoaderModule], exports: [CoverageResultComponent] }); })();

const TRANSLATIONS = {
    it: {
        "table": {
            "header": {
                "document-type": "Documento",
                "document-url": "Link"
            },
            "body": {
                "document-types": {
                    "identity": "Documento d'identità",
                    "portability_template_signed": "Modulo firmato",
                    "last_invoice": "Ultima bolletta"
                }
            }
        },
        "errors": {
            "generic": "Non ci sono informazioni sui documenti da mostrare. Riprova o contatta il supporto"
        }
    },
    en: {
        "table": {
            "header": {
                "document-type": "Document",
                "document-url": "Link"
            },
            "body": {
                "document-types": {
                    "identity": "Identity document",
                    "portability_template_signed": "Signed portability module",
                    "last_invoice": "Last invoice"
                }
            }
        },
        "errors": {
            "generic": "Sorry, there is no document information to be shown. Please try again or contact support."
        }
    }
};

function PortabilityTableReadonlyComponent_div_0_table_1_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "a", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const document_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.translations[ctx_r4._language]["table"]["body"]["document-types"][i0.ɵɵpipeBind1(3, 3, document_r5.documentType)], " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", document_r5.documentUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.getDocName(document_r5));
} }
function PortabilityTableReadonlyComponent_div_0_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵelementStart(1, "thead");
    i0.ɵɵelementStart(2, "tr");
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "tbody");
    i0.ɵɵtemplate(8, PortabilityTableReadonlyComponent_div_0_table_1_tr_8_Template, 7, 5, "tr", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["table"]["header"]["document-type"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.translations[ctx_r2._language]["table"]["header"]["document-url"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.data.documents);
} }
function PortabilityTableReadonlyComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.translations[ctx_r3._language]["errors"]["generic"]);
} }
function PortabilityTableReadonlyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PortabilityTableReadonlyComponent_div_0_table_1_Template, 9, 3, "table", 2);
    i0.ɵɵtemplate(2, PortabilityTableReadonlyComponent_div_0_div_2_Template, 5, 1, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isEmpty);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isEmpty);
} }
const _c0$1 = function () { return { "height": "226px", "margin-bottom": "0px" }; };
function PortabilityTableReadonlyComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c0$1));
} }
class PortabilityTableReadonlyComponent {
    constructor() {
        this.didNumber = '+39800126317';
        this.translations = TRANSLATIONS;
        this._language = 'en';
    }
    set language(v) {
        if (v && v !== this._language) {
            this._language = v.toLowerCase();
        }
    }
    ;
    getDocName(document) {
        const url = document.documentUrl;
        const index = url.lastIndexOf('/');
        return url.substring(index + 1);
    }
    get isEmpty() {
        return !this.data;
    }
}
PortabilityTableReadonlyComponent.ɵfac = function PortabilityTableReadonlyComponent_Factory(t) { return new (t || PortabilityTableReadonlyComponent)(); };
PortabilityTableReadonlyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PortabilityTableReadonlyComponent, selectors: [["vox-portability-table-readonly"]], inputs: { loading: "loading", data: "data", language: "language" }, decls: 2, vars: 2, consts: [["class", "portability-data-table", 4, "ngIf"], [1, "portability-data-table"], [4, "ngIf"], ["class", "vox-inline-message vox-inline-message_light-grey", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["target", "_blank", "download", "", 3, "href"], [1, "vox-inline-message", "vox-inline-message_light-grey"], [1, "icon-small-info"], [3, "theme"]], template: function PortabilityTableReadonlyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PortabilityTableReadonlyComponent_div_0_Template, 3, 2, "div", 0);
        i0.ɵɵtemplate(1, PortabilityTableReadonlyComponent_div_1_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [i1.NgIf, i1.NgForOf, i2$1.NgxSkeletonLoaderComponent], pipes: [i1.LowerCasePipe], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}*[_ngcontent-%COMP%]{font-family:\"GT-Eesti-Pro\",\"Arial\",\"Helvetica\",sans-serif}.portability-data-table[_ngcontent-%COMP%]{overflow-x:auto}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%;border:2px solid #e5e9f0}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{border-bottom:2px solid #e5e9f0}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{min-width:200px;height:56px;font-size:16px;font-weight:bold;color:#000;line-height:1;vertical-align:middle;white-space:nowrap;padding:10px 15px;text-align:start}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:not(:last-child){border-right:2px solid #e5e9f0}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:#fff}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(:last-child){border-bottom:2px solid #e5e9f0}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{min-width:200px;height:56px;font-size:16px;font-weight:300;color:#000;line-height:1;text-align:left;vertical-align:middle;white-space:nowrap;padding:10px 15px}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:100%;color:#06f}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:last-child){border-right:2px solid #e5e9f0}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-of-type(1){font-weight:700}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-last-of-type(1){min-width:300px}.portability-data-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]{padding-left:15px;margin:0}.portability-data-table[_ngcontent-%COMP%]   .vox-inline-message.vox-inline-message_light-grey[_ngcontent-%COMP%]{margin-bottom:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PortabilityTableReadonlyComponent, [{
        type: Component,
        args: [{
                selector: "vox-portability-table-readonly",
                templateUrl: "./portability-table-readonly.component.html",
                styleUrls: ["./portability-table-readonly.component.scss"]
            }]
    }], null, { loading: [{
            type: Input
        }], data: [{
            type: Input
        }], language: [{
            type: Input
        }] }); })();

class VoxPortabilityTableReadonlyModule {
}
VoxPortabilityTableReadonlyModule.ɵfac = function VoxPortabilityTableReadonlyModule_Factory(t) { return new (t || VoxPortabilityTableReadonlyModule)(); };
VoxPortabilityTableReadonlyModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxPortabilityTableReadonlyModule });
VoxPortabilityTableReadonlyModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, NgxSkeletonLoaderModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxPortabilityTableReadonlyModule, [{
        type: NgModule,
        args: [{
                declarations: [PortabilityTableReadonlyComponent],
                imports: [CommonModule, NgxSkeletonLoaderModule],
                exports: [PortabilityTableReadonlyComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxPortabilityTableReadonlyModule, { declarations: [PortabilityTableReadonlyComponent], imports: [CommonModule, NgxSkeletonLoaderModule], exports: [PortabilityTableReadonlyComponent] }); })();

// Standart events:
// * abort	        Fires when the loading of an audio/video is aborted
// * canplay	      Fires when the browser can start playing the audio/video
// * canplaythrough	Fires when the browser can play through the audio/video without stopping for buffering
// * durationchange	Fires when the duration of the audio/video is changed
// * emptied	      Fires when the current playlist is empty
// * ended	        Fires when the current playlist is ended
// * error	        Fires when an error occurred during the loading of an audio/video
// * loadeddata	    Fires when the browser has loaded the current frame of the audio/video
// * loadedmetadata	Fires when the browser has loaded meta data for the audio/video
// * loadstart	    Fires when the browser starts looking for the audio/video
// * pause	        Fires when the audio/video has been paused
// * play	          Fires when the audio/video has been started or is no longer paused
// * playing	      Fires when the audio/video is playing after having been paused or stopped for buffering
// * progress	      Fires when the browser is downloading the audio/video
// * ratechange	    Fires when the playing speed of the audio/video is changed
// * seeked	        Fires when the user is finished moving/skipping to a new position in the audio/video
// * seeking	      Fires when the user starts moving/skipping to a new position in the audio/video
// * stalled	      Fires when the browser is trying to get media data, but data is not available
// * suspend	      Fires when the browser is intentionally not getting media data
// * timeupdate	    Fires when the current playback position has changed
// * volumechange	  Fires when the volume has been changed
// * waiting	      Fires when the video stops because it needs to buffer the next frame
// Supported events:
var AUDIO_EVENT_TYPE;
(function (AUDIO_EVENT_TYPE) {
    AUDIO_EVENT_TYPE["PLAY"] = "PLAY";
    AUDIO_EVENT_TYPE["PLAYING"] = "PLAYING";
    AUDIO_EVENT_TYPE["PAUSE"] = "PAUSE";
    AUDIO_EVENT_TYPE["ENDED"] = "ENDED";
    AUDIO_EVENT_TYPE["PROGRESS"] = "PROGRESS";
    AUDIO_EVENT_TYPE["TIME_UPDATE"] = "TIME_UPDATE";
    AUDIO_EVENT_TYPE["LOAD_START"] = "LOAD_START";
    AUDIO_EVENT_TYPE["LOAD_END"] = "LOAD_END";
    AUDIO_EVENT_TYPE["ERROR"] = "ERROR";
})(AUDIO_EVENT_TYPE || (AUDIO_EVENT_TYPE = {}));

class TimePipe {
    transform(value, format) {
        let days;
        let seconds;
        let minutes;
        let hours;
        if (format === 'hhmmss' || format === 'mmss') {
            seconds = Math.floor((value % 60));
            minutes = Math.floor(((value / 60) % 60));
            hours = Math.floor(((value / 60) / 60));
            return this.format(format, seconds, minutes, hours, days);
        }
        else if ((format === 'ddhhmmss' || format === 'ddhhmmssLong')) {
            seconds = Math.floor(value % 60);
            minutes = Math.floor(((value / 60) % 60));
            hours = Math.floor(((value / 60) / 60) % 24);
            days = Math.floor((((value / 60) / 60) / 24));
            return this.format(format, seconds, minutes, hours, days);
        }
        else {
            return value;
        }
    }
    format(format, seconds, minutes, hours, days) {
        (days < 10) ? days = '0' + days : days;
        (hours < 10) ? hours = '0' + hours : hours;
        (minutes < 10) ? minutes = '0' + minutes : minutes;
        (seconds < 10) ? seconds = '0' + seconds : seconds;
        switch (format) {
            case 'mmss':
                return `${minutes}:${seconds}`;
            case 'hhmmss':
                return `${hours}:${minutes}:${seconds}`;
            case 'ddhhmmss':
                return `${days}d, ${hours}h, ${minutes}m, ${seconds}s`;
            case 'ddhhmmssLong':
                return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
        }
    }
}
TimePipe.ɵfac = function TimePipe_Factory(t) { return new (t || TimePipe)(); };
TimePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "time", type: TimePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePipe, [{
        type: Pipe,
        args: [{
                name: 'time'
            }]
    }], null, null); })();

function AudioPlayerComponent_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function AudioPlayerComponent_div_0_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.stop(); });
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2._loading || ctx_r2.disabled || ctx_r2.error);
} }
function AudioPlayerComponent_div_0_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 2);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r3.error ? "icon-small-alert" : "icon-small-play-outline");
} }
function AudioPlayerComponent_div_0_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
} }
function AudioPlayerComponent_div_0_div_5_i_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵlistener("click", function AudioPlayerComponent_div_0_div_5_i_3_Template_i_click_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return ctx_r10.play($event); });
    i0.ɵɵelementEnd();
} }
function AudioPlayerComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function AudioPlayerComponent_div_0_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.seek($event); });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "div", 13);
    i0.ɵɵtemplate(3, AudioPlayerComponent_div_0_div_5_i_3_Template, 1, 0, "i", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("vox-progress progress ", ctx_r5.error || ctx_r5.disabled ? "disabled" : "", "");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", ctx_r5.progress, "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.error);
} }
function AudioPlayerComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 17);
    i0.ɵɵelementEnd();
} }
const _c0 = function (a1) { return { "vox-audio-player": true, "vox-audio-player_active": a1 }; };
function AudioPlayerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, AudioPlayerComponent_div_0_button_1_Template, 2, 1, "button", 3);
    i0.ɵɵelementStart(2, "button", 4);
    i0.ɵɵlistener("click", function AudioPlayerComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.play(); });
    i0.ɵɵtemplate(3, AudioPlayerComponent_div_0_i_3_Template, 1, 1, "i", 0);
    i0.ɵɵtemplate(4, AudioPlayerComponent_div_0_i_4_Template, 1, 0, "i", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AudioPlayerComponent_div_0_div_5_Template, 4, 6, "div", 6);
    i0.ɵɵtemplate(6, AudioPlayerComponent_div_0_div_6_Template, 2, 0, "div", 7);
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "time");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, " - ");
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0, !ctx_r0._loading));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.canStop);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0._loading || ctx_r0.disabled || ctx_r0.error);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.playing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.playing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0._loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0._loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", "vox-audio-player__time--" + ctx_r0.timeFormat);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 10, ctx_r0.currentTime, ctx_r0.timeFormat));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(15, 13, ctx_r0.duration, ctx_r0.timeFormat));
} }
const _c1 = function () { return { "width": "28px", "height": "28px", "margin-bottom": 0 }; };
const _c2 = function () { return { "width": "100%", "height": "8px", "margin-bottom": 0 }; };
const _c3 = function () { return { "width": "40px", "height": "21px", "margin-bottom": 0, "margin-left": "3px", "vertical-align": "middle" }; };
function AudioPlayerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 19);
    i0.ɵɵelement(2, "ngx-skeleton-loader", 20);
    i0.ɵɵelement(3, "ngx-skeleton-loader", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("count", ctx_r1.canStop ? 2 : 1)("theme", i0.ɵɵpureFunction0(4, _c1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(6, _c3));
} }
class AudioPlayerComponent {
    constructor() {
        this.disabled = false;
        this.loading = false;
        this.canStop = true;
        this.audioEvent = new EventEmitter();
        this.audioError = new EventEmitter();
        this._loading = false;
        this.playing = false;
        this.currentTime = 0;
        this.duration = 0.01;
        this.progress = 0;
        this.error = false;
        this.onlineSubscription$ = fromEvent(window, 'online')
            .subscribe(e => {
            // resume load after going back online
            if (this.audioElement) {
                this.audioElement.load();
            }
            else {
                this._loading = false;
            }
        });
        this.offlineSubscription$ = fromEvent(window, 'offline')
            .subscribe(e => {
            // pause when offline
            if (this.audioElement && this.playing) {
                this.audioElement.pause();
            }
            this._loading = true;
        });
    }
    ngOnInit() {
        if (this.fileUrl) {
            this.createAudioElement(this.fileUrl);
        }
    }
    ngOnChanges(c) {
        var _a, _b;
        if (!((_a = c.fileUrl) === null || _a === void 0 ? void 0 : _a.firstChange) && ((_b = c.fileUrl) === null || _b === void 0 ? void 0 : _b.currentValue)) {
            this.retryAudioInit();
        }
    }
    ngOnDestroy() {
        if (this.audioElement) {
            this.stop();
            this.unsubscribeFromAudioEvents();
        }
        this.audioElement = null;
        this.onlineSubscription$.unsubscribe();
        this.offlineSubscription$.unsubscribe();
    }
    createAudioElement(fileAudio) {
        this.audioElement = new Audio(fileAudio);
        this.audioElement.addEventListener('play', this.playEvent.bind(this));
        this.audioElement.addEventListener('playing', this.playingEvent.bind(this));
        this.audioElement.addEventListener('pause', this.pauseEvent.bind(this));
        this.audioElement.addEventListener('ended', this.endedEvent.bind(this));
        this.audioElement.addEventListener('progress', this.progressEvent.bind(this));
        this.audioElement.addEventListener('timeupdate', this.timeupdateEvent.bind(this));
        this.audioElement.addEventListener('loadstart', this.loadstartEvent.bind(this));
        this.audioElement.addEventListener('loadeddata', this.loadeddataEvent.bind(this));
        this.audioElement.addEventListener('error', this.loadFailedEvent.bind(this));
    }
    // methods event listener for audio element
    playingEvent(e) {
        this.playing = true;
        this.duration = this.audioElement.duration;
        this.updateProgress();
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.PLAYING,
            playing: true
        });
    }
    playEvent(e) {
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.PLAY,
        });
    }
    pauseEvent(e) {
        this.playing = false;
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.PAUSE
        });
        this.updateProgress();
    }
    timeupdateEvent(e) {
        this.currentTime = this.audioElement.currentTime;
        this.updateProgress();
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.TIME_UPDATE,
            currentTime: this.audioElement.currentTime
        });
    }
    loadstartEvent(e) {
        this._loading = true;
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.LOAD_START
        });
    }
    loadeddataEvent(e) {
        this._loading = false;
        this.duration = this.audioElement.duration;
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.LOAD_END
        });
    }
    endedEvent(e) {
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.ENDED
        });
    }
    progressEvent(e) {
        this.audioEvent.emit({
            eventType: AUDIO_EVENT_TYPE.PROGRESS
        });
    }
    loadFailedEvent(e) {
        this._loading = false;
        this.error = true;
        this.audioError.emit({
            eventType: AUDIO_EVENT_TYPE.ERROR,
            event: e
        });
    }
    unsubscribeFromAudioEvents() {
        this.audioElement.removeEventListener('play', this.playEvent);
        this.audioElement.removeEventListener('playing', this.playingEvent);
        this.audioElement.removeEventListener('pause', this.pauseEvent);
        this.audioElement.removeEventListener('timeupdate', this.timeupdateEvent);
        this.audioElement.removeEventListener('loadstart', this.loadstartEvent);
        this.audioElement.removeEventListener('loadeddata', this.loadeddataEvent);
        this.audioElement.removeEventListener('ended', this.endedEvent);
        this.audioElement.removeEventListener('progress', this.progressEvent);
        this.audioElement.removeEventListener('error', this.loadFailedEvent);
    }
    updateProgress() {
        this.progress = (100 * this.audioElement.currentTime) / this.audioElement.duration;
    }
    seek(event) {
        if (this.audioElement && !this.error && !this.disabled) {
            let newprogress = (event.offsetX - 0.5) / event.currentTarget.clientWidth;
            if (newprogress < 0) {
                newprogress = 0;
            }
            if (newprogress > 1) {
                newprogress = 1;
            }
            this.audioElement.currentTime = this.audioElement.duration * newprogress;
            event.stopPropagation();
        }
    }
    retryAudioInit() {
        this.error = false;
        if (this.audioElement) {
            this.audioElement.src = null;
            this.audioElement.src = this.fileUrl;
        }
        else {
            this.createAudioElement(this.fileUrl);
        }
    }
    play(e) {
        if (this.error) {
            this.retryAudioInit();
            e.stopPropagation();
        }
        if (this.playing) {
            this.audioElement.pause();
        }
        else {
            this.audioElement.play();
        }
    }
    stop() {
        this.audioElement.pause();
        this.audioElement.currentTime = 0;
    }
    get timeFormat() {
        if (!this.duration)
            return 'mmss';
        return this.duration >= 3600 ? 'hhmmss' : 'mmss';
    }
}
AudioPlayerComponent.ɵfac = function AudioPlayerComponent_Factory(t) { return new (t || AudioPlayerComponent)(); };
AudioPlayerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AudioPlayerComponent, selectors: [["vox-audio-player"]], inputs: { fileUrl: "fileUrl", disabled: "disabled", loading: "loading", canStop: "canStop" }, outputs: { audioEvent: "audioEvent", audioError: "audioError" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "ngClass", 4, "ngIf"], ["class", "vox-audio-player vox-audio-player_active", 4, "ngIf"], [3, "ngClass"], ["class", "vox-btn vox-audio-player__play", 3, "disabled", "click", 4, "ngIf"], [1, "vox-btn", "vox-audio-player__play", 3, "disabled", "click"], ["class", "icon-small-pause", 4, "ngIf"], ["class", "vox-audio-player__progress", 3, "click", 4, "ngIf"], ["class", "vox-audio-player__progress", 4, "ngIf"], [1, "vox-audio-player__time", 3, "ngClass"], [1, "time-container"], [1, "icon-small-stop"], [1, "icon-small-pause"], [1, "vox-audio-player__progress", 3, "click"], ["role", "progressbar", 1, "vox-progress__bar", "vox-progress__bar_royal-blue", "progress-bar"], ["class", "icon-small-update", 3, "click", 4, "ngIf"], [1, "icon-small-update", 3, "click"], [1, "vox-audio-player__progress"], [1, "vox-progress", "progress"], [1, "vox-audio-player", "vox-audio-player_active"], ["appearance", "circle", 1, "vox-btn", "vox-audio-player__play", 3, "count", "theme"], [1, "vox-audio-player__progress", 3, "theme"], ["count", "2", 1, "vox-audio-player__time", 3, "theme"]], template: function AudioPlayerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AudioPlayerComponent_div_0_Template, 16, 18, "div", 0);
        i0.ɵɵtemplate(1, AudioPlayerComponent_div_1_Template, 4, 7, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [i1.NgIf, i1.NgClass, i2$1.NgxSkeletonLoaderComponent], pipes: [TimePipe], styles: ["body[_ngcontent-%COMP%]{scrollbar-face-color:#868990;scrollbar-track-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-scrollbar{width:.5em;height:.5em}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background-color:#868990}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:#b5bac2}[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#b5bac2;opacity:1;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-ms-input-placeholder{color:#b5bac2;opacity:1;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]::-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:-moz-placeholder{color:#b5bac2;opacity:1;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in}[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:0;-webkit-transition-property:opacity;transition-property:opacity;transition-duration:.5s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus::-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-moz-placeholder{opacity:0;-moz-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}[_ngcontent-%COMP%]:focus:-ms-input-placeholder{opacity:0;-ms-transition-property:opacity;transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-out}.vox-audio-player[_ngcontent-%COMP%]{display:flex;align-items:center}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__play[_ngcontent-%COMP%]{background-color:transparent;padding:0}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__play[_ngcontent-%COMP%]:disabled   i[_ngcontent-%COMP%]{color:#868990}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__play[_ngcontent-%COMP%]:not(:last-child){margin-right:5px}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__play[_ngcontent-%COMP%]:last-child{margin-right:10px}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]{margin-right:7px}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress[_ngcontent-%COMP%]{height:8px;margin:auto;position:relative}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress.disabled[_ngcontent-%COMP%]:hover{cursor:not-allowed}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress[_ngcontent-%COMP%]:hover{cursor:pointer}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress[_ngcontent-%COMP%]   .icon-small-update[_ngcontent-%COMP%]{background-color:#ff3465;border-radius:50px;position:absolute;font-size:30px;left:calc(50% - .5*30px);top:-11px;color:#fff;transition:transform .2s ease-in}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress[_ngcontent-%COMP%]   .icon-small-update[_ngcontent-%COMP%]:hover{cursor:pointer;transform:rotate(180deg)}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__progress[_ngcontent-%COMP%]   .vox-progress[_ngcontent-%COMP%]   .vox-progress__bar[_ngcontent-%COMP%]:after{display:none}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time[_ngcontent-%COMP%]{display:none}@media only screen and (min-width: 480px){.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time[_ngcontent-%COMP%]{display:block}}@media only screen and (min-width: 480px){.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time--mmss[_ngcontent-%COMP%]{min-width:100px}}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time--mmss[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{min-width:40px}@media only screen and (min-width: 480px){.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time--hhmmss[_ngcontent-%COMP%]{min-width:125px}}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time--hhmmss[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{min-width:5px}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time[_ngcontent-%COMP%]   .time-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.vox-audio-player[_ngcontent-%COMP%]   .vox-audio-player__time[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:30px;width:67px;border:none;background-color:transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AudioPlayerComponent, [{
        type: Component,
        args: [{
                selector: 'vox-audio-player',
                templateUrl: './audio-player.component.html',
                styleUrls: ['./audio-player.component.scss']
            }]
    }], function () { return []; }, { fileUrl: [{
            type: Input
        }], disabled: [{
            type: Input
        }], loading: [{
            type: Input
        }], canStop: [{
            type: Input
        }], audioEvent: [{
            type: Output
        }], audioError: [{
            type: Output
        }] }); })();

class VoxAudioPlayerModule {
}
VoxAudioPlayerModule.ɵfac = function VoxAudioPlayerModule_Factory(t) { return new (t || VoxAudioPlayerModule)(); };
VoxAudioPlayerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VoxAudioPlayerModule });
VoxAudioPlayerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgxSkeletonLoaderModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoxAudioPlayerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AudioPlayerComponent,
                    TimePipe
                ],
                imports: [
                    CommonModule,
                    NgxSkeletonLoaderModule
                ],
                exports: [
                    AudioPlayerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VoxAudioPlayerModule, { declarations: [AudioPlayerComponent,
        TimePipe], imports: [CommonModule,
        NgxSkeletonLoaderModule], exports: [AudioPlayerComponent] }); })();

class NgVoxloudModule {
    static forRoot(env) {
        return {
            ngModule: NgVoxloudModule,
            providers: [
                {
                    provide: Environment,
                    useValue: env
                }
            ]
        };
    }
}
NgVoxloudModule.ɵfac = function NgVoxloudModule_Factory(t) { return new (t || NgVoxloudModule)(); };
NgVoxloudModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NgVoxloudModule });
NgVoxloudModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            VoxAddressSearchModule,
            VoxLanguagePickerModule,
            VoxPhoneTextFieldModule,
            VoxSmsCodeInputModule,
            VoxToggleModule,
            VoxPasswordComponentModule,
            VoxVatFieldModule,
            VoxTimezoneInputModule,
            VoxSelectPrefixModule,
            VoxVDTableReadonlyModule,
            VoxVerificationDataFormModule,
            VoxCountrySelectorModule,
            VoxLinksSummaryModule,
            VoxDropdownMultiselectModule,
            VoxCoverageResultModule,
            VoxPortabilityTableReadonlyModule,
            VoxAudioPlayerModule
        ], VoxAddressSearchModule,
        VoxLanguagePickerModule,
        VoxPhoneTextFieldModule,
        VoxSmsCodeInputModule,
        VoxToggleModule,
        VoxPasswordComponentModule,
        VoxVatFieldModule,
        VoxTimezoneInputModule,
        VoxSelectPrefixModule,
        VoxVDTableReadonlyModule,
        VoxVerificationDataFormModule,
        VoxCountrySelectorModule,
        VoxLinksSummaryModule,
        VoxDropdownMultiselectModule,
        VoxCoverageResultModule,
        VoxPortabilityTableReadonlyModule,
        VoxAudioPlayerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgVoxloudModule, [{
        type: NgModule,
        args: [{
                declarations: [NgVoxloudComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    VoxAddressSearchModule,
                    VoxLanguagePickerModule,
                    VoxPhoneTextFieldModule,
                    VoxSmsCodeInputModule,
                    VoxToggleModule,
                    VoxPasswordComponentModule,
                    VoxVatFieldModule,
                    VoxTimezoneInputModule,
                    VoxSelectPrefixModule,
                    VoxVDTableReadonlyModule,
                    VoxVerificationDataFormModule,
                    VoxCountrySelectorModule,
                    VoxLinksSummaryModule,
                    VoxDropdownMultiselectModule,
                    VoxCoverageResultModule,
                    VoxPortabilityTableReadonlyModule,
                    VoxAudioPlayerModule
                ],
                exports: [
                    NgVoxloudComponent,
                    VoxAddressSearchModule,
                    VoxLanguagePickerModule,
                    VoxPhoneTextFieldModule,
                    VoxSmsCodeInputModule,
                    VoxToggleModule,
                    VoxPasswordComponentModule,
                    VoxVatFieldModule,
                    VoxTimezoneInputModule,
                    VoxSelectPrefixModule,
                    VoxVDTableReadonlyModule,
                    VoxVerificationDataFormModule,
                    VoxCountrySelectorModule,
                    VoxLinksSummaryModule,
                    VoxDropdownMultiselectModule,
                    VoxCoverageResultModule,
                    VoxPortabilityTableReadonlyModule,
                    VoxAudioPlayerModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NgVoxloudModule, { declarations: [NgVoxloudComponent], imports: [CommonModule,
        FormsModule,
        VoxAddressSearchModule,
        VoxLanguagePickerModule,
        VoxPhoneTextFieldModule,
        VoxSmsCodeInputModule,
        VoxToggleModule,
        VoxPasswordComponentModule,
        VoxVatFieldModule,
        VoxTimezoneInputModule,
        VoxSelectPrefixModule,
        VoxVDTableReadonlyModule,
        VoxVerificationDataFormModule,
        VoxCountrySelectorModule,
        VoxLinksSummaryModule,
        VoxDropdownMultiselectModule,
        VoxCoverageResultModule,
        VoxPortabilityTableReadonlyModule,
        VoxAudioPlayerModule], exports: [NgVoxloudComponent,
        VoxAddressSearchModule,
        VoxLanguagePickerModule,
        VoxPhoneTextFieldModule,
        VoxSmsCodeInputModule,
        VoxToggleModule,
        VoxPasswordComponentModule,
        VoxVatFieldModule,
        VoxTimezoneInputModule,
        VoxSelectPrefixModule,
        VoxVDTableReadonlyModule,
        VoxVerificationDataFormModule,
        VoxCountrySelectorModule,
        VoxLinksSummaryModule,
        VoxDropdownMultiselectModule,
        VoxCoverageResultModule,
        VoxPortabilityTableReadonlyModule,
        VoxAudioPlayerModule] }); })();

class VerificationData {
}
class Address {
}

var PORTABILITY_STATUS;
(function (PORTABILITY_STATUS) {
    PORTABILITY_STATUS["ONGOING"] = "ONGOING";
    PORTABILITY_STATUS["COMPLETED"] = "COMPLETED";
})(PORTABILITY_STATUS || (PORTABILITY_STATUS = {}));
var DID_CLASS;
(function (DID_CLASS) {
    DID_CLASS["FAX"] = "FAX";
    DID_CLASS["VOICE"] = "VOICE";
})(DID_CLASS || (DID_CLASS = {}));
var DID_TYPE;
(function (DID_TYPE) {
    DID_TYPE["GEOGRAPHIC"] = "GEOGRAPHIC";
    DID_TYPE["TOLL_FREE"] = "TOLL_FREE";
})(DID_TYPE || (DID_TYPE = {}));

/*
 * Public API Surface of ng-voxloud
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACCEPTED_FILE_FORMAT, AUDIO_EVENT_TYPE, Address, AddressSearchComponent, AudioPlayerComponent, CONNECTION_TYPE, CallflowType, CountrySelectorComponent, CoverageResultComponent, DID_CLASS, DID_TYPE, DOCUMENT_TYPES, DropdownMultiselectComponent, EQUIPMENT_MODEL, FIBER_PRODUCT_TYPE, FIELD_TYPES, GeoLocationErrors, LanguagePickerComponent, Layouts, LinksSummaryComponent, LocalizeCountryNamePipe, MAX_FILE_SIZE, NgVoxloudComponent, NgVoxloudModule, NgVoxloudService, PORTABILITY_STATUS, PRODUCT_TYPE, PasswordInputComponent, PermissionState, PhoneTextFieldComponent, PortabilityTableReadonlyComponent, SelectPrefixComponent, SmsCodeInputComponent, TimezoneInputComponent, ToggleComponent, VatFieldComponent, VerificationData, VerificationDataFormComponent, VerificationDataTableReadonlyComponent, VoxAddressSearchModule, VoxAudioPlayerModule, VoxCountrySelectorModule, VoxCoverageResultModule, VoxDropdownMultiselectModule, VoxLanguagePickerModule, VoxLinksSummaryModule, VoxPasswordComponentModule, VoxPhoneTextFieldModule, VoxPortabilityTableReadonlyModule, VoxSelectPrefixModule, VoxSmsCodeInputModule, VoxTimezoneInputModule, VoxToggleModule, VoxVDTableReadonlyModule, VoxVatFieldModule, VoxVerificationDataFormModule, fallbackVats, localTranslations, servedCountries };
